window.currency = (function () {
  var moneyFormat = "${{amount}}";

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

(function (factory) {
  typeof define === "function" && define.amd ? define("index", factory) : factory();
})(function () {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj &&
          typeof Symbol === "function" &&
          obj.constructor === Symbol &&
          obj !== Symbol.prototype
          ? "symbol"
          : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true,
      },
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf =
      Object.setPrototypeOf ||
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true,
        },
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (
        Array.isArray(o) ||
        (it = _unsupportedIterableToArray(o)) ||
        (allowArrayLike && o && typeof o.length === "number")
      ) {
        if (it) o = it;
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length)
              return {
                done: true,
              };
            return {
              done: false,
              value: o[i++],
            };
          },
          e: function (e) {
            throw e;
          },
          f: F,
        };
      }

      throw new TypeError(
        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
      );
    }

    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function () {
        it = o[Symbol.iterator]();
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      },
    };
  }

  var animationQueue = {};

  var Animation = /*#__PURE__*/ (function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }

    _createClass(Animation, null, [
      {
        key: "slideUp",

        /**
         * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
         * force an animation
         */
        value: function slideUp(element, callback) {
          var propertyToAnimate =
            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "height";
          element.style[propertyToAnimate] = "".concat(element.scrollHeight, "px"); // Force previous height to allow CSS transition

          element.offsetHeight; // Force redraw

          element.style[propertyToAnimate] = 0;

          if (animationQueue[element.id]) {
            element.removeEventListener("transitionend", animationQueue[element.id]);
            delete animationQueue[element.id];
          }

          var transitionEnded = function transitionEnded(event) {
            if (event.propertyName === "height") {
              element.removeEventListener("transitionend", transitionEnded);
              (callback || function () {})();
            }
          };

          element.addEventListener("transitionend", transitionEnded);
        },
        /**
         * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
         * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
         */
      },
      {
        key: "slideDown",
        value: function slideDown(element, callback) {
          var propertyToAnimate =
            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "height";
          // To do the animation we temporarily hide it, check the height, and transition to it
          element.style[propertyToAnimate] = "".concat(element.scrollHeight, "px");

          var transitionEnded = function transitionEnded(event) {
            if (event.propertyName === propertyToAnimate) {
              var defaultValue = "auto";

              if (propertyToAnimate === "max-height") {
                defaultValue = "none";
              }

              element.style[propertyToAnimate] = defaultValue; // Allows the content to grow normally

              element.removeEventListener("transitionend", transitionEnded);
              delete animationQueue[element.id];
              (callback || function () {})();
            }
          };

          element.addEventListener("transitionend", transitionEnded);
          animationQueue[element.id] = transitionEnded;
        },
      },
    ]);

    return Animation;
  })();

  /**
   * Various DOM helper
   */
  var Dom = /*#__PURE__*/ (function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }

    _createClass(Dom, null, [
      {
        key: "getSiblings",

        /**
         * Get all the previous and next siblings, optionally filtered by a selector
         */
        value: function getSiblings(element, filter) {
          var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var siblings = [];
          var currentElement = element; // Do the previous first

          while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }

          if (includeSelf) {
            siblings.push(element);
          } // Then the next side

          currentElement = element;

          while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }

          return siblings;
        },
      },
    ]);

    return Dom;
  })();

  var commonjsGlobal =
    typeof globalThis !== "undefined"
      ? globalThis
      : typeof window !== "undefined"
        ? window
        : typeof global !== "undefined"
          ? global
          : typeof self !== "undefined"
            ? self
            : {};

  function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default")
      ? x["default"]
      : x;
  }

  function createCommonjsModule(fn, basedir, module) {
    return (
      (module = {
        path: basedir,
        exports: {},
        require: function (path, base) {
          return commonjsRequire(path, base === undefined || base === null ? module.path : base);
        },
      }),
      fn(module, module.exports),
      module.exports
    );
  }

  function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }

  var browser = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true,
    });
    exports["default"] = void 0;
    /**
     * DOM event delegator
     *
     * The delegator will listen
     * for events that bubble up
     * to the root node.
     *
     * @constructor
     * @param {Node|string} [root] The root node or a selector string matching the root node
     */

    function Delegate(root) {
      /**
       * Maintain a map of listener
       * lists, keyed by event name.
       *
       * @type Object
       */
      this.listenerMap = [{}, {}];

      if (root) {
        this.root(root);
      }
      /** @type function() */

      this.handle = Delegate.prototype.handle.bind(this); // Cache of event listeners removed during an event cycle

      this._removedListeners = [];
    }
    /**
     * Start listening for events
     * on the provided DOM element
     *
     * @param  {Node|string} [root] The root node or a selector string matching the root node
     * @returns {Delegate} This method is chainable
     */

    Delegate.prototype.root = function (root) {
      var listenerMap = this.listenerMap;
      var eventType; // Remove master event listeners

      if (this.rootElement) {
        for (eventType in listenerMap[1]) {
          if (listenerMap[1].hasOwnProperty(eventType)) {
            this.rootElement.removeEventListener(eventType, this.handle, true);
          }
        }

        for (eventType in listenerMap[0]) {
          if (listenerMap[0].hasOwnProperty(eventType)) {
            this.rootElement.removeEventListener(eventType, this.handle, false);
          }
        }
      } // If no root or root is not
      // a dom node, then remove internal
      // root reference and exit here

      if (!root || !root.addEventListener) {
        if (this.rootElement) {
          delete this.rootElement;
        }

        return this;
      }
      /**
       * The root node at which
       * listeners are attached.
       *
       * @type Node
       */

      this.rootElement = root; // Set up master event listeners

      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.addEventListener(eventType, this.handle, true);
        }
      }

      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.addEventListener(eventType, this.handle, false);
        }
      }

      return this;
    };
    /**
     * @param {string} eventType
     * @returns boolean
     */

    Delegate.prototype.captureForType = function (eventType) {
      return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
    };
    /**
     * Attach a handler to one
     * event for all elements
     * that match the selector,
     * now or in the future
     *
     * The handler function receives
     * three arguments: the DOM event
     * object, the node that matched
     * the selector while the event
     * was bubbling and a reference
     * to itself. Within the handler,
     * 'this' is equal to the second
     * argument.
     *
     * The node that actually received
     * the event can be accessed via
     * 'event.target'.
     *
     * @param {string} eventType Listen for these events
     * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
     * @param {function()} handler Handler function - event data passed here will be in event.data
     * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
     * @returns {Delegate} This method is chainable
     */

    Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
      var root;
      var listenerMap;
      var matcher;
      var matcherParam;

      if (!eventType) {
        throw new TypeError("Invalid event type: " + eventType);
      } // handler can be passed as
      // the second or third argument

      if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
      } // Fallback to sensible defaults
      // if useCapture not set

      if (useCapture === undefined) {
        useCapture = this.captureForType(eventType);
      }

      if (typeof handler !== "function") {
        throw new TypeError("Handler must be a type of Function");
      }

      root = this.rootElement;
      listenerMap = this.listenerMap[useCapture ? 1 : 0]; // Add master handler for type if not created yet

      if (!listenerMap[eventType]) {
        if (root) {
          root.addEventListener(eventType, this.handle, useCapture);
        }

        listenerMap[eventType] = [];
      }

      if (!selector) {
        matcherParam = null; // COMPLEX - matchesRoot needs to have access to
        // this.rootElement, so bind the function to this.

        matcher = matchesRoot.bind(this); // Compile a matcher for the given selector
      } else if (/^[a-z]+$/i.test(selector)) {
        matcherParam = selector;
        matcher = matchesTag;
      } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
        matcherParam = selector.slice(1);
        matcher = matchesId;
      } else {
        matcherParam = selector;
        matcher = Element.prototype.matches;
      } // Add to the list of listeners

      listenerMap[eventType].push({
        selector: selector,
        handler: handler,
        matcher: matcher,
        matcherParam: matcherParam,
      });
      return this;
    };
    /**
     * Remove an event handler
     * for elements that match
     * the selector, forever
     *
     * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
     * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
     * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
     * @returns {Delegate} This method is chainable
     */

    Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
      var i;
      var listener;
      var listenerMap;
      var listenerList;
      var singleEventType; // Handler can be passed as
      // the second or third argument

      if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
      } // If useCapture not set, remove
      // all event listeners

      if (useCapture === undefined) {
        this.off(eventType, selector, handler, true);
        this.off(eventType, selector, handler, false);
        return this;
      }

      listenerMap = this.listenerMap[useCapture ? 1 : 0];

      if (!eventType) {
        for (singleEventType in listenerMap) {
          if (listenerMap.hasOwnProperty(singleEventType)) {
            this.off(singleEventType, selector, handler);
          }
        }

        return this;
      }

      listenerList = listenerMap[eventType];

      if (!listenerList || !listenerList.length) {
        return this;
      } // Remove only parameter matches
      // if specified

      for (i = listenerList.length - 1; i >= 0; i--) {
        listener = listenerList[i];

        if (
          (!selector || selector === listener.selector) &&
          (!handler || handler === listener.handler)
        ) {
          this._removedListeners.push(listener);

          listenerList.splice(i, 1);
        }
      } // All listeners removed

      if (!listenerList.length) {
        delete listenerMap[eventType]; // Remove the main handler

        if (this.rootElement) {
          this.rootElement.removeEventListener(eventType, this.handle, useCapture);
        }
      }

      return this;
    };
    /**
     * Handle an arbitrary event.
     *
     * @param {Event} event
     */

    Delegate.prototype.handle = function (event) {
      var i;
      var l;
      var type = event.type;
      var root;
      var phase;
      var listener;
      var returned;
      var listenerList = [];
      var target;
      var eventIgnore = "ftLabsDelegateIgnore";

      if (event[eventIgnore] === true) {
        return;
      }

      target = event.target; // Hardcode value of Node.TEXT_NODE
      // as not defined in IE8

      if (target.nodeType === 3) {
        target = target.parentNode;
      } // Handle SVG <use> elements in IE

      if (target.correspondingUseElement) {
        target = target.correspondingUseElement;
      }

      root = this.rootElement;
      phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2); // eslint-disable-next-line default-case

      switch (phase) {
        case 1:
          //Event.CAPTURING_PHASE:
          listenerList = this.listenerMap[1][type];
          break;

        case 2:
          //Event.AT_TARGET:
          if (this.listenerMap[0] && this.listenerMap[0][type]) {
            listenerList = listenerList.concat(this.listenerMap[0][type]);
          }

          if (this.listenerMap[1] && this.listenerMap[1][type]) {
            listenerList = listenerList.concat(this.listenerMap[1][type]);
          }

          break;

        case 3:
          //Event.BUBBLING_PHASE:
          listenerList = this.listenerMap[0][type];
          break;
      }

      var toFire = []; // Need to continuously check
      // that the specific list is
      // still populated in case one
      // of the callbacks actually
      // causes the list to be destroyed.

      l = listenerList.length;

      while (target && l) {
        for (i = 0; i < l; i++) {
          listener = listenerList[i]; // Bail from this loop if
          // the length changed and
          // no more listeners are
          // defined between i and l.

          if (!listener) {
            break;
          }

          if (
            target.tagName &&
            ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 &&
            target.hasAttribute("disabled")
          ) {
            // Remove things that have previously fired
            toFire = [];
          } // Check for match and fire
          // the event if there's one
          //
          // TODO:MCG:20120117: Need a way
          // to check if event#stopImmediatePropagation
          // was called. If so, break both loops.
          else if (listener.matcher.call(target, listener.matcherParam, target)) {
            toFire.push([event, target, listener]);
          }
        } // TODO:MCG:20120117: Need a way to
        // check if event#stopPropagation
        // was called. If so, break looping
        // through the DOM. Stop if the
        // delegation root has been reached

        if (target === root) {
          break;
        }

        l = listenerList.length; // Fall back to parentNode since SVG children have no parentElement in IE

        target = target.parentElement || target.parentNode; // Do not traverse up to document root when using parentNode, though

        if (target instanceof HTMLDocument) {
          break;
        }
      }

      var ret;

      for (i = 0; i < toFire.length; i++) {
        // Has it been removed during while the event function was fired
        if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
          continue;
        }

        returned = this.fire.apply(this, toFire[i]); // Stop propagation to subsequent
        // callbacks if the callback returned
        // false

        if (returned === false) {
          toFire[i][0][eventIgnore] = true;
          toFire[i][0].preventDefault();
          ret = false;
          break;
        }
      }

      return ret;
    };
    /**
     * Fire a listener on a target.
     *
     * @param {Event} event
     * @param {Node} target
     * @param {Object} listener
     * @returns {boolean}
     */

    Delegate.prototype.fire = function (event, target, listener) {
      return listener.handler.call(target, event, target);
    };
    /**
     * Check whether an element
     * matches a tag selector.
     *
     * Tags are NOT case-sensitive,
     * except in XML (and XML-based
     * languages such as XHTML).
     *
     * @param {string} tagName The tag name to test against
     * @param {Element} element The element to test with
     * @returns boolean
     */

    function matchesTag(tagName, element) {
      return tagName.toLowerCase() === element.tagName.toLowerCase();
    }
    /**
     * Check whether an element
     * matches the root.
     *
     * @param {?String} selector In this case this is always passed through as null and not used
     * @param {Element} element The element to test with
     * @returns boolean
     */

    function matchesRoot(selector, element) {
      if (this.rootElement === window) {
        return (
          // Match the outer document (dispatched from document)
          element === document || // The <html> element (dispatched from document.body or document.documentElement)
          element === document.documentElement || // Or the window itself (dispatched from window)
          element === window
        );
      }

      return this.rootElement === element;
    }
    /**
     * Check whether the ID of
     * the element in 'this'
     * matches the given ID.
     *
     * IDs are case-sensitive.
     *
     * @param {string} id The ID to test against
     * @param {Element} element The element to test with
     * @returns boolean
     */

    function matchesId(id, element) {
      return id === element.id;
    }
    /**
     * Short hand for off()
     * and root(), ie both
     * with no parameters
     *
     * @return void
     */

    Delegate.prototype.destroy = function () {
      this.off();
      this.root();
    };

    var _default = Delegate;
    exports["default"] = _default;
    module.exports = exports["default"];
  });
  var Delegate = /*@__PURE__*/ getDefaultExportFromCjs(browser);

  var CollapsibleManager = /*#__PURE__*/ (function () {
    function CollapsibleManager() {
      _classCallCheck(this, CollapsibleManager);

      this.domDelegate = new Delegate(document.body);

      this._attachListeners();
    }

    _createClass(CollapsibleManager, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.domDelegate.on(
            "click",
            '[data-action="toggle-collapsible"]:not([disabled])',
            this._toggleCollapsible.bind(this),
          );
          document.addEventListener("collapsible:toggle", this._toggleCollapsible.bind(this));
        },
        /**
         * Toggle a given collapsible
         */
      },
      {
        key: "_toggleCollapsible",
        value: function _toggleCollapsible(event, target) {
          var _this = this;

          // If the target is null, it may be because someone has sent the global event "collapsible:toggle". If that the case
          // we can retrieve the toggle button by using the event.detail.id
          if (!target && event.detail) {
            target = document.querySelector('[aria-controls="'.concat(event.detail.id, '"]'));
          }

          var isOpen = target.getAttribute("aria-expanded") === "true",
            parentCollapsible = target.parentNode;

          if (isOpen) {
            this._close(parentCollapsible);
          } else {
            this._open(parentCollapsible);
          } // We make sure to close any siblings collapsible as well

          if (target.getAttribute("data-close-siblings") !== "false") {
            Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
              return _this._close(collapsibleToClose);
            });
          }
        },
        /**
         * Open a given collapsible
         */
      },
      {
        key: "_open",
        value: function _open(collapsible) {
          var toggleButton = collapsible.querySelector("[aria-controls]");

          if (!toggleButton || toggleButton.getAttribute("aria-expanded") === "true") {
            return; // It's already open
          }

          var collapsibleContent = collapsible.querySelector(
            "#".concat(toggleButton.getAttribute("aria-controls")),
          );
          toggleButton.setAttribute("aria-expanded", "true");

          if (collapsibleContent.hasAttribute("aria-hidden")) {
            collapsibleContent.setAttribute("aria-hidden", "false");
          }

          Animation.slideDown(collapsibleContent, function () {
            if (toggleButton.hasAttribute("data-collapsible-force-overflow")) {
              collapsibleContent.style.overflow = "visible";
            } // If there is an autofocus field, we focus it

            var autofocusElement = collapsibleContent.querySelector("[autofocus]");

            if (autofocusElement) {
              autofocusElement.focus();
            }
          });
        },
        /**
         * Close a given collapsible
         */
      },
      {
        key: "_close",
        value: function _close(collapsible) {
          var toggleButton = collapsible.querySelector("[aria-controls]");

          if (!toggleButton || toggleButton.getAttribute("aria-expanded") === "false") {
            return; // It's already closed
          }

          var collapsibleContent = collapsible.querySelector(
            "#".concat(toggleButton.getAttribute("aria-controls")),
          );

          if (toggleButton.hasAttribute("data-collapsible-force-overflow")) {
            collapsibleContent.style.overflow = "hidden";
          }

          if (collapsibleContent.hasAttribute("aria-hidden")) {
            collapsibleContent.setAttribute("aria-hidden", "true");
          }

          toggleButton.setAttribute("aria-expanded", "false");
          Animation.slideUp(collapsibleContent);
        },
      },
    ]);

    return CollapsibleManager;
  })();

  var CountrySelector = /*#__PURE__*/ (function () {
    function CountrySelector(countrySelect, provinceSelect) {
      _classCallCheck(this, CountrySelector);

      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;

      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners();

        this._initSelectors();
      }
    }

    _createClass(CountrySelector, [
      {
        key: "destroy",
        value: function destroy() {
          if (this.countrySelect) {
            this.countrySelect.removeEventListener("change", this._onCountryChangedListener);
          }
        },
      },
      {
        key: "_initSelectors",
        value: function _initSelectors() {
          // Check first the default value of country
          var defaultCountry = this.countrySelect.getAttribute("data-default");

          if (defaultCountry) {
            for (var i = 0; i !== this.countrySelect.options.length; ++i) {
              if (this.countrySelect.options[i].text === defaultCountry) {
                this.countrySelect.selectedIndex = i;
                break;
              }
            }
          } else {
            this.countrySelect.selectedIndex = 0;
          }

          var event = new Event("change", {
            bubbles: true,
          });
          this.countrySelect.dispatchEvent(event); // Then the province

          var defaultProvince = this.provinceSelect.getAttribute("data-default");

          if (defaultProvince) {
            for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
              if (this.provinceSelect.options[_i].text === defaultProvince) {
                this.provinceSelect.selectedIndex = _i;
                break;
              }
            }
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onCountryChangedListener = this._onCountryChanged.bind(this);
          this.countrySelect.addEventListener("change", this._onCountryChangedListener);
        },
      },
      {
        key: "_onCountryChanged",
        value: function _onCountryChanged() {
          var _this = this;

          var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex];

          if (!selectedOption) {
            return;
          }

          var provinces = JSON.parse(selectedOption.getAttribute("data-provinces") || "[]"); // First remove all options

          this.provinceSelect.innerHTML = "";

          if (provinces.length === 0) {
            this.provinceSelect.closest(".form__input-wrapper").style.display = "none";
            return;
          } // We need to build the provinces array

          provinces.forEach(function (data) {
            _this.provinceSelect.options.add(new Option(data[1], data[0]));
          });
          this.provinceSelect.closest(".form__input-wrapper").style.display = "block";
        },
      },
    ]);

    return CountrySelector;
  })();

  var Responsive = /*#__PURE__*/ (function () {
    function Responsive() {
      _classCallCheck(this, Responsive);
    }

    _createClass(Responsive, null, [
      {
        key: "matchesBreakpoint",
        value: function matchesBreakpoint(breakpoint) {
          switch (breakpoint) {
            case "phone":
              return window.matchMedia("screen and (max-width: 640px)").matches;

            case "tablet":
              return window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)")
                .matches;

            case "tablet-and-up":
              return window.matchMedia("screen and (min-width: 641px)").matches;

            case "pocket":
              return window.matchMedia("screen and (max-width: 1023px)").matches;

            case "lap":
              return window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)")
                .matches;

            case "lap-and-up":
              return window.matchMedia("screen and (min-width: 1024px)").matches;

            case "desk":
              return window.matchMedia("screen and (min-width: 1280px)").matches;

            case "widescreen":
              return window.matchMedia("screen and (min-width: 1440px)").matches;

            case "supports-hover":
              return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
          }
        },
      },
      {
        key: "getCurrentBreakpoint",
        value: function getCurrentBreakpoint() {
          if (window.matchMedia("screen and (max-width: 640px)").matches) {
            return "phone";
          }

          if (window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches) {
            return "tablet";
          }

          if (window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches) {
            return "lap";
          }

          if (window.matchMedia("screen and (min-width: 1280px)").matches) {
            return "desk";
          }
        },
      },
    ]);

    return Responsive;
  })();

  var DesktopNavigation = /*#__PURE__*/ (function () {
    function DesktopNavigation(element, navigationLayout, openTrigger) {
      _classCallCheck(this, DesktopNavigation);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.delegateRoot = new Delegate(document.documentElement);
      this.useInlineNavigation = navigationLayout === "inline";
      this.isNavigationVisible = this.useInlineNavigation;
      this.allItems = document.querySelectorAll(".nav-bar__item")
      this.openTrigger = openTrigger; // If we use a device that does not support hover, we force the open trigger to be on click (for instance iPad)

      if (!Responsive.matchesBreakpoint("supports-hover")) {
        this.openTrigger = "click";
      }

      this.openItems = [];
      this.dropdownActivationTimeouts = {};
      this.dropdownDeactivationTimeouts = {};
      this.DROPDOWN_TIMEOUT = 100;

      this._attachListeners();

      if (this.useInlineNavigation) {
        this._setupInlineNavigation();
      }
    }

    _createClass(DesktopNavigation, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
          this.delegateRoot.off();
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          var _this = this;

          if (!this.useInlineNavigation) {
            this._openNavigation();
          } // We receive a reference to the mega-menu, but for simpler handling, we simulate as if the button was hovered. First, we must close
          // mega-menu if there is already one that is open

          Dom.getSiblings(event.target.parentNode, ".is-dropdown-open").forEach(
            function (openItem) {
              _this._deactivateDropdown(
                event,
                openItem.querySelector('[data-type="menuitem"][aria-haspopup]'),
              );
            },
          ); // The previousElementSibling is always the link itself

          this._activateDropdown(event, event.target.previousElementSibling);
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect(event) {
          if (!this.useInlineNavigation) {
            this._closeNavigation();
          } // The deactivation is done on the wrapping div (so parentNode)

          this._deactivateDropdown(event, event.target.parentNode);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on("focusout", this._onFocusOut.bind(this));
          this.delegateRoot.on("click", this._onClick.bind(this));
          this.delegateElement.on(
            "click",
            '[data-action="toggle-menu"]',
            this._toggleNavigation.bind(this),
          );

          if (this.openTrigger === "hover") {
            this.delegateElement.on(
              "focusin",
              '[data-type="menuitem"][aria-haspopup]',
              this._activateDropdown.bind(this),
            );
            this.delegateElement.on(
              "mouseover",
              '[data-type="menuitem"][aria-haspopup]',
              this._activateDropdown.bind(this),
            );
            this.delegateElement.on(
              "mouseover",
              '[data-type="menu"][aria-hidden="false"]',
              this._blockDropdownDeactivation.bind(this),
            );
            this.delegateElement.on(
              "focusout",
              ".is-dropdown-open",
              this._deactivateDropdown.bind(this),
            );
            this.delegateElement.on(
              "mouseout",
              ".is-dropdown-open",
              this._deactivateDropdown.bind(this),
            );
          } else {
            this.delegateElement.on(
              "click",
              '[data-type="menuitem"][aria-haspopup]',
              this._toggleDropdown.bind(this),
            );
          }
        },
        /**
         * When the whole menu looses focus, it's automatically closed (in the case of condensed menu)
         */
      },
      {
        key: "_onFocusOut",
        value: function _onFocusOut(event) {
          // event.relatedTarget is the new target that receives focus
          if (event.relatedTarget !== null && !this.element.contains(event.relatedTarget)) {
            this._closeNavigation();
          }
        },
        /**
         * We need to catch click outside the element to automatically close menu
         */
      },
      {
        key: "_onClick",
        value: function _onClick(event) {
          if (!this.element.contains(event.target)) {
            this._closeNavigation();
          }
        },
        /**
         * Open the navigation (really make sense for condensed menu-
         */
      },
      {
        key: "_openNavigation",
        value: function _openNavigation() {
          // Inline navigation is always visible so there is nothing to open
          if (this.useInlineNavigation) {
            return;
          }

          this.element
            .querySelector('[data-action="toggle-menu"]')
            .setAttribute("aria-expanded", "true");
          this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "false");
          this.isNavigationVisible = true;
        },
        /**
         * Close the navigation (really make sense for condensed menu)
         */
      },
      {
        key: "_closeNavigation",
        value: function _closeNavigation() {
          var _this2 = this;

          if (!this.useInlineNavigation) {
            this.element
              .querySelector('[data-action="toggle-menu"]')
              .setAttribute("aria-expanded", "false");
            this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "true");
          }

          this.isNavigationVisible = false;

          if (this.openTrigger === "click") {
            var cloneOpenItems = this.openItems.slice(0);
            cloneOpenItems.forEach(function (item) {
              _this2._deactivateDropdown(event, item);
            });
          }
        },
        /**
         * Toggle navigation
         */
      },
      {
        key: "_toggleNavigation",
        value: function _toggleNavigation(event) {
          if (this.isNavigationVisible) {
            this._closeNavigation();
          } else {
            this._openNavigation();
          }
        },
        /**
         * Toggle a dropdown
         */
      },
      {
        key: "_toggleDropdown",
        value: function _toggleDropdown(event, target) {
          // If the link is currently not expanded, we block the click
          if (target.getAttribute("aria-expanded") === "false") {
            event.preventDefault();
          }

          if (target.getAttribute("aria-expanded") === "true") {
            // If the link target is "#", by convention we close the dropdown, otherwise we just follow the link
            if (target.getAttribute("href") === "#") {
              event.preventDefault();

              this._deactivateDropdown(event, target.closest(".is-dropdown-open"));
            }
          } else {
            this._activateDropdown(event, target);
          }
        },
        /**
         * Open a dropdown menu
         */
      },
      {
        key: "_closeAllDropdowns",
        value: function _closeAllDropdowns() {
          this.allItems.forEach((item => {
            if (item.classList.contains("is-dropdown-open")) {
              item.classList.remove("is-dropdown-open");
              item.querySelector('[data-type="menuitem"]').setAttribute("aria-expanded", "false");
              var menuToClose = item.querySelector("[aria-hidden]");
              menuToClose.setAttribute("aria-hidden", "true");
            }
          }))
        }
      },
      {
        key: "_activateDropdown",
        value: function _activateDropdown(event, target) {
          var _this3 = this;
          _this3._closeAllDropdowns()

          // If we are on click, we first need to close any other dropdown (if needed)
          if (this.openTrigger === "click") {
            var cloneOpenItems = this.openItems.slice(0);
            cloneOpenItems.forEach(function (item) {
              if (!item.contains(target)) {
                _this3._deactivateDropdown(event, item);
              }
            });
          }

          var menuToOpen = Dom.getSiblings(target, "[aria-hidden]")[0];

          var callback = function callback() {
            target.setAttribute("aria-expanded", "true");
            target.parentNode.classList.add("is-dropdown-open");
            menuToOpen.setAttribute("aria-hidden", "false"); // If this menu was scheduled for deactivation, we remove the scheduling as it is now meant to open

            if (
              _this3.openTrigger === "hover" &&
              _this3.dropdownDeactivationTimeouts[menuToOpen.id]
            ) {
              clearTimeout(_this3.dropdownDeactivationTimeouts[menuToOpen.id]);
              delete _this3.dropdownDeactivationTimeouts[menuToOpen.id];
            } // If we are in inline navigation, we may be on the edge of the screen. If that's the case we check if any of the sub-sub-menu goes outside the screen. If
            // this is the case, sub-sub-menu will be displayed on the left

            if (_this3.useInlineNavigation) {
              var windowWidth = window.innerWidth,
                shouldOpenLeft = false;
              menuToOpen.querySelectorAll(".nav-dropdown").forEach(function (subSubMenu) {
                if (subSubMenu.getBoundingClientRect().right > windowWidth) {
                  shouldOpenLeft = true;
                }
              });

              if (shouldOpenLeft) {
                menuToOpen.classList.add("nav-dropdown--inverse");
              }
            }

            target.closest('[data-type="menu"]').classList.add("nav-dropdown--glued");

            if (menuToOpen.classList.contains("mega-menu")) {
              _this3._setupMegaMenu(menuToOpen);
            }

            if (_this3.openTrigger === "click") {
              _this3.openItems.push(target.parentNode);
            }
          }; // If we are using on click, we can directly close, otherwise we apply a slight delay before closing the menu,
          // so that the deactivation could be cancelled if the mouse is back to the dropdown (which can happen when doing
          // horizontal movement)

          if (this.openTrigger === "click") {
            callback();
          } else {
            // Any other menu that has been scheduled for activation must be deactivated as it's now this one that is supposed to open
            for (var toDeactivate in this.dropdownActivationTimeouts) {
              if (this.dropdownActivationTimeouts.hasOwnProperty(toDeactivate)) {
                clearTimeout(this.dropdownActivationTimeouts[toDeactivate]);
                delete this.dropdownActivationTimeouts[toDeactivate];
              }
            }

            callback();
            /*this.dropdownActivationTimeouts[menuToOpen.id] = setTimeout(() => {
            callback();
            delete this.dropdownActivationTimeouts[menuToOpen.id];
          }, this.DROPDOWN_TIMEOUT);*/
          }
        },
        /**
         * Close a dropdown menu
         */
      },
      {
        key: "_deactivateDropdown",
        value: function _deactivateDropdown(event, target) {
          var _this4 = this;

          // event.relatedTarget is the new target. This allows to make sure to only close the dropdown if we leave the containing div
          if (this.openTrigger === "hover" && target.contains(event.relatedTarget)) {
            return;
          }

          var menuToClose = target.querySelector("[aria-hidden]");

          var callback = function callback() {
            if (!event.relatedTarget.classList.contains("nav-bar__item") || !event.relatedTarget.querySelector('.mega-menu')) {
              target.classList.remove("is-dropdown-open");
              target.querySelector('[data-type="menuitem"]').setAttribute("aria-expanded", "false");
              var menuToClose = target.querySelector("[aria-hidden]");
              menuToClose.setAttribute("aria-hidden", "true");
              target.closest('[data-type="menu"]').classList.remove("nav-dropdown--glued"); // If on click, we also close all sub-menus that may be open
            }

            if (_this4.openTrigger === "click") {
              target.querySelectorAll(".is-dropdown-open").forEach(function (item) {
                _this4._deactivateDropdown(event, item);

                var index = _this4.openItems.indexOf(item);

                if (index > -1) {
                  _this4.openItems.splice(index, 1);
                }
              }); // It has been deactivated so we also remove this one

              var index = _this4.openItems.indexOf(target);

              if (index > -1) {
                _this4.openItems.splice(index, 1);
              }
            }
          }; // If we are using on click, we can directly close, otherwise we apply a slight delay before closing the menu,
          // so that the deactivation could be cancelled if the mouse is back to the dropdown (which can happen when doing
          // horizontal movement)

          if (this.openTrigger === "click") {
            callback();
          } else {
            this.dropdownDeactivationTimeouts[menuToClose.id] = setTimeout(function () {
              callback();
              delete _this4.dropdownDeactivationTimeouts[menuToClose.id];
            }, this.DROPDOWN_TIMEOUT);
          }
        },
        /**
         * This method allows to block the dropdown deactivation if the mouse is back on the element. This may happen for
         * instance when the customer does a kind of diagonal movement to the menu. While the mouse may leave the opening
         * item, we want the item to stay open
         */
      },
      {
        key: "_blockDropdownDeactivation",
        value: function _blockDropdownDeactivation(event, target) {
          if (this.dropdownDeactivationTimeouts[target.id] !== undefined) {
            clearTimeout(this.dropdownDeactivationTimeouts[target.id]);
            delete this.dropdownDeactivationTimeouts[target.id]; // If we blocked the deactivation, then we must also remove any pending menu that could have been scheduled to open

            for (var toDeactivate in this.dropdownActivationTimeouts) {
              if (this.dropdownActivationTimeouts.hasOwnProperty(toDeactivate)) {
                clearTimeout(this.dropdownActivationTimeouts[toDeactivate]);
                delete this.dropdownActivationTimeouts[toDeactivate];
              }
            }
          }
        },
        /**
         * Set the maximum width allowed for the given mega-menu. For the inline style, it is always full width so nothing to do
         */
      },
      {
        key: "_setupMegaMenu",
        value: function _setupMegaMenu(megaMenu) {
          if (!this.useInlineNavigation) {
            var navDropdownWidth = megaMenu.closest(".nav-dropdown").clientWidth;
            megaMenu.style.maxWidth =
              Math.min(
                1400 - navDropdownWidth,
                parseInt(window.innerWidth - navDropdownWidth - 80),
              ) + "px";
          }
        },
        /**
         * Fix inline navigation
         */
      },
      {
        key: "_setupInlineNavigation",
        value: function _setupInlineNavigation() {
          var _this5 = this;

          this.element.querySelectorAll(".mega-menu").forEach(function (megaMenu) {
            megaMenu.closest(".nav-bar__item").classList.add("nav-bar__item--static");
          }); // If using the inline navigation, we also set up a mutation observer whenever a sub-sub-dropdown is open, in order
          // to calculate their distance from the top of the screen, so we can apply a max-height properly

          if ("MutationObserver" in window) {
            this.dropdownMenuObserver = new MutationObserver(function (mutationList) {
              mutationList.forEach(function (mutation) {
                if (mutation.target.getAttribute("aria-hidden") === "false") {
                  // We set a CSS variable, so we can do various calculation in CSS
                  mutation.target.style.setProperty(
                    "--distance-to-top",
                    "".concat(mutation.target.getBoundingClientRect().top, "px"),
                  );
                }
              });
            });
            this.element.querySelectorAll(".nav-dropdown .nav-dropdown").forEach(function (item) {
              _this5.dropdownMenuObserver.observe(item, {
                attributes: true,
                attributeFilter: ["aria-hidden"],
              });
            });
          }
        },
      },
    ]);

    return DesktopNavigation;
  })();

  var CollectionFilterDrawer = /*#__PURE__*/ (function () {
    function CollectionFilterDrawer(options) {
      _classCallCheck(this, CollectionFilterDrawer);
      this.delegateRoot = new Delegate(document.documentElement);
      this._attachListeners();
    }

    _createClass(CollectionFilterDrawer, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateRoot.off();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateRoot.on(
            "click",
            '[aria-controls="mobile-collection-filters"][data-action="open-drawer"]',
            this.open.bind(this),
          );
        },
      },
      {
        key: "open",
        value: function open(event) {
          if (event) {
            event.stopPropagation();
          }
          dispatchEvent(new CustomEvent("filters:open"));
        },
      },
    ]);

    return CollectionFilterDrawer;
  })();

  var ExitPopup = /*#__PURE__*/ (function () {
    function ExitPopup(element) {
      _classCallCheck(this, ExitPopup);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.rootDelegateElement = new Delegate(document.body);
      this.options = JSON.parse(element.getAttribute("data-popup-settings"));
      this.hasOpenOnceInCurrentPage = false; // If the popup has been already displayed, we do not display it

      try {
        if (window.location.hash === "#exit-popup" && window.theme.pageType !== "captcha") {
          this._openPopup();
        }
      } catch (error) {
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }

      this._attachListeners();
    }

    _createClass(ExitPopup, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          var _this = this;

          this._onKeyPressedListener = this._onKeyPressed.bind(this);
          /* Some browsers like Android emit a mouseleave event when opening keyboard. This is too unreliable for touch devices */

          if (!Responsive.matchesBreakpoint("supports-hover")) {
            return;
          }

          this.delegateElement.on(
            "click",
            '[data-action="close-popup"]',
            this._closePopup.bind(this),
          );
          document.body.addEventListener("mouseleave", function () {
            if (!_this.hasOpenOnceInCurrentPage) {
              if (
                !_this.options["showOnlyOnce"] ||
                (_this.options["showOnlyOnce"] && localStorage.getItem("themeExitPopup") === null)
              ) {
                _this._openPopup();
              }
            }
          });
          this._clickOutsideListener = this._checkClickOutside.bind(this);
        },
      },
      {
        key: "_openPopup",
        value: function _openPopup() {
          if (!window.theme.isNewsletterPopupOpen) {
            this.element.setAttribute("aria-hidden", "false");
            localStorage.setItem("themeExitPopup", "true");
            this.hasOpenOnceInCurrentPage = true;
            window.theme.isExitPopupOpen = true;
            this.delegateElement.on("click", this._clickOutsideListener);
            this.rootDelegateElement.on("keyup", this._onKeyPressedListener);
          }
        },
      },
      {
        key: "_closePopup",
        value: function _closePopup() {
          this.element.setAttribute("aria-hidden", "true");
          window.theme.isExitPopupOpen = false;
          this.delegateElement.off("click", this._clickOutsideListener);
          this.rootDelegateElement.off("keyup", this._onKeyPressedListener);
        },
      },
      {
        key: "_checkClickOutside",
        value: function _checkClickOutside(event) {
          if (!this.element.contains(event.target) || this.element === event.target) {
            this._closePopup();
          }
        },
      },
      {
        key: "_onKeyPressed",
        value: function _onKeyPressed(event) {
          if (event.key === "Escape") {
            this._closePopup();
          }
        },
      },
    ]);

    return ExitPopup;
  })();

  /**
   * Simple plugin that handles the loading bar actions
   *
   * This plugin uses delegate events so it's independent of the sections.
   */
  var LoadingBar = /*#__PURE__*/ (function () {
    function LoadingBar() {
      _classCallCheck(this, LoadingBar);

      this.element = document.querySelector(".loading-bar");

      if (this.element) {
        document.addEventListener("theme:loading:start", this._onLoadingStart.bind(this));
        document.addEventListener("theme:loading:end", this._onLoadingEnd.bind(this));
        this.element.addEventListener("transitionend", this._onTransitionEnd.bind(this));
      }
    }

    _createClass(LoadingBar, [
      {
        key: "_onLoadingStart",
        value: function _onLoadingStart() {
          this.element.classList.add("is-visible");
          this.element.style.transform = "scaleX(0.4)";
        },
      },
      {
        key: "_onLoadingEnd",
        value: function _onLoadingEnd() {
          this.element.style.transform = "scaleX(1)";
          this.element.classList.add("is-finished");
        },
      },
      {
        key: "_onTransitionEnd",
        value: function _onTransitionEnd(event) {
          if (
            event.propertyName === "transform" &&
            this.element.classList.contains("is-finished")
          ) {
            this.element.classList.remove("is-visible");
            this.element.classList.remove("is-finished");
            this.element.style.transform = "scaleX(0)";
          }
        },
      },
    ]);

    return LoadingBar;
  })();

  var Accessibility = /*#__PURE__*/ (function () {
    function Accessibility() {
      _classCallCheck(this, Accessibility);
    }

    _createClass(Accessibility, null, [
      {
        key: "trapFocus",

        /**
         * Traps the focus in a particular container
         */
        value: function trapFocus(container, namespace) {
          this.listeners = this.listeners || {}; // We check if there is an element with the attribute "autofocus"

          var elementToFocus = container.querySelector("[autofocus]") || container;
          container.setAttribute("tabindex", "-1");
          elementToFocus.focus();

          this.listeners[namespace] = function (event) {
            if (container !== event.target && !container.contains(event.target)) {
              elementToFocus.focus();
            }
          };

          document.addEventListener("focusin", this.listeners[namespace]);
        },
        /**
         * Removes the trap of focus in a particular container
         */
      },
      {
        key: "removeTrapFocus",
        value: function removeTrapFocus(container, namespace) {
          if (container) {
            container.removeAttribute("tabindex");
          }

          document.removeEventListener("focusin", this.listeners[namespace]);
        },
        /**
         * Reset any previous trap focus
         */
      },
      {
        key: "clearTrapFocus",
        value: function clearTrapFocus() {
          for (var key in this.listeners) {
            if (this.listeners.hasOwnProperty(key)) {
              document.removeEventListener("focusin", this.listeners[key]);
            }
          }

          this.listeners = {};
        },
      },
    ]);

    return Accessibility;
  })();

  /**
   * This class handles both the mini cart and the dedicated cart page. It's not the cleanest code on earth but works well :)
   */

  var Cart = /*#__PURE__*/ (function () {
    function Cart(element, options) {
      _classCallCheck(this, Cart);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.delegateRoot = new Delegate(document.documentElement);
      this.options = options; // Some developers blindly remove the DOM code for the cart, so we have to do a check here to make sure it is here

      if (!this.element) {
        return;
      }

      this.miniCartElement = this.element.querySelector(".mini-cart");
      this.isMiniCartOpen = false;

      if (window.theme.pageType !== "cart" && this.miniCartElement) {
        this.miniCartToggleElement = this.element.querySelector(
          '[aria-controls="'.concat(this.miniCartElement.id, '"]'),
        );

        this._checkMiniCartScrollability();
      }

      this.itemCount = window.theme.cartCount;

      this._attachListeners();
    }

    _createClass(Cart, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
          this.delegateRoot.off();
          window.removeEventListener("resize", this._calculateMiniCartHeightListener);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._calculateMiniCartHeightListener = this._calculateMiniCartHeight.bind(this);

          if (window.theme.pageType !== "cart" && window.theme.cartType !== "page") {
            this.delegateElement.on(
              "click",
              '[data-action="toggle-mini-cart"]',
              this._toggleMiniCart.bind(this),
            );
            this.delegateElement.on("keyup", this._checkMiniCartClose.bind(this));
            this.delegateRoot.on("click", this._onWindowClick.bind(this));
            window.addEventListener("resize", this._calculateMiniCartHeightListener);
          }

          this.delegateRoot.on(
            "click",
            '[data-action="decrease-quantity"]',
            this._updateQuantity.bind(this),
          );
          this.delegateRoot.on(
            "click",
            '[data-action="increase-quantity"]',
            this._updateQuantity.bind(this),
          );
          this.delegateRoot.on(
            "change",
            ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value",
            this._updateQuantity.bind(this),
          );
          this.delegateRoot.on(
            "keyup",
            ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value",
            this._updateQuantitySize.bind(this),
          );
          this.delegateRoot.on(
            "keydown",
            ".quantity-selector__value",
            this._blockEnterKey.bind(this),
          );
          this.delegateRoot.on("product:added", this._onProductAdded.bind(this));
          this.delegateRoot.on("cart:refresh", this._onCartRefresh.bind(this));
        },
      },
      {
        key: "_toggleMiniCart",
        value: function _toggleMiniCart(event) {
          if (event) {
            event.preventDefault();
          }

          if (this.isMiniCartOpen) {
            this._closeMiniCart();
          } else {
            this._openMiniCart();
          }
        },
      },
      {
        key: "_openMiniCart",
        value: function _openMiniCart() {
          this.miniCartToggleElement.setAttribute("aria-expanded", "true"); // If we are on mobile phone we also set the aria-expanded attribute to true on the icon state holder

          if (Responsive.getCurrentBreakpoint() === "phone") {
            this.miniCartToggleElement
              .querySelector(".header__cart-icon")
              .setAttribute("aria-expanded", "true");
          } // Finally also set aria-hidden to false on controlled element

          this.miniCartElement.setAttribute("aria-hidden", "false");
          this.isMiniCartOpen = true;

          this._calculateMiniCartHeight(); // Trap the focus

          Accessibility.trapFocus(this.miniCartElement, "mini-cart");
          document.body.classList.add("no-mobile-scroll");
        },
      },
      {
        key: "_closeMiniCart",
        value: function _closeMiniCart() {
          this.miniCartToggleElement.setAttribute("aria-expanded", "false"); // If we are on mobile phone we also set the aria-expanded attribute to true on the icon state holder

          if (Responsive.getCurrentBreakpoint() === "phone") {
            this.miniCartToggleElement
              .querySelector(".header__cart-icon")
              .setAttribute("aria-expanded", "false");
            this.miniCartElement.style.maxHeight = "";
          } // Finally also set aria-hidden to false on controlled element

          this.miniCartElement.setAttribute("aria-hidden", "true");
          this.isMiniCartOpen = false;
          document.body.classList.remove("no-mobile-scroll");
        },
      },
      {
        key: "_checkMiniCartClose",
        value: function _checkMiniCartClose(event) {
          if (!this.isMiniCartOpen) {
            return;
          }

          if (event.key === "Escape") {
            this._closeMiniCart();
          }
        },
      },
      {
        key: "_calculateMiniCartHeight",
        value: function _calculateMiniCartHeight() {
          if (Responsive.getCurrentBreakpoint() === "phone") {
            if (this.isMiniCartOpen) {
              var maxHeight =
                window.innerHeight -
                document.querySelector(".header").getBoundingClientRect().bottom;
              this.miniCartElement.style.maxHeight = "".concat(maxHeight, "px"); // We also need to calculate the content part height to avoid any issue on Chrome

              var miniCartContentElement =
                  this.miniCartElement.querySelector(".mini-cart__content"),
                miniCartRecapElement = this.miniCartElement.querySelector(".mini-cart__recap");

              if (miniCartRecapElement) {
                miniCartContentElement.style.maxHeight = "".concat(
                  maxHeight - miniCartRecapElement.clientHeight,
                  "px",
                );
              }
            } else {
              this.miniCartElement.style.maxHeight = "";
              this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = "";
            }
          } else {
            this.miniCartElement.style.maxHeight = "";
            this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = "";
          }
        },
        /**
         * Change the quantity of the cart
         */
      },
      {
        key: "_updateQuantity",
        value: function _updateQuantity(event, target) {
          var _this = this;

          var parsedQuantity = 1;
          if (target.tagName === "INPUT") {
            parsedQuantity = parseInt(target.value);
          } else {
            parsedQuantity = parseInt(target.getAttribute("data-quantity"));
          } // If we are in "page" mode, we reload the page instead of doing that in Ajax to have a better compatibility with apps

          if (window.theme.cartType === "page") {
            if (target.hasAttribute("data-href")) {
              window.location.href = target.getAttribute("data-href");
            } else {
              window.location.href = ""
                .concat(window.routes.cartChangeUrl, "?line=")
                .concat(target.getAttribute("data-line"), "&quantity=")
                .concat(parsedQuantity);
            }

            return;
          }

          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
            body: JSON.stringify({
              line: target.getAttribute("data-line"),
              quantity: parsedQuantity,
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          }).then(function (cart) {
            cart.json().then(function (content) {
              const event = new CustomEvent("addToCartFinish", {
                detail: content,
              });
              document.dispatchEvent(event);
              _this.itemCount = content["item_count"];

              _this._rerender(false).then(function () {
                document.dispatchEvent(new CustomEvent("theme:loading:end"));
              });
            });
          });
          event.preventDefault();
        },
      },
      {
        key: "_updateQuantitySize",
        value: function _updateQuantitySize(event, target) {
          target.setAttribute("size", Math.max(target.value.length, 2));
        },
      },
      {
        key: "_blockEnterKey",
        value: function _blockEnterKey(event) {
          if (event.key === "Enter") {
            return false;
          }
        },
        /**
         * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
         * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
         * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
         * all the time and hence having easier logic.
         */
      },
      {
        key: "_rerender",
        value: function _rerender() {
          var _this2 = this;

          var scrollToTop =
            arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
          var url = "";

          if (window.theme.pageType !== "cart") {
            url = "".concat(window.routes.cartUrl, "?section_id=mini-cart");
          } else {
            var cartSection = document.querySelector('[data-section-type="cart"]');
            url = ""
              .concat(window.routes.cartUrl, "?section_id=")
              .concat(cartSection.getAttribute("data-section-id"));
          }

          return fetch(url, {
            credentials: "same-origin",
            method: "GET",
            headers: {
              "Cache-Control": "no-cache",
            },
          }).then(function (content) {
            content.text().then(function (html) {
              // We extract the data-item-count from the returned element
              var myDiv = document.createElement("div");
              myDiv.innerHTML = html;

              if (
                myDiv.firstElementChild &&
                myDiv.firstElementChild.hasAttribute("data-item-count")
              ) {
                _this2.itemCount = parseInt(
                  myDiv.firstElementChild.getAttribute("data-item-count"),
                );
              }

              if (_this2.element.querySelector(".header__cart-count")) {
                _this2.element.querySelector(".header__cart-count").textContent = _this2.itemCount;
              }
              if (_this2.itemCount < 1) {
                _this2.element.querySelector(".header__cart-count")?.classList.add("cart-empty");
              } else {
                _this2.element.querySelector(".header__cart-count")?.classList.remove("cart-empty");
              }

              if (window.theme.cartType !== "page") {
                if (window.theme.pageType !== "cart") {
                  // Note: we could use outerHTML here but outerHTML does not update the reference to new object
                  var tempElement = document.createElement("div");
                  tempElement.innerHTML = html; // When we re-render, we need to preserve the scroll position when content changes

                  var miniCartItemListElement = _this2.miniCartElement.querySelector(
                      ".mini-cart__line-item-list",
                    ),
                    scrollPosition = null;

                  if (miniCartItemListElement) {
                    scrollPosition = miniCartItemListElement.scrollTop;
                  }

                  _this2.miniCartElement.innerHTML =
                    tempElement.querySelector(".mini-cart").innerHTML;

                  var newMiniCartItemListElement = _this2.miniCartElement.querySelector(
                    ".mini-cart__line-item-list",
                  );

                  if (newMiniCartItemListElement && scrollPosition !== null) {
                    newMiniCartItemListElement.scrollTop = scrollPosition;
                  }

                  _this2._checkMiniCartScrollability();

                  _this2._calculateMiniCartHeight();

                  _this2.element.dispatchEvent(new CustomEvent("cart:rerendered"));
                } else {
                  // The replacement of the DOM here could be made better and more resilient (maybe exploring using a virtual DOM approach in future?)
                  var _tempElement = document.createElement("div");

                  _tempElement.innerHTML = html;
                  var originalCart = document.querySelector('[data-section-type="cart"]');
                  originalCart.innerHTML = _tempElement.querySelector(
                    '[data-section-type="cart"]',
                  ).innerHTML;

                  if (scrollToTop) {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }

                  _this2.element.dispatchEvent(
                    new CustomEvent("cart:rerendered", {
                      bubbles: true,
                    }),
                  );
                }
              }
            });
          });
        },
        /**
         * Check if the mini-cart is scrollable
         */
      },
      {
        key: "_checkMiniCartScrollability",
        value: function _checkMiniCartScrollability() {
          var miniCartItemList = this.miniCartElement.querySelector(".mini-cart__line-item-list");

          if (miniCartItemList && miniCartItemList.scrollHeight > miniCartItemList.clientHeight) {
            miniCartItemList.classList.add("is-scrollable");
          }
        },
        /**
         * This callback is automatically called when a variant has been added, which allows us to open it and re-render
         */
      },
      {
        key: "_onProductAdded",
        value: function _onProductAdded(event) {
          var _this3 = this;

          this.itemCount += event.detail.quantity;
          /* Add the quantity added */

          this._onCartRefresh().then(function () {
            if (window.theme.pageType !== "cart") {
              // If we don't have the sticky header enabled, we scroll to top to make sure it is visible
              if (window.theme.cartType === "drawer" && !_this3.options["useStickyHeader"]) {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }

              if (window.theme.cartType === "message" && event.detail.button) {
                event.detail.button.innerHTML = window.languages.productAddedShort;
                setTimeout(function () {
                  event.detail.button.innerHTML = window.languages.productFormAddToCart;
                }, 1500);
              }

              if (window.theme.pageType !== "cart" && window.theme.cartType === "drawer") {
                _this3._openMiniCart();
              }
            }
          });
        },
        /**
         * Allows to refresh the mini-cart
         */
      },
      {
        key: "_onCartRefresh",
        value: function _onCartRefresh(event) {
          var scrollToTop = true;

          if (event && event.detail) {
            scrollToTop = event.detail.scrollToTop;
          }

          return this._rerender(scrollToTop).then(function () {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
          });
        },
        /**
         * We need to catch click outside the element to automatically close mini-cart
         */
      },
      {
        key: "_onWindowClick",
        value: function _onWindowClick(event) {
          if (this.miniCartElement && this.isMiniCartOpen && !this.element.contains(event.target)) {
            this._closeMiniCart();
          }
        },
      },
    ]);

    return Cart;
  })();

  var MobileNavigation = /*#__PURE__*/ (function () {
    function MobileNavigation(element) {
      _classCallCheck(this, MobileNavigation);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.delegateRoot = new Delegate(document.documentElement);
      this.mobileMenuElement = this.element.querySelector(".mobile-menu");
      this.mobileMenuToggleElement = this.element.querySelector(
        '[aria-controls="'.concat(this.mobileMenuElement.id, '"]'),
      );
      this.isOpen = false;

      this._attachListeners();
    }

    _createClass(MobileNavigation, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
          this.delegateRoot.off();
          window.removeEventListener("resize", this._calculatMaxHeightListener);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this);
          this.delegateElement.on(
            "click",
            '[data-action="toggle-menu"]',
            this._toggleMenu.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="open-panel"]',
            this._openPanel.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="close-panel"]',
            this._closePanel.bind(this),
          );
          this.delegateRoot.on("click", this._onWindowClick.bind(this));
          window.addEventListener("resize", this._calculatMaxHeightListener);
        },
      },
      {
        key: "_toggleMenu",
        value: function _toggleMenu() {
          this.isOpen = !this.isOpen;
          this.mobileMenuToggleElement.setAttribute(
            "aria-expanded",
            this.isOpen ? "true" : "false",
          );
          this.mobileMenuElement.setAttribute("aria-hidden", this.isOpen ? "false" : "true");

          if (!this.isOpen) {
            this.mobileMenuElement.style.maxHeight = ""; // If closed, we need to close all sub-menus

            this.element.querySelectorAll(".mobile-menu__panel.is-open").forEach(function (item) {
              item.classList.remove("is-open");
            });
            document.body.classList.remove("no-mobile-scroll");
          } else {
            // We need to restrict the height
            this._calculateMaxHeight();

            document.body.classList.add("no-mobile-scroll");
          }
        },
      },
      {
        key: "_openPanel",
        value: function _openPanel(event, target) {
          target.setAttribute("aria-expanded", "true");
          this.element
            .querySelector("#".concat(target.getAttribute("aria-controls")))
            .classList.add("is-open");
        },
      },
      {
        key: "_closePanel",
        value: function _closePanel(event, target) {
          // We first get the panel to be closed
          var panelToClose = target.closest(".mobile-menu__panel.is-open");
          panelToClose.classList.remove("is-open"); // Then update the ARIA attributes for button that control it

          this.element
            .querySelector('[aria-controls="'.concat(panelToClose.id, '"]'))
            .setAttribute("aria-expanded", "false");
        },
      },
      {
        key: "_calculateMaxHeight",
        value: function _calculateMaxHeight() {
          if (this.isOpen) {
            this.mobileMenuElement.style.maxHeight = "".concat(
              window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom,
              "px",
            );
          }
        },
      },
      {
        key: "_onWindowClick",
        value: function _onWindowClick(event) {
          if (this.isOpen && !this.element.contains(event.target)) {
            this._toggleMenu();
          }
        },
      },
    ]);

    return MobileNavigation;
  })();

  var ModalManager = /*#__PURE__*/ (function () {
    function ModalManager() {
      _classCallCheck(this, ModalManager);

      this.domDelegate = new Delegate(document.body);
      this.activeModalsQueue = [];
      var activeModal = document.querySelector('.modal[aria-hidden="false"]');

      if (activeModal) {
        this.activeModalsQueue.push(activeModal);
      }

      this._attachListeners();
    }

    _createClass(ModalManager, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onKeyPressedListener = this._onKeyPressed.bind(this);
          this.domDelegate.on("click", '[data-action="open-modal"]', this._openModal.bind(this));
          this.domDelegate.on("click", '[data-action="close-modal"]', this._closeModal.bind(this)); // We allow any other code to force closing a modal by listening to the "modal:close" event

          document.addEventListener("modal:close", this._closeModal.bind(this));
          this._clickOutsideListener = this._checkClickOutside.bind(this); // If there is already an active modal when the page is loaded, we directly attach the listener on outside click

          if (this.activeModalsQueue.length > 0) {
            document.documentElement.classList.add("is-locked");
            this.domDelegate.on("click", this._clickOutsideListener);
          }
        },
      },
      {
        key: "_openModal",
        value: function _openModal(event, target) {
          var _this = this;

          var modal = document.querySelector("#".concat(target.getAttribute("aria-controls")));

          if (modal) {
            var onOpen = function onOpen(event) {
              if (event.propertyName === "visibility") {
                modal.removeEventListener("transitionend", onOpen);
                Accessibility.trapFocus(modal, "modal" + modal.id);

                _this.activeModalsQueue.push(modal);
              }
            };

            modal.addEventListener("transitionend", onOpen);
            modal.setAttribute("aria-hidden", "false");
            document.documentElement.classList.add("is-locked");
            this.domDelegate.on("click", this._clickOutsideListener);
            this.domDelegate.on("keyup", this._onKeyPressedListener);
            return false; // Prevent the event to be propagated to the clickOutsideListener immediately
          }
        },
      },
      {
        key: "_closeModal",
        value: function _closeModal() {
          if (this.activeModalsQueue.length > 0) {
            var modalToClose = this.activeModalsQueue.pop();

            var onClose = function onClose(event) {
              if (event.propertyName === "visibility") {
                modalToClose.removeEventListener("transitionend", onClose);
                Accessibility.removeTrapFocus(modalToClose, "modal" + modalToClose.id); // We emit an event saying it has closed, which can give the option to do cleanup

                modalToClose.dispatchEvent(new CustomEvent("modal:closed"));
              }
            };

            modalToClose.addEventListener("transitionend", onClose);
            modalToClose.setAttribute("aria-hidden", "true");
            document.documentElement.classList.remove("is-locked");
            this.domDelegate.off("click", this._clickOutsideListener);
            this.domDelegate.off("keyup", this._onKeyPressedListener);
          }
        },
      },
      {
        key: "_checkClickOutside",
        value: function _checkClickOutside(event) {
          if (this.activeModalsQueue.length === 0) {
            return;
          }

          var modalToClose = this.activeModalsQueue[this.activeModalsQueue.length - 1];

          if (
            modalToClose &&
            (!modalToClose.contains(event.target) || modalToClose === event.target)
          ) {
            this._closeModal();
          }
        },
      },
      {
        key: "_onKeyPressed",
        value: function _onKeyPressed(event) {
          if (event.key === "Escape") {
            this._closeModal();
          }
        },
      },
    ]);

    return ModalManager;
  })();

  var NewsletterPopup = /*#__PURE__*/ (function () {
    function NewsletterPopup(element) {
      _classCallCheck(this, NewsletterPopup);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.rootDelegateElement = new Delegate(document.body);
      this.options = JSON.parse(element.getAttribute("data-popup-settings")); // If the popup has been already displayed, we do not display it

      try {
        if (window.location.hash === "#newsletter-popup" && window.theme.pageType !== "captcha") {
          this._openPopup();
        } else if (
          !this.options["showOnlyOnce"] ||
          (this.options["showOnlyOnce"] && localStorage.getItem("themePopup") === null)
        ) {
          setTimeout(this._openPopup.bind(this), this.options["apparitionDelay"] * 1000);
        }
      } catch (error) {
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }

      this._attachListeners();
    }

    _createClass(NewsletterPopup, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onKeyPressedListener = this._onKeyPressed.bind(this);
          this.delegateElement.on(
            "click",
            '[data-action="close-popup"]',
            this._closePopup.bind(this),
          );
          this._clickOutsideListener = this._checkClickOutside.bind(this);
        },
      },
      {
        key: "_openPopup",
        value: function _openPopup() {
          if (!window.theme.isExitPopupOpen) {
            this.element.setAttribute("aria-hidden", "false");
            localStorage.setItem("themePopup", "true");
            window.theme.isNewsletterPopupOpen = true;
            this.delegateElement.on("click", this._clickOutsideListener);
            this.rootDelegateElement.on("keyup", this._onKeyPressedListener);
          }
        },
      },
      {
        key: "_closePopup",
        value: function _closePopup() {
          this.element.setAttribute("aria-hidden", "true");
          window.theme.isNewsletterPopupOpen = false;
          this.delegateElement.off("click");
          this.rootDelegateElement.off("keyup", this._onKeyPressedListener);
        },
      },
      {
        key: "_checkClickOutside",
        value: function _checkClickOutside(event) {
          if (!this.element.contains(event.target) || this.element === event.target) {
            this._closePopup();
          }
        },
      },
      {
        key: "_onKeyPressed",
        value: function _onKeyPressed(event) {
          if (event.key === "Escape") {
            this._closePopup();
          }
        },
      },
    ]);

    return NewsletterPopup;
  })();

  var fastdom = createCommonjsModule(function (module) {
    !(function (win) {
      /**
       * Mini logger
       *
       * @return {Function}
       */

      var debug = function () {};
      /**
       * Normalized rAF
       *
       * @type {Function}
       */

      var raf =
        win.requestAnimationFrame ||
        win.webkitRequestAnimationFrame ||
        win.mozRequestAnimationFrame ||
        win.msRequestAnimationFrame ||
        function (cb) {
          return setTimeout(cb, 16);
        };
      /**
       * Initialize a `FastDom`.
       *
       * @constructor
       */

      function FastDom() {
        var self = this;
        self.reads = [];
        self.writes = [];
        self.raf = raf.bind(win); // test hook
      }

      FastDom.prototype = {
        constructor: FastDom,

        /**
         * Adds a job to the read batch and
         * schedules a new frame if need be.
         *
         * @param  {Function} fn
         * @param  {Object} ctx the context to be bound to `fn` (optional).
         * @public
         */
        measure: function measure(fn, ctx) {
          var task = !ctx ? fn : fn.bind(ctx);
          this.reads.push(task);
          scheduleFlush(this);
          return task;
        },

        /**
         * Adds a job to the
         * write batch and schedules
         * a new frame if need be.
         *
         * @param  {Function} fn
         * @param  {Object} ctx the context to be bound to `fn` (optional).
         * @public
         */
        mutate: function mutate(fn, ctx) {
          var task = !ctx ? fn : fn.bind(ctx);
          this.writes.push(task);
          scheduleFlush(this);
          return task;
        },

        /**
         * Clears a scheduled 'read' or 'write' task.
         *
         * @param {Object} task
         * @return {Boolean} success
         * @public
         */
        clear: function clear(task) {
          return remove(this.reads, task) || remove(this.writes, task);
        },

        /**
         * Extend this FastDom with some
         * custom functionality.
         *
         * Because fastdom must *always* be a
         * singleton, we're actually extending
         * the fastdom instance. This means tasks
         * scheduled by an extension still enter
         * fastdom's global task queue.
         *
         * The 'super' instance can be accessed
         * from `this.fastdom`.
         *
         * @example
         *
         * var myFastdom = fastdom.extend({
         *   initialize: function() {
         *     // runs on creation
         *   },
         *
         *   // override a method
         *   measure: function(fn) {
         *     // do extra stuff ...
         *
         *     // then call the original
         *     return this.fastdom.measure(fn);
         *   },
         *
         *   ...
         * });
         *
         * @param  {Object} props  properties to mixin
         * @return {FastDom}
         */
        extend: function extend(props) {
          if (_typeof(props) != "object") throw new Error("expected object");
          var child = Object.create(this);
          mixin(child, props);
          child.fastdom = this; // run optional creation hook

          if (child.initialize) child.initialize();
          return child;
        },
        // override this with a function
        // to prevent Errors in console
        // when tasks throw
        catch: null,
      };
      /**
       * Schedules a new read/write
       * batch if one isn't pending.
       *
       * @private
       */

      function scheduleFlush(fastdom) {
        if (!fastdom.scheduled) {
          fastdom.scheduled = true;
          fastdom.raf(flush.bind(null, fastdom));
        }
      }
      /**
       * Runs queued `read` and `write` tasks.
       *
       * Errors are caught and thrown by default.
       * If a `.catch` function has been defined
       * it is called instead.
       *
       * @private
       */

      function flush(fastdom) {
        var writes = fastdom.writes;
        var reads = fastdom.reads;
        var error;

        try {
          debug("flushing reads", reads.length);
          runTasks(reads);
          debug("flushing writes", writes.length);
          runTasks(writes);
        } catch (e) {
          error = e;
        }

        fastdom.scheduled = false; // If the batch errored we may still have tasks queued

        if (reads.length || writes.length) scheduleFlush(fastdom);

        if (error) {
          debug("task errored", error.message);
          if (fastdom["catch"]) fastdom["catch"](error);
          else throw error;
        }
      }
      /**
       * We run this inside a try catch
       * so that if any jobs error, we
       * are able to recover and continue
       * to flush the batch until it's empty.
       *
       * @private
       */

      function runTasks(tasks) {
        var task;

        while ((task = tasks.shift())) {
          task();
        }
      }
      /**
       * Remove an item from an Array.
       *
       * @param  {Array} array
       * @param  {*} item
       * @return {Boolean}
       */

      function remove(array, item) {
        var index = array.indexOf(item);
        return !!~index && !!array.splice(index, 1);
      }
      /**
       * Mixin own properties of source
       * object into the target.
       *
       * @param  {Object} target
       * @param  {Object} source
       */

      function mixin(target, source) {
        for (var key in source) {
          if (source.hasOwnProperty(key)) target[key] = source[key];
        }
      } // There should never be more than
      // one instance of `FastDom` in an app

      var exports = (win.fastdom = win.fastdom || new FastDom()); // jshint ignore:line
      // Expose to CJS & AMD

      module.exports = exports;
    })(typeof window !== "undefined" ? window : commonjsGlobal);
  });

  var PopoverManager = /*#__PURE__*/ (function () {
    function PopoverManager() {
      _classCallCheck(this, PopoverManager);

      this.delegateElement = new Delegate(document.body);
      this.delegateRoot = new Delegate(document.documentElement);
      this.activePopover = null;

      this._attachListeners();
    }

    _createClass(PopoverManager, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onLooseFocusListener = this._onLooseFocus.bind(this);
          this.delegateElement.on(
            "click",
            '[data-action="toggle-popover"]',
            this._togglePopover.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="show-popover-panel"]',
            this._showPanel.bind(this),
          );
          this.delegateRoot.on("click", this._onWindowClick.bind(this));
          document.addEventListener("popover:close", this._closeActivePopover.bind(this));
          window.addEventListener("resize", this._windowResized.bind(this));
        },
      },
      {
        key: "_togglePopover",
        value: function _togglePopover(event, target) {
          var hasActivePopover = this.activePopover !== null,
            previousActivePopoverId = this.activePopover ? this.activePopover.id : null; // If the toggler has a "data-follow-link" attribute, we match against the breakpoint and redirect to the page

          if (
            target.hasAttribute("data-follow-link") &&
            Responsive.matchesBreakpoint(target.getAttribute("data-follow-link"))
          ) {
            return;
          }

          if (hasActivePopover) {
            this._closeActivePopover();
          }

          if (
            !hasActivePopover ||
            (hasActivePopover && target.getAttribute("aria-controls") !== previousActivePopoverId)
          ) {
            this._openPopover(target);
          }

          event.preventDefault();
        },
      },
      {
        key: "_closeActivePopover",
        value: function _closeActivePopover() {
          this.activePopover.setAttribute("aria-hidden", "true");
          document
            .querySelector('[aria-controls="'.concat(this.activePopover.id, '"]'))
            .setAttribute("aria-expanded", "false");
          this.activePopover.removeEventListener("focusout", this._onLooseFocusListener);
          this.activePopover = null;
        },
      },
      {
        key: "_openPopover",
        value: function _openPopover(target) {
          var element = document.getElementById(target.getAttribute("aria-controls"));
          target.setAttribute("aria-expanded", "true");
          element.setAttribute("aria-hidden", "false"); // If we are on mobile phone we also set the aria-expanded attribute to true on the icon state holder

          if (Responsive.getCurrentBreakpoint() === "phone") {
            element.style.height = "".concat(
              window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom,
              "px",
            );
          } else {
            element.style.height = ""; // If the popover contains a "panel-list", we set the height to the active panel

            var panelList = element.querySelector(".popover__panel-list");

            if (panelList) {
              panelList.style.height = "".concat(panelList.clientHeight, "px");
            }
          }

          this.activePopover = element;
          this.activePopover.addEventListener("focusout", this._onLooseFocusListener);
        },
      },
      {
        key: "_showPanel",
        value: function _showPanel(event, target) {
          // If no active popover, we do nothing
          if (!this.activePopover) {
            return;
          } // Otherwise we get all the panels within the popover

          var panels = this.activePopover.querySelectorAll(".popover__panel");
          panels.forEach(function (panel) {
            if (panel.id === target.getAttribute("aria-controls")) {
              panel.classList.add("is-selected");
              panel.closest(".popover__panel-list").style.height = "".concat(
                panel.clientHeight,
                "px",
              );
            } else {
              panel.classList.remove("is-selected");
            }
          });
        },
      },
      {
        key: "_onWindowClick",
        value: function _onWindowClick(event) {
          if (
            event.target.getAttribute("data-action") === "toggle-popover" ||
            event.target.closest('[data-action="toggle-popover"]')
          ) {
            return;
          }

          if (this.activePopover && !this.activePopover.contains(event.target)) {
            this._closeActivePopover();
          }
        },
      },
      {
        key: "_onLooseFocus",
        value: function _onLooseFocus(event) {
          if (
            this.activePopover &&
            event.relatedTarget !== null &&
            !this.activePopover.contains(event.relatedTarget)
          ) {
            this._closeActivePopover();
          }
        },
      },
      {
        key: "_windowResized",
        value: function _windowResized() {
          if (Responsive.getCurrentBreakpoint() === "phone" && this.activePopover) {
            this.activePopover.style.height = "".concat(
              window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom,
              "px",
            );
          }
        },
      },
    ]);

    return PopoverManager;
  })();

  var Currency = /*#__PURE__*/ (function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [
      {
        key: "formatMoney",

        /**
         * Format money values based on your shop currency settings
         *
         * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
         * @param  {String} format - shop money_format setting
         * @return {String} value - formatted value
         */
        value: function formatMoney(cents, format) {
          if (typeof cents === "string") {
            cents = cents.replace(".", "");
          }

          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || "${{amount}}";

          function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
          }

          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");

            if (isNaN(number) || number == null) {
              return 0;
            }

            number = (number / 100.0).toFixed(precision);
            var parts = number.split("."),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
          }

          var value = "";

          switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;

            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;

            case "amount_with_space_separator":
              value = formatWithDelimiters(cents, 2, " ", ".");
              break;

            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ",", ".");
              break;

            case "amount_no_decimals_with_space_separator":
              value = formatWithDelimiters(cents, 0, " ");
              break;

            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 2, ".", ",");
              break;
          }

          if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString.replace(placeholderRegex, value);
          } else {
            return formatString.replace(placeholderRegex, value);
          }
        },
      },
    ]);

    return Currency;
  })();

  /**
   * This implementation allows to serialize a form
   */
  var Form = /*#__PURE__*/ (function () {
    function Form() {
      _classCallCheck(this, Form);
    }

    _createClass(Form, null, [
      {
        key: "serialize",
        value: function serialize(form) {
          function stringKey(key, value) {
            var beginBracket = key.lastIndexOf("[");

            if (beginBracket === -1) {
              var _hash = {};
              _hash[key] = value;
              return _hash;
            }

            var newKey = key.substr(0, beginBracket);
            var newValue = {};
            newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
            return stringKey(newKey, newValue);
          }

          var hash = {};

          for (var i = 0, len = form.elements.length; i < len; i++) {
            var formElement = form.elements[i];

            if (formElement.name === "" || formElement.disabled) {
              continue;
            }

            if (
              formElement.name &&
              !formElement.disabled &&
              (formElement.checked ||
                /select|textarea/i.test(formElement.nodeName) ||
                /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                  formElement.type,
                ))
            ) {
              var stringKeys = stringKey(formElement.name, formElement.value);
              hash = Form.extend(hash, stringKeys);
            }
          }

          return hash;
        },
      },
      {
        key: "extend",
        value: function extend() {
          var extended = {};
          var i = 0; // Merge the object into the extended object

          var merge = function merge(obj) {
            for (var prop in obj) {
              if (obj.hasOwnProperty(prop)) {
                // If property is an object, merge properties
                if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                  extended[prop] = Form.extend(extended[prop], obj[prop]);
                } else {
                  extended[prop] = obj[prop];
                }
              }
            }
          }; // Loop through each object and conduct a merge

          for (; i < arguments.length; i++) {
            merge(arguments[i]);
          }

          return extended;
        },
      },
    ]);

    return Form;
  })();

  function _typeof$1(obj) {
    if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
      _typeof$1 = function _typeof$1(obj) {
        return _typeof(obj);
      };
    } else {
      _typeof$1 = function _typeof$1(obj) {
        return obj &&
          typeof Symbol === "function" &&
          obj.constructor === Symbol &&
          obj !== Symbol.prototype
          ? "symbol"
          : _typeof(obj);
      };
    }

    return _typeof$1(obj);
  } // This is not really a perfect check, but works fine.
  // From http://stackoverflow.com/questions/384286

  var HAS_DOM_2 =
    (typeof HTMLElement === "undefined" ? "undefined" : _typeof$1(HTMLElement)) === "object";
  function isDOMElement(obj) {
    return HAS_DOM_2
      ? obj instanceof HTMLElement
      : obj &&
          _typeof$1(obj) === "object" &&
          obj !== null &&
          obj.nodeType === 1 &&
          typeof obj.nodeName === "string";
  }
  function addClasses(el, classNames) {
    classNames.forEach(function (className) {
      el.classList.add(className);
    });
  }
  function removeClasses(el, classNames) {
    classNames.forEach(function (className) {
      el.classList.remove(className);
    });
  }

  /* UNMINIFIED RULES

  const RULES = `
  @keyframes noop {
    0% { zoom: 1; }
  }

  @-webkit-keyframes noop {
    0% { zoom: 1; }
  }

  .drift-zoom-pane.drift-open {
    display: block;
  }

  .drift-zoom-pane.drift-opening, .drift-zoom-pane.drift-closing {
    animation: noop 1ms;
    -webkit-animation: noop 1ms;
  }

  .drift-zoom-pane {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  .drift-zoom-pane-loader {
    display: none;
  }

  .drift-zoom-pane img {
    position: absolute;
    display: block;
    max-width: none;
    max-height: none;
  }

  .drift-bounding-box {
    position: absolute;
    pointer-events: none;
  }
  `;

  */
  var RULES =
    ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
  function injectBaseStylesheet() {
    if (document.querySelector(".drift-base-styles")) {
      return;
    }

    var styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.classList.add("drift-base-styles");
    styleEl.appendChild(document.createTextNode(RULES));
    var head = document.head;
    head.insertBefore(styleEl, head.firstChild);
  }

  function throwIfMissing() {
    throw new Error("Missing parameter");
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  var BoundingBox = /*#__PURE__*/ (function () {
    function BoundingBox(options) {
      _classCallCheck$1(this, BoundingBox);

      this.isShowing = false;
      var _options$namespace = options.namespace,
        namespace = _options$namespace === void 0 ? null : _options$namespace,
        _options$zoomFactor = options.zoomFactor,
        zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
        _options$containerEl = options.containerEl,
        containerEl = _options$containerEl === void 0 ? throwIfMissing() : _options$containerEl;
      this.settings = {
        namespace: namespace,
        zoomFactor: zoomFactor,
        containerEl: containerEl,
      };
      this.openClasses = this._buildClasses("open");

      this._buildElement();
    }

    _createClass$1(BoundingBox, [
      {
        key: "_buildClasses",
        value: function _buildClasses(suffix) {
          var classes = ["drift-".concat(suffix)];
          var ns = this.settings.namespace;

          if (ns) {
            classes.push("".concat(ns, "-").concat(suffix));
          }

          return classes;
        },
      },
      {
        key: "_buildElement",
        value: function _buildElement() {
          this.el = document.createElement("div");
          addClasses(this.el, this._buildClasses("bounding-box"));
        },
      },
      {
        key: "show",
        value: function show(zoomPaneWidth, zoomPaneHeight) {
          this.isShowing = true;
          this.settings.containerEl.appendChild(this.el);
          var style = this.el.style;
          style.width = "".concat(Math.round(zoomPaneWidth / this.settings.zoomFactor), "px");
          style.height = "".concat(Math.round(zoomPaneHeight / this.settings.zoomFactor), "px");
          addClasses(this.el, this.openClasses);
        },
      },
      {
        key: "hide",
        value: function hide() {
          if (this.isShowing) {
            this.settings.containerEl.removeChild(this.el);
          }

          this.isShowing = false;
          removeClasses(this.el, this.openClasses);
        },
      },
      {
        key: "setPosition",
        value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
          var pageXOffset = window.pageXOffset;
          var pageYOffset = window.pageYOffset;
          var inlineLeft =
            triggerRect.left +
            percentageOffsetX * triggerRect.width -
            this.el.clientWidth / 2 +
            pageXOffset;
          var inlineTop =
            triggerRect.top +
            percentageOffsetY * triggerRect.height -
            this.el.clientHeight / 2 +
            pageYOffset;

          if (inlineLeft < triggerRect.left + pageXOffset) {
            inlineLeft = triggerRect.left + pageXOffset;
          } else if (
            inlineLeft + this.el.clientWidth >
            triggerRect.left + triggerRect.width + pageXOffset
          ) {
            inlineLeft = triggerRect.left + triggerRect.width - this.el.clientWidth + pageXOffset;
          }

          if (inlineTop < triggerRect.top + pageYOffset) {
            inlineTop = triggerRect.top + pageYOffset;
          } else if (
            inlineTop + this.el.clientHeight >
            triggerRect.top + triggerRect.height + pageYOffset
          ) {
            inlineTop = triggerRect.top + triggerRect.height - this.el.clientHeight + pageYOffset;
          }

          this.el.style.left = "".concat(inlineLeft, "px");
          this.el.style.top = "".concat(inlineTop, "px");
        },
      },
    ]);

    return BoundingBox;
  })();

  function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
  }

  var Trigger = /*#__PURE__*/ (function () {
    function Trigger() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck$2(this, Trigger);

      this._show = this._show.bind(this);
      this._hide = this._hide.bind(this);
      this._handleEntry = this._handleEntry.bind(this);
      this._handleMovement = this._handleMovement.bind(this);
      var _options$el = options.el,
        el = _options$el === void 0 ? throwIfMissing() : _options$el,
        _options$zoomPane = options.zoomPane,
        zoomPane = _options$zoomPane === void 0 ? throwIfMissing() : _options$zoomPane,
        _options$sourceAttrib = options.sourceAttribute,
        sourceAttribute =
          _options$sourceAttrib === void 0 ? throwIfMissing() : _options$sourceAttrib,
        _options$handleTouch = options.handleTouch,
        handleTouch = _options$handleTouch === void 0 ? throwIfMissing() : _options$handleTouch,
        _options$onShow = options.onShow,
        onShow = _options$onShow === void 0 ? null : _options$onShow,
        _options$onHide = options.onHide,
        onHide = _options$onHide === void 0 ? null : _options$onHide,
        _options$hoverDelay = options.hoverDelay,
        hoverDelay = _options$hoverDelay === void 0 ? 0 : _options$hoverDelay,
        _options$touchDelay = options.touchDelay,
        touchDelay = _options$touchDelay === void 0 ? 0 : _options$touchDelay,
        _options$hoverBoundin = options.hoverBoundingBox,
        hoverBoundingBox =
          _options$hoverBoundin === void 0 ? throwIfMissing() : _options$hoverBoundin,
        _options$touchBoundin = options.touchBoundingBox,
        touchBoundingBox =
          _options$touchBoundin === void 0 ? throwIfMissing() : _options$touchBoundin,
        _options$namespace = options.namespace,
        namespace = _options$namespace === void 0 ? null : _options$namespace,
        _options$zoomFactor = options.zoomFactor,
        zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
        _options$boundingBoxC = options.boundingBoxContainer,
        boundingBoxContainer =
          _options$boundingBoxC === void 0 ? throwIfMissing() : _options$boundingBoxC;
      this.settings = {
        el: el,
        zoomPane: zoomPane,
        sourceAttribute: sourceAttribute,
        handleTouch: handleTouch,
        onShow: onShow,
        onHide: onHide,
        hoverDelay: hoverDelay,
        touchDelay: touchDelay,
        hoverBoundingBox: hoverBoundingBox,
        touchBoundingBox: touchBoundingBox,
        namespace: namespace,
        zoomFactor: zoomFactor,
        boundingBoxContainer: boundingBoxContainer,
      };

      if (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) {
        this.boundingBox = new BoundingBox({
          namespace: this.settings.namespace,
          zoomFactor: this.settings.zoomFactor,
          containerEl: this.settings.boundingBoxContainer,
        });
      }

      this.enabled = true;

      this._bindEvents();
    }

    _createClass$2(Trigger, [
      {
        key: "_preventDefault",
        value: function _preventDefault(event) {
          event.preventDefault();
        },
      },
      {
        key: "_preventDefaultAllowTouchScroll",
        value: function _preventDefaultAllowTouchScroll(event) {
          if (!this.settings.touchDelay || !this._isTouchEvent(event) || this.isShowing) {
            event.preventDefault();
          }
        },
      },
      {
        key: "_isTouchEvent",
        value: function _isTouchEvent(event) {
          return !!event.touches;
        },
      },
      {
        key: "_bindEvents",
        value: function _bindEvents() {
          this.settings.el.addEventListener("mouseenter", this._handleEntry, false);
          this.settings.el.addEventListener("mouseleave", this._hide, false);
          this.settings.el.addEventListener("mousemove", this._handleMovement, false);

          if (this.settings.handleTouch) {
            this.settings.el.addEventListener("touchstart", this._handleEntry, false);
            this.settings.el.addEventListener("touchend", this._hide, false);
            this.settings.el.addEventListener("touchmove", this._handleMovement, false);
          } else {
            this.settings.el.addEventListener("touchstart", this._preventDefault, false);
            this.settings.el.addEventListener("touchend", this._preventDefault, false);
            this.settings.el.addEventListener("touchmove", this._preventDefault, false);
          }
        },
      },
      {
        key: "_unbindEvents",
        value: function _unbindEvents() {
          this.settings.el.removeEventListener("mouseenter", this._handleEntry, false);
          this.settings.el.removeEventListener("mouseleave", this._hide, false);
          this.settings.el.removeEventListener("mousemove", this._handleMovement, false);

          if (this.settings.handleTouch) {
            this.settings.el.removeEventListener("touchstart", this._handleEntry, false);
            this.settings.el.removeEventListener("touchend", this._hide, false);
            this.settings.el.removeEventListener("touchmove", this._handleMovement, false);
          } else {
            this.settings.el.removeEventListener("touchstart", this._preventDefault, false);
            this.settings.el.removeEventListener("touchend", this._preventDefault, false);
            this.settings.el.removeEventListener("touchmove", this._preventDefault, false);
          }
        },
      },
      {
        key: "_handleEntry",
        value: function _handleEntry(e) {
          this._preventDefaultAllowTouchScroll(e);

          this._lastMovement = e;

          if (e.type == "mouseenter" && this.settings.hoverDelay) {
            this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay);
          } else if (this.settings.touchDelay) {
            this.entryTimeout = setTimeout(this._show, this.settings.touchDelay);
          } else {
            this._show();
          }
        },
      },
      {
        key: "_show",
        value: function _show() {
          if (!this.enabled) {
            return;
          }

          var onShow = this.settings.onShow;

          if (onShow && typeof onShow === "function") {
            onShow();
          }

          this.settings.zoomPane.show(
            this.settings.el.getAttribute(this.settings.sourceAttribute),
            this.settings.el.clientWidth,
            this.settings.el.clientHeight,
          );

          if (this._lastMovement) {
            var touchActivated = this._lastMovement.touches;

            if (
              (touchActivated && this.settings.touchBoundingBox) ||
              (!touchActivated && this.settings.hoverBoundingBox)
            ) {
              this.boundingBox.show(
                this.settings.zoomPane.el.clientWidth,
                this.settings.zoomPane.el.clientHeight,
              );
            }
          }

          this._handleMovement();
        },
      },
      {
        key: "_hide",
        value: function _hide(e) {
          if (e) {
            this._preventDefaultAllowTouchScroll(e);
          }

          this._lastMovement = null;

          if (this.entryTimeout) {
            clearTimeout(this.entryTimeout);
          }

          if (this.boundingBox) {
            this.boundingBox.hide();
          }

          var onHide = this.settings.onHide;

          if (onHide && typeof onHide === "function") {
            onHide();
          }

          this.settings.zoomPane.hide();
        },
      },
      {
        key: "_handleMovement",
        value: function _handleMovement(e) {
          if (e) {
            this._preventDefaultAllowTouchScroll(e);

            this._lastMovement = e;
          } else if (this._lastMovement) {
            e = this._lastMovement;
          } else {
            return;
          }

          var movementX;
          var movementY;

          if (e.touches) {
            var firstTouch = e.touches[0];
            movementX = firstTouch.clientX;
            movementY = firstTouch.clientY;
          } else {
            movementX = e.clientX;
            movementY = e.clientY;
          }

          var el = this.settings.el;
          var rect = el.getBoundingClientRect();
          var offsetX = movementX - rect.left;
          var offsetY = movementY - rect.top;
          var percentageOffsetX = offsetX / this.settings.el.clientWidth;
          var percentageOffsetY = offsetY / this.settings.el.clientHeight;

          if (this.boundingBox) {
            this.boundingBox.setPosition(percentageOffsetX, percentageOffsetY, rect);
          }

          this.settings.zoomPane.setPosition(percentageOffsetX, percentageOffsetY, rect);
        },
      },
      {
        key: "isShowing",
        get: function get() {
          return this.settings.zoomPane.isShowing;
        },
      },
    ]);

    return Trigger;
  })();

  function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$3(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$3(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$3(Constructor, staticProps);
    return Constructor;
  }
  // account for, just in case.

  var divStyle = document.createElement("div").style;
  var HAS_ANIMATION =
    typeof document === "undefined"
      ? false
      : "animation" in divStyle || "webkitAnimation" in divStyle;

  var ZoomPane = /*#__PURE__*/ (function () {
    function ZoomPane() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck$3(this, ZoomPane);

      this._completeShow = this._completeShow.bind(this);
      this._completeHide = this._completeHide.bind(this);
      this._handleLoad = this._handleLoad.bind(this);
      this.isShowing = false;
      var _options$container = options.container,
        container = _options$container === void 0 ? null : _options$container,
        _options$zoomFactor = options.zoomFactor,
        zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
        _options$inline = options.inline,
        inline = _options$inline === void 0 ? throwIfMissing() : _options$inline,
        _options$namespace = options.namespace,
        namespace = _options$namespace === void 0 ? null : _options$namespace,
        _options$showWhitespa = options.showWhitespaceAtEdges,
        showWhitespaceAtEdges =
          _options$showWhitespa === void 0 ? throwIfMissing() : _options$showWhitespa,
        _options$containInlin = options.containInline,
        containInline = _options$containInlin === void 0 ? throwIfMissing() : _options$containInlin,
        _options$inlineOffset = options.inlineOffsetX,
        inlineOffsetX = _options$inlineOffset === void 0 ? 0 : _options$inlineOffset,
        _options$inlineOffset2 = options.inlineOffsetY,
        inlineOffsetY = _options$inlineOffset2 === void 0 ? 0 : _options$inlineOffset2,
        _options$inlineContai = options.inlineContainer,
        inlineContainer = _options$inlineContai === void 0 ? document.body : _options$inlineContai;
      this.settings = {
        container: container,
        zoomFactor: zoomFactor,
        inline: inline,
        namespace: namespace,
        showWhitespaceAtEdges: showWhitespaceAtEdges,
        containInline: containInline,
        inlineOffsetX: inlineOffsetX,
        inlineOffsetY: inlineOffsetY,
        inlineContainer: inlineContainer,
      };
      this.openClasses = this._buildClasses("open");
      this.openingClasses = this._buildClasses("opening");
      this.closingClasses = this._buildClasses("closing");
      this.inlineClasses = this._buildClasses("inline");
      this.loadingClasses = this._buildClasses("loading");

      this._buildElement();
    }

    _createClass$3(ZoomPane, [
      {
        key: "_buildClasses",
        value: function _buildClasses(suffix) {
          var classes = ["drift-".concat(suffix)];
          var ns = this.settings.namespace;

          if (ns) {
            classes.push("".concat(ns, "-").concat(suffix));
          }

          return classes;
        },
      },
      {
        key: "_buildElement",
        value: function _buildElement() {
          this.el = document.createElement("div");
          addClasses(this.el, this._buildClasses("zoom-pane"));
          var loaderEl = document.createElement("div");
          addClasses(loaderEl, this._buildClasses("zoom-pane-loader"));
          this.el.appendChild(loaderEl);
          this.imgEl = document.createElement("img");
          this.el.appendChild(this.imgEl);
        },
      },
      {
        key: "_setImageURL",
        value: function _setImageURL(imageURL) {
          this.imgEl.setAttribute("src", imageURL);
        },
      },
      {
        key: "_setImageSize",
        value: function _setImageSize(triggerWidth, triggerHeight) {
          this.imgEl.style.width = "".concat(triggerWidth * this.settings.zoomFactor, "px");
          this.imgEl.style.height = "".concat(triggerHeight * this.settings.zoomFactor, "px");
        }, // `percentageOffsetX` and `percentageOffsetY` must be percentages
        // expressed as floats between `0' and `1`.
      },
      {
        key: "setPosition",
        value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
          var imgElWidth = this.imgEl.offsetWidth;
          var imgElHeight = this.imgEl.offsetHeight;
          var elWidth = this.el.offsetWidth;
          var elHeight = this.el.offsetHeight;
          var centreOfContainerX = elWidth / 2;
          var centreOfContainerY = elHeight / 2;
          var targetImgXToBeCentre = imgElWidth * percentageOffsetX;
          var targetImgYToBeCentre = imgElHeight * percentageOffsetY;
          var left = centreOfContainerX - targetImgXToBeCentre;
          var top = centreOfContainerY - targetImgYToBeCentre;
          var differenceBetweenContainerWidthAndImgWidth = elWidth - imgElWidth;
          var differenceBetweenContainerHeightAndImgHeight = elHeight - imgElHeight;
          var isContainerLargerThanImgX = differenceBetweenContainerWidthAndImgWidth > 0;
          var isContainerLargerThanImgY = differenceBetweenContainerHeightAndImgHeight > 0;
          var minLeft = isContainerLargerThanImgX
            ? differenceBetweenContainerWidthAndImgWidth / 2
            : 0;
          var minTop = isContainerLargerThanImgY
            ? differenceBetweenContainerHeightAndImgHeight / 2
            : 0;
          var maxLeft = isContainerLargerThanImgX
            ? differenceBetweenContainerWidthAndImgWidth / 2
            : differenceBetweenContainerWidthAndImgWidth;
          var maxTop = isContainerLargerThanImgY
            ? differenceBetweenContainerHeightAndImgHeight / 2
            : differenceBetweenContainerHeightAndImgHeight;

          if (this.el.parentElement === this.settings.inlineContainer) {
            // This may be needed in the future to deal with browser event
            // inconsistencies, but it's difficult to tell for sure.
            // let scrollX = isTouch ? 0 : window.scrollX;
            // let scrollY = isTouch ? 0 : window.scrollY;
            var scrollX = window.pageXOffset;
            var scrollY = window.pageYOffset;
            var inlineLeft =
              triggerRect.left +
              percentageOffsetX * triggerRect.width -
              elWidth / 2 +
              this.settings.inlineOffsetX +
              scrollX;
            var inlineTop =
              triggerRect.top +
              percentageOffsetY * triggerRect.height -
              elHeight / 2 +
              this.settings.inlineOffsetY +
              scrollY;

            if (this.settings.containInline) {
              if (inlineLeft < triggerRect.left + scrollX) {
                inlineLeft = triggerRect.left + scrollX;
              } else if (inlineLeft + elWidth > triggerRect.left + triggerRect.width + scrollX) {
                inlineLeft = triggerRect.left + triggerRect.width - elWidth + scrollX;
              }

              if (inlineTop < triggerRect.top + scrollY) {
                inlineTop = triggerRect.top + scrollY;
              } else if (inlineTop + elHeight > triggerRect.top + triggerRect.height + scrollY) {
                inlineTop = triggerRect.top + triggerRect.height - elHeight + scrollY;
              }
            }

            this.el.style.left = "".concat(inlineLeft, "px");
            this.el.style.top = "".concat(inlineTop, "px");
          }

          if (!this.settings.showWhitespaceAtEdges) {
            if (left > minLeft) {
              left = minLeft;
            } else if (left < maxLeft) {
              left = maxLeft;
            }

            if (top > minTop) {
              top = minTop;
            } else if (top < maxTop) {
              top = maxTop;
            }
          }

          this.imgEl.style.transform = "translate(".concat(left, "px, ").concat(top, "px)");
          this.imgEl.style.webkitTransform = "translate(".concat(left, "px, ").concat(top, "px)");
        },
      },
      {
        key: "_removeListenersAndResetClasses",
        value: function _removeListenersAndResetClasses() {
          this.el.removeEventListener("animationend", this._completeShow, false);
          this.el.removeEventListener("animationend", this._completeHide, false);
          this.el.removeEventListener("webkitAnimationEnd", this._completeShow, false);
          this.el.removeEventListener("webkitAnimationEnd", this._completeHide, false);
          removeClasses(this.el, this.openClasses);
          removeClasses(this.el, this.closingClasses);
        },
      },
      {
        key: "show",
        value: function show(imageURL, triggerWidth, triggerHeight) {
          this._removeListenersAndResetClasses();

          this.isShowing = true;
          addClasses(this.el, this.openClasses);

          if (this.imgEl.getAttribute("src") != imageURL) {
            addClasses(this.el, this.loadingClasses);
            this.imgEl.addEventListener("load", this._handleLoad, false);

            this._setImageURL(imageURL);
          }

          this._setImageSize(triggerWidth, triggerHeight);

          if (this._isInline) {
            this._showInline();
          } else {
            this._showInContainer();
          }

          if (HAS_ANIMATION) {
            this.el.addEventListener("animationend", this._completeShow, false);
            this.el.addEventListener("webkitAnimationEnd", this._completeShow, false);
            addClasses(this.el, this.openingClasses);
          }
        },
      },
      {
        key: "_showInline",
        value: function _showInline() {
          this.settings.inlineContainer.appendChild(this.el);
          addClasses(this.el, this.inlineClasses);
        },
      },
      {
        key: "_showInContainer",
        value: function _showInContainer() {
          this.settings.container.appendChild(this.el);
        },
      },
      {
        key: "hide",
        value: function hide() {
          this._removeListenersAndResetClasses();

          this.isShowing = false;

          if (HAS_ANIMATION) {
            this.el.addEventListener("animationend", this._completeHide, false);
            this.el.addEventListener("webkitAnimationEnd", this._completeHide, false);
            addClasses(this.el, this.closingClasses);
          } else {
            removeClasses(this.el, this.openClasses);
            removeClasses(this.el, this.inlineClasses);
          }
        },
      },
      {
        key: "_completeShow",
        value: function _completeShow() {
          this.el.removeEventListener("animationend", this._completeShow, false);
          this.el.removeEventListener("webkitAnimationEnd", this._completeShow, false);
          removeClasses(this.el, this.openingClasses);
        },
      },
      {
        key: "_completeHide",
        value: function _completeHide() {
          this.el.removeEventListener("animationend", this._completeHide, false);
          this.el.removeEventListener("webkitAnimationEnd", this._completeHide, false);
          removeClasses(this.el, this.openClasses);
          removeClasses(this.el, this.closingClasses);
          removeClasses(this.el, this.inlineClasses);
          this.el.setAttribute("style", ""); // The window could have been resized above or below `inline`
          // limits since the ZoomPane was shown. Because of this, we
          // can't rely on `this._isInline` here.

          if (this.el.parentElement === this.settings.container) {
            this.settings.container.removeChild(this.el);
          } else if (this.el.parentElement === this.settings.inlineContainer) {
            this.settings.inlineContainer.removeChild(this.el);
          }
        },
      },
      {
        key: "_handleLoad",
        value: function _handleLoad() {
          this.imgEl.removeEventListener("load", this._handleLoad, false);
          removeClasses(this.el, this.loadingClasses);
        },
      },
      {
        key: "_isInline",
        get: function get() {
          var inline = this.settings.inline;
          return inline === true || (typeof inline === "number" && window.innerWidth <= inline);
        },
      },
    ]);

    return ZoomPane;
  })();

  function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$4(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$4(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$4(Constructor, staticProps);
    return Constructor;
  }

  var Drift = /*#__PURE__*/ (function () {
    function Drift(triggerEl) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck$4(this, Drift);

      this.VERSION = "1.4.0";
      this.triggerEl = triggerEl;
      this.destroy = this.destroy.bind(this);

      if (!isDOMElement(this.triggerEl)) {
        throw new TypeError("`new Drift` requires a DOM element as its first argument.");
      } // Prefix for generated element class names (e.g. `my-ns` will
      // result in classes such as `my-ns-pane`. Default `drift-`
      // prefixed classes will always be added as well.

      var namespace = options["namespace"] || null; // Whether the ZoomPane should show whitespace when near the edges.

      var showWhitespaceAtEdges = options["showWhitespaceAtEdges"] || false; // Whether the inline ZoomPane should stay inside
      // the bounds of its image.

      var containInline = options["containInline"] || false; // How much to offset the ZoomPane from the
      // interaction point when inline.

      var inlineOffsetX = options["inlineOffsetX"] || 0;
      var inlineOffsetY = options["inlineOffsetY"] || 0; // A DOM element to append the inline ZoomPane to

      var inlineContainer = options["inlineContainer"] || document.body; // Which trigger attribute to pull the ZoomPane image source from.

      var sourceAttribute = options["sourceAttribute"] || "data-zoom"; // How much to magnify the trigger by in the ZoomPane.
      // (e.g., `zoomFactor: 3` will result in a 900 px wide ZoomPane imag
      // if the trigger is displayed at 300 px wide)

      var zoomFactor = options["zoomFactor"] || 3; // A DOM element to append the non-inline ZoomPane to.
      // Required if `inlinePane !== true`.

      var paneContainer =
        options["paneContainer"] === undefined ? document.body : options["paneContainer"]; // When to switch to an inline ZoomPane. This can be a boolean or
      // an integer. If `true`, the ZoomPane will always be inline,
      // if `false`, it will switch to inline when `windowWidth <= inlinePane`

      var inlinePane = options["inlinePane"] || 375; // If `true`, touch events will trigger the zoom, like mouse events.

      var handleTouch = "handleTouch" in options ? !!options["handleTouch"] : true; // If present (and a function), this will be called
      // whenever the ZoomPane is shown.

      var onShow = options["onShow"] || null; // If present (and a function), this will be called
      // whenever the ZoomPane is hidden.

      var onHide = options["onHide"] || null; // Add base styles to the page. See the "Theming"
      // section of README.md for more information.

      var injectBaseStyles = "injectBaseStyles" in options ? !!options["injectBaseStyles"] : true; // An optional number that determines how long to wait before
      // showing the ZoomPane because of a `mouseenter` event.

      var hoverDelay = options["hoverDelay"] || 0; // An optional number that determines how long to wait before
      // showing the ZoomPane because of a `touchstart` event.
      // It's unlikely that you would want to use this option, since
      // "tap and hold" is much more intentional than a hover event.

      var touchDelay = options["touchDelay"] || 0; // If true, a bounding box will show the area currently being previewed
      // during mouse hover

      var hoverBoundingBox = options["hoverBoundingBox"] || false; // If true, a bounding box will show the area currently being previewed
      // during touch events

      var touchBoundingBox = options["touchBoundingBox"] || false; // A DOM element to append the bounding box to.

      var boundingBoxContainer = options["boundingBoxContainer"] || document.body;

      if (inlinePane !== true && !isDOMElement(paneContainer)) {
        throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
      }

      if (!isDOMElement(inlineContainer)) {
        throw new TypeError("`inlineContainer` must be a DOM element");
      }

      this.settings = {
        namespace: namespace,
        showWhitespaceAtEdges: showWhitespaceAtEdges,
        containInline: containInline,
        inlineOffsetX: inlineOffsetX,
        inlineOffsetY: inlineOffsetY,
        inlineContainer: inlineContainer,
        sourceAttribute: sourceAttribute,
        zoomFactor: zoomFactor,
        paneContainer: paneContainer,
        inlinePane: inlinePane,
        handleTouch: handleTouch,
        onShow: onShow,
        onHide: onHide,
        injectBaseStyles: injectBaseStyles,
        hoverDelay: hoverDelay,
        touchDelay: touchDelay,
        hoverBoundingBox: hoverBoundingBox,
        touchBoundingBox: touchBoundingBox,
        boundingBoxContainer: boundingBoxContainer,
      };

      if (this.settings.injectBaseStyles) {
        injectBaseStylesheet();
      }

      this._buildZoomPane();

      this._buildTrigger();
    }

    _createClass$4(Drift, [
      {
        key: "_buildZoomPane",
        value: function _buildZoomPane() {
          this.zoomPane = new ZoomPane({
            container: this.settings.paneContainer,
            zoomFactor: this.settings.zoomFactor,
            showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
            containInline: this.settings.containInline,
            inline: this.settings.inlinePane,
            namespace: this.settings.namespace,
            inlineOffsetX: this.settings.inlineOffsetX,
            inlineOffsetY: this.settings.inlineOffsetY,
            inlineContainer: this.settings.inlineContainer,
          });
        },
      },
      {
        key: "_buildTrigger",
        value: function _buildTrigger() {
          this.trigger = new Trigger({
            el: this.triggerEl,
            zoomPane: this.zoomPane,
            handleTouch: this.settings.handleTouch,
            onShow: this.settings.onShow,
            onHide: this.settings.onHide,
            sourceAttribute: this.settings.sourceAttribute,
            hoverDelay: this.settings.hoverDelay,
            touchDelay: this.settings.touchDelay,
            hoverBoundingBox: this.settings.hoverBoundingBox,
            touchBoundingBox: this.settings.touchBoundingBox,
            namespace: this.settings.namespace,
            zoomFactor: this.settings.zoomFactor,
            boundingBoxContainer: this.settings.boundingBoxContainer,
          });
        },
      },
      {
        key: "setZoomImageURL",
        value: function setZoomImageURL(imageURL) {
          this.zoomPane._setImageURL(imageURL);
        },
      },
      {
        key: "disable",
        value: function disable() {
          this.trigger.enabled = false;
        },
      },
      {
        key: "enable",
        value: function enable() {
          this.trigger.enabled = true;
        },
      },
      {
        key: "destroy",
        value: function destroy() {
          this.trigger._hide();

          this.trigger._unbindEvents();
        },
      },
      {
        key: "isShowing",
        get: function get() {
          return this.zoomPane.isShowing;
        },
      },
      {
        key: "zoomFactor",
        get: function get() {
          return this.settings.zoomFactor;
        },
        set: function set(zf) {
          this.settings.zoomFactor = zf;
          this.zoomPane.settings.zoomFactor = zf;
          this.trigger.settings.zoomFactor = zf;
          this.boundingBox.settings.zoomFactor = zf;
        },
      },
    ]);

    return Drift;
  })(); // Public API
  Object.defineProperty(Drift.prototype, "isShowing", {
    get: function get() {
      return this.isShowing;
    },
  });
  Object.defineProperty(Drift.prototype, "zoomFactor", {
    get: function get() {
      return this.zoomFactor;
    },
    set: function set(value) {
      this.zoomFactor = value;
    },
  });
  Drift.prototype["setZoomImageURL"] = Drift.prototype.setZoomImageURL;
  Drift.prototype["disable"] = Drift.prototype.disable;
  Drift.prototype["enable"] = Drift.prototype.enable;
  Drift.prototype["destroy"] = Drift.prototype.destroy;
  /* eslint-enable no-self-assign */

  var QuantityPicker = /*#__PURE__*/ (function () {
    function QuantityPicker(element) {
      _classCallCheck(this, QuantityPicker);

      if (!element) {
        return;
      }

      this.element = element;
      this.inputElement = this.element.querySelector('[name="quantity"]');
      this.delegateElement = new Delegate(this.element);

      this._attachListeners();
    }

    _createClass(QuantityPicker, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="decrease-picker-quantity"]',
            this._onDecrease.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="increase-picker-quantity"]',
            this._onIncrease.bind(this),
          );
          this.delegateElement.on("keyup", this._onInputValueChanged.bind(this));
          this.delegateElement.on("focusout", this._onInputFocusOut.bind(this));
        },
      },
      {
        key: "_onDecrease",
        value: function _onDecrease() {
          this.inputElement.value = Math.max(1, parseInt(this.inputElement.value) - 1);
        },
      },
      {
        key: "_onIncrease",
        value: function _onIncrease() {
          this.inputElement.value = parseInt(this.inputElement.value) + 1;
        },
      },
      {
        key: "_onInputValueChanged",
        value: function _onInputValueChanged(event) {
          var value = event.target.value;

          if (value !== "" && isNaN(value)) {
            event.target.value = Math.max(1, parseInt(value) || 1);
          }
        },
      },
      {
        key: "_onInputFocusOut",
        value: function _onInputFocusOut(event) {
          event.target.value = Math.max(1, parseInt(event.target.value) || 1);
        },
      },
    ]);

    return QuantityPicker;
  })();

  var ShippingEstimator = /*#__PURE__*/ (function () {
    function ShippingEstimator(element, options) {
      _classCallCheck(this, ShippingEstimator);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.options = options;
      this.countrySelector = new CountrySelector(
        this.element.querySelector('[name="country"]'),
        this.element.querySelector('[name="province"]'),
      );

      this._attachListeners();
    }

    _createClass(ShippingEstimator, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off("click");
          this.countrySelector.destroy();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="estimate-shipping"]',
            this._fetchRates.bind(this),
          );
        },
      },
      {
        key: "_fetchRates",
        value: function _fetchRates() {
          document.dispatchEvent(new CustomEvent("theme:loading:start"));

          if (this.options["singleProduct"]) {
            this._fetchRatesForProduct();
          } else {
            this._fetchRatesForCart();
          }
        },
      },
      {
        key: "_fetchRatesForCart",
        value: function _fetchRatesForCart() {
          var _this = this;

          var country = this.element.querySelector('[name="country"]').value,
            province = this.element.querySelector('[name="province"]').value,
            zip = this.element.querySelector('[name="zip"]').value;
          fetch(
            ""
              .concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=")
              .concat(zip, "&shipping_address[country]=")
              .concat(country, "&shipping_address[province]=")
              .concat(province),
            {
              credentials: "same-origin",
              method: "GET",
            },
          ).then(function (response) {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            response.json().then(function (result) {
              _this._formatResults(response.ok, result);
            });
          });
        },
        /**
         * Technique is coming from this website: https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
         */
      },
      {
        key: "_fetchRatesForProduct",
        value: function _fetchRatesForProduct() {
          var _this2 = this;

          // grab the current cookie for the cart and we store it
          var cartCookie = this._getCookie("cart"),
            tempCookieValue = "temp-cart-cookie___" + Date.now() + parseInt(Math.random() * 1000),
            fakeCookieValue = "fake-cart-cookie___" + Date.now() + parseInt(Math.random() * 1000); // if not found, make a new temp cookie

          if (!cartCookie) {
            this._updateCartCookie(tempCookieValue);

            cartCookie = this._getCookie("cart");
          } // if found but has a weird length, bail

          if (cartCookie.length < 32) {
            return;
          } // change the cookie value to a new 32 character value

          this._updateCartCookie(fakeCookieValue); // add the product to our fake cart

          var formElement = document.querySelector('form[action*="/cart/add"]');
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(Form.serialize(formElement)),
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
            method: "POST",
          }).then(function (response) {
            response
              .json()
              .then(function () {
                var country = _this2.element.querySelector('[name="country"]').value,
                  province = _this2.element.querySelector('[name="province"]').value,
                  zip = _this2.element.querySelector('[name="zip"]').value;

                fetch(
                  ""
                    .concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=")
                    .concat(zip, "&shipping_address[country]=")
                    .concat(country, "&shipping_address[province]=")
                    .concat(province),
                  {
                    credentials: "same-origin",
                    method: "GET",
                  },
                )
                  .then(function (response) {
                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                    response.json().then(function (result) {
                      _this2._formatResults(response.ok, result);
                    });

                    _this2._updateCartCookie(cartCookie); // We can restore the cookie
                  })
                  ["catch"](function () {
                    _this2._updateCartCookie(cartCookie);
                  });
              })
              ["catch"](function () {
                // We have error so we have to reset cookie
                _this2._updateCartCookie(cartCookie);

                document.dispatchEvent(new CustomEvent("theme:loading:end"));
              });
          });
        },
      },
      {
        key: "_formatResults",
        value: function _formatResults(isOk, results) {
          var resultsElement = this.element.querySelector(".shipping-estimator__results");
          resultsElement.innerHTML = "";

          if (isOk) {
            var shippingRates = results["shipping_rates"];

            if (shippingRates.length === 0) {
              resultsElement.innerHTML = "<p>".concat(
                window.languages.shippingEstimatorNoResults,
                "</p>",
              );
            } else {
              if (shippingRates.length === 1) {
                resultsElement.innerHTML = "<p>".concat(
                  window.languages.shippingEstimatorOneResult,
                  "</p>",
                );
              } else {
                resultsElement.innerHTML = "<p>".concat(
                  window.languages.shippingEstimatorMultipleResults.replace(
                    "{{count}}",
                    shippingRates.length,
                  ),
                  "</p>",
                );
              }

              var listRatesHtml = "";
              shippingRates.forEach(function (item) {
                listRatesHtml += "<li>"
                  .concat(item["name"], ": ")
                  .concat(
                    Currency.formatMoney(parseInt(item["price"] * 100), window.theme.moneyFormat),
                    "</li>",
                  );
              });
              resultsElement.innerHTML += "<ul>".concat(listRatesHtml, "</ul>");
            }
          } else {
            resultsElement.innerHTML = "<p>".concat(
              window.languages.shippingEstimatorErrors,
              "</p>",
            );
            var errorHtml = "";
            Object.keys(results).forEach(function (key) {
              errorHtml += '<li class="alert__list-item">'
                .concat(key, " ")
                .concat(results[key], "</li>");
            });
            resultsElement.innerHTML += "<ul>".concat(errorHtml, "</ul>");
          }

          resultsElement.style.display = "block";
        },
      },
      {
        key: "_getCookie",
        value: function _getCookie(name) {
          var value = "; ".concat(document.cookie),
            parts = value.split("; " + name + "=");

          if (parts.length === 2) {
            return parts.pop().split(";").shift();
          }
        },
      },
      {
        key: "_updateCartCookie",
        value: function _updateCartCookie(value) {
          var date = new Date();
          date.setTime(date.getTime() + 14 * 86400000);
          document.cookie = "cart="
            .concat(value, "; expires=")
            .concat(date.toUTCString(), "; path=/");
        },
      },
    ]);

    return ShippingEstimator;
  })();

  /**
   * The given ID must be the value picker itself (the element that contains the class "value-picker", not the button that toggles it
   */

  var ValuePicker = /*#__PURE__*/ (function () {
    function ValuePicker(id) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, ValuePicker);

      this.id = id;
      this.delegateRoot = new Delegate(document.documentElement);
      this.isOpen = false;
      this.togglerElement = document.querySelector(
        '[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'),
      );

      this.onSelect = options["onValueSelect"] || function () {};

      this._attachListeners();
    }

    _createClass(ValuePicker, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateRoot.off();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateRoot.on(
            "click",
            '[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'),
            this._toggle.bind(this),
          );
          this.delegateRoot.on(
            "click",
            '[data-action="close-value-picker"][aria-controls="'.concat(this.id, '"]'),
            this._toggle.bind(this),
          );
          this.delegateRoot.on(
            "click",
            "#".concat(this.id, ' [data-action="select-value"]'),
            this._selectValue.bind(this),
          );
          this.delegateRoot.on("click", this._detectOutsideClick.bind(this), true);
          this.delegateRoot.on("focusout", "#".concat(this.id), this._onFocusOut.bind(this));
        },
      },
      {
        key: "_toggle",
        value: function _toggle(event) {
          if (this.isOpen) {
            this._close(event);
          } else {
            this._open(event);
          }
        },
      },
      {
        key: "_open",
        value: function _open() {
          document
            .querySelector(
              '[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'),
            )
            .setAttribute("aria-expanded", "true");
          document.getElementById(this.id).setAttribute("aria-hidden", "false"); // This is quite ugly, but in order to avoid an issue with the header that has a higher z-index, we have to temporarily reduce
          // it while we have the element open

          if (Responsive.matchesBreakpoint("phone")) {
            var headerElement = document.querySelector(".shopify-section__header");
            headerElement.style.zIndex = "3";
          }

          this.isOpen = true;
          document.body.classList.add("no-mobile-scroll");
        },
      },
      {
        key: "_close",
        value: function _close() {
          document
            .querySelector(
              '[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'),
            )
            .setAttribute("aria-expanded", "false");
          document.getElementById(this.id).setAttribute("aria-hidden", "true"); // This is quite ugly, but in order to avoid an issue with the header that has a higher z-index, we have to temporarily reduce
          // it while we have the element open

          var headerElement = document.querySelector(".shopify-section__header");
          headerElement.style.zIndex = "";
          this.isOpen = false;
          document.body.classList.remove("no-mobile-scroll");
        },
      },
      {
        key: "_selectValue",
        value: function _selectValue(event, target) {
          this.onSelect(target.getAttribute("data-value"));

          this._close();
        },
      },
      {
        key: "_onFocusOut",
        value: function _onFocusOut(event) {
          var container = document.getElementById(this.id); // If the element that get the new focus is not contains within the value picker, we close it

          if (!container.contains(event.relatedTarget)) {
            this._close();
          }
        },
      },
      {
        key: "_detectOutsideClick",
        value: function _detectOutsideClick(event) {
          // If already closed, nothing to do
          if (
            !this.isOpen ||
            this.togglerElement === event.target ||
            this.togglerElement.contains(event.target)
          ) {
            return;
          }

          if (!event.target.closest(".value-picker__inner") && this.isOpen) {
            this._close(event);
          }
        },
      },
    ]);

    return ValuePicker;
  })();

  var AccountSection = /*#__PURE__*/ (function () {
    function AccountSection(element) {
      _classCallCheck(this, AccountSection);

      this.element = element;
      this.domDelegate = new Delegate(this.element);
      this.element
        .querySelectorAll('[action*="/account/addresses"]')
        .forEach(function (addressForm) {
          new CountrySelector(
            addressForm.querySelector('[name="address[country]"]'),
            addressForm.querySelector('[name="address[province]"]'),
          );
        });
      this.pageSelector = new ValuePicker("account-selector");
    }

    _createClass(AccountSection, [
      {
        key: "_onUnload",
        value: function _onUnload() {
          this.pageSelector.destroy();
        },
      },
    ]);

    return AccountSection;
  })();

  var AnnouncementBarSection = /*#__PURE__*/ (function () {
    function AnnouncementBarSection(element) {
      _classCallCheck(this, AnnouncementBarSection);

      this.element = element;
      this.domDelegate = new Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      this.isOpen = false; // We set the new width of the announcement bar button if any

      if (this.options["showNewsletter"]) {
        document.documentElement.style.setProperty(
          "--announcement-bar-button-width",
          this.element.querySelector(".announcement-bar__button").clientWidth + "px",
        );
      } else {
        document.documentElement.style.removeProperty("--announcement-bar-button-width");
      }

      this._attachListeners();
    }

    _createClass(AnnouncementBarSection, [
      {
        key: "onSelect",
        value: function onSelect() {
          if (this.options["showNewsletter"] && !this.isOpen) {
            this._toggleNewsletter();
          }
        },
      },
      {
        key: "onDeselect",
        value: function onDeselect() {
          if (this.options["showNewsletter"] && this.isOpen) {
            this._toggleNewsletter();
          }
        },
      },
      {
        key: "onUnload",
        value: function onUnload() {
          this.domDelegate.off();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.domDelegate.on(
            "click",
            '[data-action="toggle-newsletter"]',
            this._toggleNewsletter.bind(this),
          );
          this.domDelegate.on("keyup", this._handleKey.bind(this));
        },
      },
      {
        key: "_toggleNewsletter",
        value: function _toggleNewsletter() {
          var togglerElement = this.element.querySelector(".announcement-bar__button"),
            newsletterElement = this.element.querySelector(".announcement-bar__newsletter");

          if (togglerElement.getAttribute("aria-expanded") === "false") {
            togglerElement.setAttribute("aria-expanded", "true");
            newsletterElement.setAttribute("aria-hidden", "false");
            Animation.slideDown(newsletterElement, function () {
              Accessibility.trapFocus(newsletterElement, "announcement-bar");
            });
          } else {
            togglerElement.setAttribute("aria-expanded", "false");
            newsletterElement.setAttribute("aria-hidden", "true");
            Animation.slideUp(newsletterElement);
            Accessibility.removeTrapFocus(newsletterElement, "announcement-bar");
          }

          this.isOpen = !this.isOpen;
        },
      },
      {
        key: "_handleKey",
        value: function _handleKey(event) {
          if (event.key === "Escape" && this.isOpen) {
            this._toggleNewsletter();
          }
        },
      },
    ]);

    return AnnouncementBarSection;
  })();

  var BlogSection = /*#__PURE__*/ (function () {
    function BlogSection(element) {
      _classCallCheck(this, BlogSection);

      this.element = element;
      this.blogTagSelector = new ValuePicker("blog-tag-selector");

      if (Shopify.designMode) {
        var elementToAdd = this.element.querySelector(".page__header");

        if (elementToAdd) {
          document.querySelector(".blog-container").previousElementSibling.remove();
          document
            .querySelector(".blog-container")
            .insertAdjacentElement("beforebegin", elementToAdd);
        }
      }
    }

    _createClass(BlogSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.blogTagSelector.destroy();
        },
      },
    ]);

    return BlogSection;
  })();

  var BlogPostSection = function BlogPostSection(element) {
    _classCallCheck(this, BlogPostSection);

    this.element = element;

    if (Shopify.designMode) {
      var elementToAdd = this.element.querySelector(".page__header");

      if (elementToAdd) {
        document.querySelector(".blog-container").previousElementSibling.remove();
        document
          .querySelector(".blog-container")
          .insertAdjacentElement("beforebegin", elementToAdd);
      }
    }
  };

  var BlogSidebarSection = /*#__PURE__*/ (function () {
    function BlogSidebarSection(element) {
      _classCallCheck(this, BlogSidebarSection);

      this.element = element;

      if (window.theme.pageType === "blog") {
        this._fixItemsPerRow();
      }
    }
    /**
     * If sidebar is not visible, then we must do some adjustments to the grid of article (especially, we must change how many items per row are displayed).
     * Because Shopify sections are independent, I didn't find a better approach than changing it in JavaScript
     */

    _createClass(BlogSidebarSection, [
      {
        key: "_fixItemsPerRow",
        value: function _fixItemsPerRow() {
          var blocks = this.element.querySelectorAll(".blog-sidebar__item");

          if (blocks.length === 0) {
            document
              .querySelector(".blog-container")
              .classList.add("blog-container--without-sidebar");
            document
              .querySelectorAll(".shopify-section__blog-posts .block-list__item")
              .forEach(function (item) {
                if (item.classList.contains("1/2--lap-and-up")) {
                  item.classList.remove("1/2--lap-and-up");
                  item.classList.add("1/3--lap-and-up");
                }
              });
          } else {
            document
              .querySelector(".blog-container")
              .classList.remove("blog-container--without-sidebar");
            document
              .querySelectorAll(".shopify-section__blog-posts .block-list__item")
              .forEach(function (item) {
                if (item.classList.contains("1/3--lap-and-up")) {
                  item.classList.remove("1/3--lap-and-up");
                  item.classList.add("1/2--lap-and-up");
                }
              });
          }
        },
      },
    ]);

    return BlogSidebarSection;
  })();

  var CartSection = /*#__PURE__*/ (function () {
    function CartSection(element) {
      _classCallCheck(this, CartSection);

      this.element = element;
      this.domDelegate = new Delegate(this.element);
      this.delegateRoot = new Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

      if (this.options["showShippingEstimator"]) {
        this.shippingEstimator = new ShippingEstimator(
          this.element.querySelector(".shipping-estimator"),
          {
            singleProduct: false,
          },
        );
      }

      this._attachListeners();

      this._enforceMinimumHeight();
    }

    _createClass(CartSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.options["showShippingEstimator"]) {
            this.shippingEstimator.destroy();
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.domDelegate.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this));
          this.domDelegate.on("click", '[data-action="save-note"]', this._saveNote.bind(this));
          this.delegateRoot.on("cart:rerendered", this._onCartRerendered.bind(this));
        },
      },
      {
        key: "_saveNote",
        value: function _saveNote() {
          var noteValue = this.element.querySelector('[name="note"]').value;
          fetch("".concat(window.routes.cartUrl, "/update.js"), {
            body: JSON.stringify({
              note: noteValue,
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          }); // Hide or show the note edit button depending on content

          this.element
            .querySelector(".cart-recap__note-edit")
            .classList.toggle("is-visible", noteValue !== ""); // Close the button by sending a global event

          document.dispatchEvent(
            new CustomEvent("collapsible:toggle", {
              detail: {
                id: "order-note",
              },
            }),
          );
        },
      },
      {
        key: "_addToCart",
        value: function _addToCart(event, target) {
          var _this = this;

          if (window.theme.cartType === "page") {
            return; // When using a cart type of page, we just simply redirect to the cart page
          }

          event.preventDefault(); // Prevent form to be submitted

          event.stopPropagation(); // First, we switch the status of the button

          target.setAttribute("disabled", "disabled");
          document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax

          var formElement = target.closest('form[action*="/cart/add"]');
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(Form.serialize(formElement)),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          }).then(function (response) {
            if (response.ok) {
              target.removeAttribute("disabled"); // We simply trigger an event so the mini-cart can re-render

              _this.element.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    variant: null,
                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value),
                  },
                }),
              );
            } else {
              target.removeAttribute("disabled");
            }
          });
          event.preventDefault();
        },
      },
      {
        key: "_enforceMinimumHeight",
        value: function _enforceMinimumHeight() {
          var cartWrapperElement = this.element.querySelector(".cart-wrapper"),
            cartRecapScrollerElement = this.element.querySelector(".cart-recap__scroller");

          if (cartWrapperElement && cartRecapScrollerElement) {
            cartWrapperElement.style.minHeight = "".concat(
              cartRecapScrollerElement.clientHeight,
              "px",
            );

            if (window.ResizeObserver) {
              var resizeObserver = new ResizeObserver(function (entries) {
                var _iterator = _createForOfIteratorHelper(entries),
                  _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var entry = _step.value;
                    cartWrapperElement.style.minHeight = "".concat(
                      parseInt(entry.contentRect.height),
                      "px",
                    );
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              });
              resizeObserver.observe(cartRecapScrollerElement);
            }
          }
        },
        /* When the cart re-render, we have some operations to do */
      },
      {
        key: "_onCartRerendered",
        value: function _onCartRerendered() {
          // For now the only thing we have to do is re-create the shipping estimator
          if (this.options["showShippingEstimator"]) {
            this.shippingEstimator.destroy();
            this.shippingEstimator = new ShippingEstimator(
              this.element.querySelector(".shipping-estimator"),
              {
                singleProduct: false,
              },
            );
          }

          this._enforceMinimumHeight();
        },
      },
    ]);

    return CartSection;
  })();

  var CollectionSection = /*#__PURE__*/ (function () {
    function CollectionSection(element) {
      _classCallCheck(this, CollectionSection);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      this.currentUrl = new URL(window.location.href);
      this.mobileFilterDrawer = new CollectionFilterDrawer(this.options);
      this.displayByValuePicker = new ValuePicker("display-by-selector", {
        onValueSelect: this._showingCountChanged.bind(this),
      });
      this.sortByValuePicker = new ValuePicker("sort-by-selector", {
        onValueSelect: this._sortByChanged.bind(this),
      });

      if (window.theme.pageType === "search" && window.theme.searchMode !== "product") {
        this._loadContentResults();
      }

      this._attachListeners();
    }

    _createClass(CollectionSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off();
          // this.mobileFilterDrawer.destroy();
          this.displayByValuePicker.destroy();
          this.sortByValuePicker.destroy();
        },
      },
      {
        key: "onSelect",
        value: function onSelect(event) {
          if (Shopify.designMode && event.detail.load) {
            // We also force the layout and number of items per page in the editor, no matter if you have choose an explicit mode
            this.element
              .querySelector(
                '.collection__layout-button[data-layout-mode="'.concat(
                  this.options["defaultLayout"],
                  '"]',
                ),
              )
              .click();

            this._showingCountChanged(this.options["defaultProductsPerPage"]);
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="change-layout"]',
            this._changeLayout.bind(this),
          );
          this.delegateElement.on(
            "change",
            "#mobile-sort-by, #desktop-sort-by",
            this._sortByChanged.bind(this),
          );
          this.delegateElement.on("change", "#showing-count", this._showingCountChanged.bind(this));
          this.delegateElement.on(
            "click",
            ".pagination [data-page]",
            this._paginationPageChanged.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="add-to-cart"]',
            this._addToCart.bind(this),
          );
          window.addEventListener("filters:change", this._onFilterChanged.bind(this));
          this.delegateElement.on(
            "click",
            '[data-action="clear-filters"]',
            this._onFiltersCleared.bind(this),
          );
          window.addEventListener("popstate", this._handlePopState.bind(this));
        },
      },
      {
        key: "_changeLayout",
        value: function _changeLayout(event, target) {
          var _this = this;

          if (target.classList.contains("is-selected")) {
            return;
          }

          var newLayoutMode = target.getAttribute("data-layout-mode"); // We save the new attribute so that we can select the appropriate mode without causing reflow

          fetch("".concat(window.routes.cartUrl, "/update.js"), {
            body: JSON.stringify({
              attributes: {
                collection_layout: newLayoutMode,
              },
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          }); // Finally, we change everything!

          fastdom.mutate(function () {
            Dom.getSiblings(target, ".is-selected").forEach(function (button) {
              return button.classList.remove("is-selected");
            });
            target.classList.add("is-selected");

            _this.element.querySelectorAll(".product-item").forEach(function (item) {
              if (newLayoutMode === "grid") {
                item.className = "product-item product-item--vertical ".concat(
                  _this.options["gridClasses"],
                );
              } else {
                item.className = "product-item product-item--list";
              }
            }); // Reload the swatches
          });
        },
        /**
         * Update the URL and reload products
         */
      },
      {
        key: "_sortByChanged",
        value: function _sortByChanged(value) {
          this.currentUrl.searchParams.set("sort_by", value);
          this.currentUrl.searchParams["delete"]("page");

          this._reload(true);
        },
        /**
         * When the number of items has changed
         */
      },
      {
        key: "_showingCountChanged",
        value: function _showingCountChanged(value) {
          var _this2 = this;

          this.currentUrl.searchParams["delete"]("page"); // We save the new value as a cart attribute, so it can be retrieved in Liquid easily :)

          fetch("".concat(window.routes.cartUrl, "/update.js"), {
            body: JSON.stringify({
              attributes: {
                collection_products_per_page: value,
              },
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          }).then(function () {
            _this2._reload(true);
          });
        },
        /**
         * When the page has changed
         */
      },
      {
        key: "_handlePopState",
        value: function _handlePopState(event) {
          window.location.reload();
        },
      },
      {
        key: "_paginationPageChanged",
        value: function _paginationPageChanged(event, target) {
          event.preventDefault();
          this.currentUrl.searchParams.set("page", parseInt(target.getAttribute("data-page")));
          this._reload(true, target);
        },
      },
      {
        key: "_onFilterChanged",
        value: function _onFilterChanged(event, target) {
          // var formData = new FormData(target.closest('form'));
          // var searchParamsAsString = new URLSearchParams(formData).toString();
          // this.currentUrl = new URL("".concat(window.location.pathname, "?").concat(searchParamsAsString), window.location.origin);
          // overriding from custom filters
          this.currentUrl = new URL(
            "".concat(window.location.pathname, "?").concat(event.detail),
            window.location.origin,
          );

          this._reload(true);
        },
      },
      {
        key: "_onFiltersCleared",
        value: function _onFiltersCleared(event, target) {
          dispatchEvent(
            new CustomEvent("filters:clear", {
              detail: {
                changeFilter: target,
              },
            }),
          );
        },
        /**
         * Reload all products from the current URL
         *
         * @private
         */
      },
      {
        key: "_reload",
        value: function _reload(pushState, paginationElem) {
          var _this3 = this;

          if (this.abortController) {
            this.abortController.abort();
          } // Then, we replace the URL

          if (pushState) {
            window.history.pushState(
              {
                path: this.currentUrl.toString(),
              },
              "",
              this.currentUrl.toString(),
            );
          }

          document.dispatchEvent(new CustomEvent("theme:loading:start")); // We scroll to the top

          var computedStyles = window.getComputedStyle(document.documentElement); // To load the content we use the newly introduced "Sections API", which also to get data much more efficiently

          var sectionUrl = "";

          if (this.currentUrl.search) {
            sectionUrl = ""
              .concat(this.currentUrl.pathname, "/")
              .concat(this.currentUrl.search, "&section_id=")
              .concat(this.element.getAttribute("data-section-id"));
          } else {
            sectionUrl = ""
              .concat(this.currentUrl.pathname, "?section_id=")
              .concat(this.element.getAttribute("data-section-id"));
          }

          try {
            this.abortController = new AbortController();
            if (paginationElem) {
              paginationElem.querySelector(".loading-spinner").classList.remove("hide");
            }

            return fetch(sectionUrl, {
              credentials: "same-origin",
              method: "GET",
              signal: this.abortController.signal,
            }).then(function (response) {
              response.text().then(function (content) {
                var tempElement = document.createElement("div");
                tempElement.innerHTML = content;
                _this3.element.querySelector(".collection__dynamic-part").innerHTML =
                  tempElement.querySelector(".collection__dynamic-part").innerHTML;

                const event = new CustomEvent("collection:refresh:success", {
                  detail: {
                    filter_data: tempElement.querySelector(".collection-filters__form").innerHTML,
                  },
                });
                dispatchEvent(event);

                var api = new Yotpo.API(yotpo);
                api.refreshWidgets();
                var elementOffset =
                  _this3.element.querySelector(".collection").getBoundingClientRect().top -
                  25 -
                  parseInt(computedStyles.getPropertyValue("--header-is-sticky")) *
                    parseInt(computedStyles.getPropertyValue("--header-height"));

                if (elementOffset < 0) {
                  window.scrollBy({
                    top: elementOffset,
                    // behavior: "smooth",
                  });
                } // Finally, we scroll to the element

                document.dispatchEvent(new CustomEvent("theme:loading:end"));
              });
            });
          } catch (e) {
            // Ignore the exception
            const event = new CustomEvent("collection:refresh:error");
            document.dispatchEvent(event);
            if (paginationElem) {
              paginationElem.querySelector(".loading-spinner").classList.add("hide");
            }
          }
        },
        /**
         * ---------------------------------------------------------------------------------------------------
         * SEARCH PAGE SPECIFIC METHOD
         * ---------------------------------------------------------------------------------------------------
         */
      },
      {
        key: "_loadContentResults",
        value: function _loadContentResults() {
          var _this4 = this;

          var currentUrl = new URL(window.location.href);
          fetch(
            ""
              .concat(window.routes.searchUrl, "?section_id=search-content&q=")
              .concat(currentUrl.searchParams.get("q"), "&type=")
              .concat(window.theme.searchMode.replace("product,", "")),
            {
              credentials: "same-origin",
            },
          ).then(function (response) {
            response.text().then(function (content) {
              var linkSearchResults = _this4.element.querySelector(".link-search-results"),
                fakeDiv = document.createElement("div");

              fakeDiv.innerHTML = content;

              if (linkSearchResults && content.trim() !== "") {
                linkSearchResults.innerHTML = fakeDiv.firstElementChild.innerHTML;
                linkSearchResults.style.display = "block";
              }
            });
          });
        },
        /**
         * ---------------------------------------------------------------------------------------------------
         * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
         * ---------------------------------------------------------------------------------------------------
         */
      },
      {
        key: "_addToCart",
        value: function _addToCart(event, target) {
          var _this5 = this;

          if (window.theme.cartType === "page") {
            return; // When using a cart type of page, we just simply redirect to the cart page
          }

          event.preventDefault(); // Prevent form to be submitted

          event.stopPropagation(); // First, we switch the status of the button

          target.setAttribute("disabled", "disabled");
          document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax

          var formElement = target.closest('form[action*="/cart/add"]');
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(Form.serialize(formElement)),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          }).then(function (response) {
            target.removeAttribute("disabled");

            if (response.ok) {
              // We simply trigger an event so the mini-cart can re-render
              _this5.element.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    button: target,
                    variant: null,
                    quantity: parseInt(formElement.querySelector('[name="quantity"]').value),
                  },
                }),
              );
            } else {
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
            }
          });
          event.preventDefault();
        },
      },
    ]);

    return CollectionSection;
  })();

  var GiftCardSection = /*#__PURE__*/ (function () {
    function GiftCardSection(container) {
      _classCallCheck(this, GiftCardSection);

      this.element = container;
      this.delegateElement = new Delegate(this.element);

      this._createQrCode();

      this._attachListeners();
    }

    _createClass(GiftCardSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off();
        },
      },
      {
        key: "_createQrCode",
        value: function _createQrCode() {
          var qrCodeElements = document.querySelectorAll(".gift-card__qr");
          qrCodeElements.forEach(function (qrCodeElement) {
            new QRCode(qrCodeElement, {
              text: qrCodeElement.getAttribute("data-identifier"),
              width: 200,
              height: 200,
            });
          });
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on("click", '[data-action="print"]', this._print.bind(this));
          this.delegateElement.on(
            "click",
            '[data-action="select-code"]',
            this._selectCode.bind(this),
          );
        },
      },
      {
        key: "_print",
        value: function _print() {
          window.print();
        },
      },
      {
        key: "_selectCode",
        value: function _selectCode(event, element) {
          element.select();
        },
      },
    ]);

    return GiftCardSection;
  })();

  var FooterSection = /*#__PURE__*/ (function () {
    function FooterSection(element) {
      _classCallCheck(this, FooterSection);

      this.element = element;
      this.domDelegate = new Delegate(this.element);
      this.localeValuePicker = new ValuePicker("footer-locale-picker");
      this.currencyValuePicker = new ValuePicker("footer-currency-picker");
      this.cookieBarElement = this.element.querySelector(".cookie-bar");

      if (this.cookieBarElement) {
        this._setupCookieBar();
      }

      this._setupCollapsibles();

      this._attachListeners();
    }

    _createClass(FooterSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          window.removeEventListener("resize", this._setupCollapsiblesListener);
          this.domDelegate.off();
          this.localeValuePicker.destroy();
          this.currencyValuePicker.destroy();
        },
      },
      {
        key: "onSelect",
        value: function onSelect() {
          if (this.cookieBarElement) {
            this.cookieBarElement.setAttribute("aria-hidden", "false");
          }
        },
      },
      {
        key: "onDeselect",
        value: function onDeselect() {
          if (this.cookieBarElement) {
            this.cookieBarElement.setAttribute("aria-hidden", "true");
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._setupCollapsiblesListener = this._setupCollapsibles.bind(this);
          window.addEventListener("resize", this._setupCollapsiblesListener);
          this.domDelegate.on(
            "click",
            '[data-action="accept-terms"]',
            this._acceptCookieBarTerms.bind(this),
          );
        },
        /**
         * On mobile, some block items are collapsed, so we must slightly edit their HTML
         */
      },
      {
        key: "_setupCollapsibles",
        value: function _setupCollapsibles() {
          var collapsibleToggles = this.element.querySelectorAll(
              '[data-action="toggle-collapsible"]',
            ),
            isPhone = Responsive.matchesBreakpoint("phone");
          collapsibleToggles.forEach(function (collapsibleToggle) {
            if (isPhone) {
              collapsibleToggle.removeAttribute("disabled");
            } else {
              collapsibleToggle.setAttribute("disabled", "disabled");
              document.getElementById(
                collapsibleToggle.getAttribute("aria-controls"),
              ).style.height = "";
            }
          });
        },
      },
      {
        key: "_setupCookieBar",
        value: function _setupCookieBar() {
          // We check if we should make it visible
          try {
            if (localStorage.getItem("cookieWasAccepted") === null) {
              this.cookieBarElement.setAttribute("aria-hidden", "false");
            }
          } catch (exception) {
            // Some browser may throw an exception when trying to access the local storage in private mode for instance, so we just ignore it
          }
        },
      },
      {
        key: "_acceptCookieBarTerms",
        value: function _acceptCookieBarTerms() {
          // We close the cookie bar and we set a value in local storage to not show it again
          this.cookieBarElement.setAttribute("aria-hidden", "true");

          try {
            localStorage.setItem("cookieWasAccepted", "true");
          } catch (exception) {}
        },
      },
    ]);

    return FooterSection;
  })();

  var SearchBar = /*#__PURE__*/ (function () {
    function SearchBar(element) {
      _classCallCheck(this, SearchBar);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.headerElement = this.element.closest(".header");
      this.searchBarElement = this.element.querySelector(".search-bar");
      this.inputElement = this.element.querySelector('[name="q"]');
      this.searchMenuElement = this.element.querySelector(".search-bar__menu-wrapper");
      this.searchResultsElement = this.element.querySelector(".search-bar__results");
      this.closeButtonElement = this.element.querySelector(".search-bar__close-button");
      this.productTypeFilter = "";
      this.isSearchOpen = false;

      this._attachListeners();
    }

    _createClass(SearchBar, [
      {
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on(
            "click",
            '[data-action="clear-input"]',
            this._clearInput.bind(this),
          );
          this.delegateElement.on(
            "click",
            '[data-action="unfix-search"]',
            this._unfixMobileSearch.bind(this),
          );
          this.delegateElement.on("focusin", '[name="q"]', this._onInputFocus.bind(this));
          this.delegateElement.on("focusout", this._onFocusOut.bind(this));
          this.delegateElement.on("keydown", '[name="q"]', this._handleTab.bind(this));
          this.delegateElement.on(
            "input",
            '[name="q"]',
            this._debounce(this._doSearch.bind(this), 250),
          );
          this.delegateElement.on(
            "change",
            "#search-product-type",
            this._productTypeChanged.bind(this),
          );
          this.delegateElement.on("submit", this._onFormSubmit.bind(this));
        },
        /**
         * Toggle the mobile search (only applicable if the show condensed search is shown)
         */
      },
      {
        key: "toggleMobileSearch",
        value: function toggleMobileSearch() {
          if (this.isSearchOpen) {
            this.headerElement.classList.remove("header--search-expanded");
            this.element.classList.remove("is-visible");
          } else {
            this.headerElement.classList.add("header--search-expanded");
            this.element.classList.add("is-visible");
          }

          this.isSearchOpen = !this.isSearchOpen;
        },
      },
      {
        key: "_unfixMobileSearch",
        value: function _unfixMobileSearch() {
          this.element.classList.remove("is-fixed");
          this.closeButtonElement.style.width = "";
          this.searchBarElement.classList.remove("is-expanded");
          this.searchResultsElement.setAttribute("aria-hidden", "true");
          this.inputElement.classList.remove("is-filled");
          document.body.classList.remove("no-mobile-scroll");

          if (this.searchMenuElement) {
            this.searchMenuElement.setAttribute("aria-hidden", "true");
          }
        },
        /**
         * Only on mobile
         */
      },
      {
        key: "_clearInput",
        value: function _clearInput() {
          this.inputElement.value = "";
          this.inputElement.classList.remove("is-filled");
          this.searchResultsElement.setAttribute("aria-hidden", "true");

          if (this.searchMenuElement) {
            this.searchMenuElement.setAttribute("aria-hidden", "false");
          }
        },
        /**
         * When the input get focus, we display the quick links if they were specified by the merchant, or we open results if
         * results were previously loaded
         */
      },
      {
        key: "_onInputFocus",
        value: function _onInputFocus() {
          this.element.classList.add("is-fixed");
          this.closeButtonElement.style.width = "".concat(
            this.closeButtonElement.firstElementChild.offsetWidth,
            "px",
          );
          document.body.classList.add("no-mobile-scroll");

          if (this.inputElement.value === "") {
            if (this.searchMenuElement) {
              this.searchMenuElement.setAttribute("aria-hidden", "false");
            }

            this.searchResultsElement.setAttribute("aria-hidden", "true");
          } else {
            if (this.searchMenuElement) {
              this.searchMenuElement.setAttribute("aria-hidden", "true");
            }

            this.searchResultsElement.setAttribute("aria-hidden", "false");
            this.inputElement.classList.add("is-filled");
            this.searchBarElement.classList.add("is-expanded");
          }

          if (this.searchMenuElement) {
            this.searchBarElement.classList.add("is-expanded");
          }
        },
        /**
         * Whenever the focus leaves the search, we close everything (both search results and quick links)
         */
      },
      {
        key: "_onFocusOut",
        value: function _onFocusOut(event) {
          // On phone, nothing happens on focus out
          if (Responsive.matchesBreakpoint("phone")) {
            return;
          }

          this.element.classList.remove("is-fixed");
          document.body.classList.remove("no-mobile-scroll"); // event.relatedTarget allows to get the new element that get focus. If it's outside the div that contains the search, we close it

          if (!this.element.contains(event.relatedTarget)) {
            if (this.searchMenuElement) {
              this.searchMenuElement.setAttribute("aria-hidden", "true");
            }

            this.searchResultsElement.setAttribute("aria-hidden", "true");
            this.searchBarElement.classList.remove("is-expanded");
          }
        },
        /**
         * This allows to slightly improve the accessibility and user experience by directly focusing on the first search results (if any)
         */
      },
      {
        key: "_handleTab",
        value: function _handleTab(event) {
          if (event.key !== "Tab") {
            return;
          } // Try to get the first link into the results to give focus to this element

          var firstFocusableElement = this.searchResultsElement.querySelector("a");

          if (firstFocusableElement) {
            firstFocusableElement.focus();
            event.preventDefault();
          }
        },
        /**
         * Fire the different Ajax requests
         */
      },
      {
        key: "_doSearch",
        value: function _doSearch() {
          var _this = this;

          // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
          // keep track of sent requests, and only use the results of the last one
          var currentInput = this.inputElement.value;
          this.lastInputValue = currentInput;

          if (currentInput === "") {
            if (this.searchMenuElement) {
              this.searchMenuElement.setAttribute("aria-hidden", "false");
            } else {
              this.searchBarElement.classList.remove("is-expanded");
            }

            this.searchResultsElement.setAttribute("aria-hidden", "true");
          } else {
            if (this.searchMenuElement) {
              this.searchMenuElement.setAttribute("aria-hidden", "true");
            }

            this.searchResultsElement.setAttribute("aria-hidden", "false");
            this.searchBarElement.classList.add("is-expanded", "is-loading");
            var queryOptions = {
                method: "GET",
                credentials: "same-origin",
              },
              productQuery = ""
                .concat(
                  this.productTypeFilter !== ""
                    ? "product_type:".concat(this.productTypeFilter, " AND ")
                    : "",
                )
                .concat(encodeURIComponent(this.lastInputValue)),
              queries = [
                fetch(
                  ""
                    .concat(window.routes.searchUrl, "?section_id=search-ajax&q=")
                    .concat(productQuery, "&options[prefix]=last&options[unavailable_products]=")
                    .concat(window.theme.searchUnavailableProducts, "&type=product"),
                  queryOptions,
                ),
              ];

            if (window.theme.searchMode !== "product") {
              queries.push(
                fetch(
                  ""
                    .concat(window.routes.searchUrl, "?section_id=search-ajax&q=")
                    .concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=")
                    .concat(window.theme.searchMode.replace("product,", "")),
                  queryOptions,
                ),
              );
            }

            Promise.all(queries).then(function (responses) {
              // If we receive the result for a query that is not the last one, we simply do not process the result
              if (_this.lastInputValue !== currentInput) {
                return;
              }

              Promise.all(
                responses.map(function (response) {
                  return response.text().then(function (responseAsText) {
                    var div = document.createElement("div");
                    div.innerHTML = responseAsText;
                    return div.querySelector(".search-ajax").innerHTML;
                  });
                }),
              ).then(function (contents) {
                _this.searchBarElement.classList.remove("is-loading");

                var searchContent = document.createElement("div");
                searchContent.innerHTML = contents.join("").trim(); // If there is a "view all" button, we move it at the end of the results

                var viewAll = searchContent.querySelector(".search-bar__view-all");

                if (viewAll) {
                  searchContent.insertAdjacentElement("beforeend", viewAll);
                }

                _this.searchBarElement.querySelector(".search-bar__results-inner").innerHTML =
                  searchContent.innerHTML;
              });
            });
          }
        },
        /**
         * Warehouse allows to display a filter by type. When its value change, we re-do a new search to get the new data
         */
      },
      {
        key: "_productTypeChanged",
        value: function _productTypeChanged(event, target) {
          target
            .closest(".search-bar__filter")
            .querySelector(".search-bar__filter-active").innerText =
            target.options[target.selectedIndex].innerText;
          this.productTypeFilter = target.value;

          if (this.inputElement.value !== "") {
            this._doSearch();
          }
        },
        /**
         * Called when the form is submitted using the Enter key. We have to capture it and transform the query to include the wildcard
         */
      },
      {
        key: "_onFormSubmit",
        value: function _onFormSubmit(event) {
          var cloneNode = this.inputElement.cloneNode();
          cloneNode.setAttribute("type", "hidden");
          cloneNode.value = "";

          if (this.productTypeFilter !== "") {
            cloneNode.value += "product_type:".concat(this.productTypeFilter);

            if (this.inputElement.value !== "") {
              cloneNode.value += " AND ";
            }
          }

          cloneNode.value += this.inputElement.value; // We remove the "q" attribute on existing node so it's not submitted

          this.inputElement.removeAttribute("name"); // And we insert it into the DOM

          this.inputElement.insertAdjacentElement("afterend", cloneNode);
        },
        /**
         * Simple function that allows to debounce
         */
      },
      {
        key: "_debounce",
        value: function _debounce(fn, delay) {
          var _this2 = this;

          var timer = null;
          return function () {
            for (
              var _len = arguments.length, args = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              args[_key] = arguments[_key];
            }

            clearTimeout(timer);
            timer = setTimeout(function () {
              fn.apply(_this2, args);
            }, delay);
          };
        },
      },
    ]);

    return SearchBar;
  })();

  var HeaderSection = /*#__PURE__*/ (function () {
    function HeaderSection(element) {
      _classCallCheck(this, HeaderSection);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
      this.searchBar = new SearchBar(this.element.querySelector(".header__search-bar-wrapper"));
      this.cart = new Cart(this.element.querySelector(".header__action-item--cart"), {
        useStickyHeader: this.options["useStickyHeader"],
      }); // We create the desktop and mobile navigation conditionally as we've found that some merchants may have no menu

      var desktopNavigationElement = this.element.querySelector(
        this.options["navigationLayout"] === "inline" ? ".nav-bar" : ".header__desktop-nav",
      );

      if (desktopNavigationElement) {
        this.desktopNavigation = new DesktopNavigation(
          desktopNavigationElement,
          this.options["navigationLayout"],
          this.options["desktopOpenTrigger"],
        );
      }

      var mobileNavigationElement = this.element.querySelector(".header__mobile-nav");

      if (mobileNavigationElement) {
        this.mobileNavigation = new MobileNavigation(mobileNavigationElement);
      }

      this._setupCssVariables();

      this._attachListeners();
    }

    _createClass(HeaderSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.searchBar.destroy();
          this.cart.destroy();

          if (this.desktopNavigation) {
            this.desktopNavigation.destroy();
          }

          if (this.mobileNavigation) {
            this.mobileNavigation.destroy();
          }

          window.removeEventListener("resize", this._setupCssVariablesListener);
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          if (this.desktopNavigation) {
            this.desktopNavigation.onBlockSelect(event);
          }
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect(event) {
          if (this.desktopNavigation) {
            this.desktopNavigation.onBlockDeselect(event);
          }
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._setupCssVariablesListener = this._setupCssVariables.bind(this);
          window.addEventListener("resize", this._setupCssVariablesListener);
          this.delegateElement.on(
            "click",
            '[data-action="toggle-search"]',
            this._toggleMobileSearch.bind(this),
          );
        },
        /**
         * We have some positioning that is based on the CSS variables, so we must make sure to update them whenever
         * the section is reloaded into the editor
         */
      },
      {
        key: "_setupCssVariables",
        value: function _setupCssVariables() {
          document.documentElement.style.setProperty(
            "--header-height",
            this.element.parentNode.clientHeight + "px",
          );
        },
        /**
         * Toggle the mobile search
         */
      },
      {
        key: "_toggleMobileSearch",
        value: function _toggleMobileSearch(event) {
          this.searchBar.toggleMobileSearch();
          event.preventDefault();
        },
      },
    ]);

    return HeaderSection;
  })();

  var LoginSection = /*#__PURE__*/ (function () {
    function LoginSection(element) {
      _classCallCheck(this, LoginSection);

      this.element = element;
      this.domDelegate = new Delegate(this.element);
      this.customerLoginForm = this.element.querySelector("#customer_login");
      this.recoverPasswordForm = this.element.querySelector("#recover_customer_password");
      this.domDelegate.on(
        "click",
        '[data-action="toggle-login-form"]',
        this._showRecoverPassword.bind(this),
      );
    }

    _createClass(LoginSection, [
      {
        key: "_showRecoverPassword",
        value: function _showRecoverPassword() {
          var isLoginActive = this.customerLoginForm.style.display === "block";

          if (isLoginActive) {
            this.customerLoginForm.style.display = "none";
            this.recoverPasswordForm.style.display = "block";
          } else {
            this.customerLoginForm.style.display = "block";
            this.recoverPasswordForm.style.display = "none";
          }
        },
      },
    ]);

    return LoginSection;
  })();

  var MapSection = /*#__PURE__*/ (function () {
    function MapSection(element) {
      _classCallCheck(this, MapSection);

      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.options = JSON.parse(element.getAttribute("data-section-settings"));
      this.mapPositions = [];
      this.desktopMarkers = [];
      this.desktopMapElement = null;
      this.mobileMarkers = [];
      this.mobileMapElements = [];

      if (this.options["apiKey"] && this.options["mapAddresses"].length > 0) {
        this._loadScript().then(this._initMaps.bind(this));
      }

      this._attachListeners();
    }

    _createClass(MapSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off("click");

          if (this.options["apiKey"] && this.options["mapAddresses"].length > 0) {
            google.maps.event.clearInstanceListeners(window);
          }
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this._showStore(event.target);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          var _this = this;

          this.delegateElement.on(
            "click",
            '[data-action="toggle-store"]',
            function (event, target) {
              _this._showStore(target.closest(".map__store-item"));
            },
          );
        },
      },
      {
        key: "_showStore",
        value: function _showStore(storeItem) {
          var _this2 = this;

          var toggleButton = storeItem.querySelector('[data-action="toggle-store"]'); // If already open, we do nothing unless we are on mobile (as we need at least one store visible on desktop)

          if (
            Responsive.getCurrentBreakpoint() !== "phone" &&
            toggleButton.getAttribute("aria-expanded") === "true"
          ) {
            return;
          } // Otherwise, we activate it

          if (toggleButton.getAttribute("aria-expanded") === "true") {
            toggleButton.setAttribute("aria-expanded", "false");
            Animation.slideUp(storeItem.querySelector(".map__store-collapsible"));
          } else {
            toggleButton.setAttribute("aria-expanded", "true");
            Animation.slideDown(storeItem.querySelector(".map__store-collapsible"));
          } // Finally, we close the other ones (if any is open)

          Dom.getSiblings(storeItem).forEach(function (storeItemToClose) {
            storeItemToClose
              .querySelector('[data-action="toggle-store"]')
              .setAttribute("aria-expanded", "false");
            Animation.slideUp(storeItemToClose.querySelector(".map__store-collapsible"));
          }); // We need to move the map to the new center, and we need to change its color to make it active

          var storeIndex = parseInt(storeItem.getAttribute("data-store-index"));
          this.desktopMapElement.panTo(this.mapPositions[storeIndex]);
          this.desktopMarkers.forEach(function (marker, index) {
            marker.setMap(_this2.desktopMapElement);

            if (index === storeIndex) {
              marker.icon.fillColor = _this2.options["markerActiveColor"];
            } else {
              marker.icon.fillColor = _this2.options["markerColor"];
            }
          });
        },
      },
      {
        key: "_loadScript",
        value: function _loadScript() {
          var _this3 = this;

          return new Promise(function (resolve, reject) {
            var script = document.createElement("script");
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = true;
            script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(
              _this3.options["apiKey"],
            );
          });
        },
      },
      {
        key: "_initMaps",
        value: function _initMaps() {
          var _this4 = this;

          // First, we gather all the maps (desktop and mobile)
          var mapOptions = {
            zoom: this.options["zoom"],
            draggable: this.options["draggableMap"],
            clickableIcons: false,
            scrollwheel: this.options["draggableMap"],
            disableDoubleClickZoom: true,
            disableDefaultUI: !this.options["showMapControls"],
            styles: JSON.parse(this.element.querySelector("[data-gmap-style]").innerHTML),
          };
          this.desktopMapElement = new google.maps.Map(
            this.element.querySelector(".map__map-container--desktop .map__gmap"),
            mapOptions,
          );
          this.mobileMapElements = [];
          this.element
            .querySelectorAll(".map__map-container--mobile .map__gmap")
            .forEach(function (item, index) {
              _this4.mobileMapElements[index] = new google.maps.Map(item, mapOptions);
            }); // Then we geocode all addresses

          this._geocodeAddresses(); // Make sure we attach the listeners so that it's properly resized

          google.maps.event.addDomListener(window, "resize", function () {
            var desktopCenter = _this4.desktopMapElement.getCenter();

            google.maps.event.trigger(_this4.desktopMapElement, "resize");

            _this4.desktopMapElement.setCenter(desktopCenter);

            _this4.mobileMapElements.forEach(function (mobileMap) {
              var mobileCenter = mobileMap.getCenter();
              google.maps.event.trigger(mobileMap, "resize");
              mobileMap.setCenter(mobileCenter);
            });
          });
        },
      },
      {
        key: "_onMarkerClicked",
        value: function _onMarkerClicked(address) {
          window.open("https://www.google.com/maps/search/?api=1&query=".concat(address), "_blank");
        },
      },
      {
        key: "_geocodeAddresses",
        value: function _geocodeAddresses() {
          var _this5 = this;

          // Then, we geocode all the addresses, and place them on the map
          var geocoder = new google.maps.Geocoder();
          this.options["mapAddresses"].forEach(function (address, index) {
            geocoder.geocode(
              {
                address: address,
              },
              function (results, status) {
                if (status !== google.maps.GeocoderStatus.OK) {
                  if (Shopify.designMode);
                } else {
                  var position = results[0].geometry.location;
                  _this5.mapPositions[index] = position; // The desktop map holds all the markers, so we add it to the desktop global map.

                  _this5.desktopMarkers[index] = new google.maps.Marker({
                    map: index === 0 ? _this5.desktopMapElement : null,
                    position: position,
                    icon: {
                      path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                      fillColor:
                        index === 0
                          ? _this5.options["markerActiveColor"]
                          : _this5.options["markerColor"],
                      fillOpacity: 1,
                      anchor: new google.maps.Point(12, 30),
                      strokeWeight: 0,
                    },
                  }); // We then add it on the corresponding mobile map

                  _this5.mobileMarkers[index] = new google.maps.Marker({
                    map: _this5.mobileMapElements[index],
                    position: position,
                    icon: {
                      path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                      fillColor: _this5.options["markerActiveColor"],
                      fillOpacity: 1,
                      anchor: new google.maps.Point(12, 30),
                      strokeWeight: 0,
                    },
                  });

                  _this5.desktopMarkers[index].addListener(
                    "click",
                    _this5._onMarkerClicked.bind(_this5, address),
                  );

                  _this5.mobileMarkers[index].addListener(
                    "click",
                    _this5._onMarkerClicked.bind(_this5, address),
                  );

                  if (index === 0) {
                    _this5.desktopMapElement.setCenter(position);
                  }

                  _this5.mobileMapElements[index].setCenter(position);
                }
              },
            );
          });
        },
      },
    ]);

    return MapSection;
  })();

  var MinimalHeaderSection = /*#__PURE__*/ (function () {
    function MinimalHeaderSection(element) {
      _classCallCheck(this, MinimalHeaderSection);

      this.element = element;

      this._setupCssVariables();

      this._attachListeners();
    }

    _createClass(MinimalHeaderSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          window.removeEventListener("resize", this._setupCssVariablesListener);
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._setupCssVariablesListener = this._setupCssVariables.bind(this);
          window.addEventListener("resize", this._setupCssVariablesListener);
        },
        /**
         * We have some positioning that is based on the CSS variables, so we must make sure to update them whenever
         * the section is reloaded into the editor
         */
      },
      {
        key: "_setupCssVariables",
        value: function _setupCssVariables() {
          document.documentElement.style.setProperty(
            "--header-height",
            this.element.parentNode.clientHeight + "px",
          );
        },
      },
    ]);

    return MinimalHeaderSection;
  })();

  var QuickLinksSection = function QuickLinksSection(element) {
    _classCallCheck(this, QuickLinksSection);

    this.element = element; // Make sure that the section is always visible in the editor, even if the option to hide it on desktop is checked

    if (Shopify.designMode) {
      this.element.classList.remove("hidden-lap-and-up");
    }
  };

  /**
   * This class handles both the newsletter popup and exit popup
   */

  var PopupsSection = /*#__PURE__*/ (function () {
    function PopupsSection(element) {
      var _this = this;

      _classCallCheck(this, PopupsSection);

      element.querySelectorAll("[data-popup-type]").forEach(function (popup) {
        if (popup.getAttribute("data-popup-type") === "exit") {
          _this.exitPopup = new ExitPopup(popup);
        } else if (popup.getAttribute("data-popup-type") === "newsletter") {
          _this.newsletterPopup = new NewsletterPopup(popup);
        }
      });
    }

    _createClass(PopupsSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          if (this.exitPopup) {
            this.exitPopup.destroy();
          }

          if (this.newsletterPopup) {
            this.newsletterPopup.destroy();
          }
        },
      },
      {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          if (event.target.getAttribute("data-popup-type") === "exit" && this.exitPopup) {
            this.exitPopup._openPopup();
          } else if (
            event.target.getAttribute("data-popup-type") === "newsletter" &&
            this.newsletterPopup
          ) {
            this.newsletterPopup._openPopup();
          }
        },
      },
      {
        key: "onBlockDeselect",
        value: function onBlockDeselect() {
          if (this.exitPopup) {
            this.exitPopup._closePopup();
          }

          if (this.newsletterPopup) {
            this.newsletterPopup._closePopup();
          }
        },
      },
    ]);

    return PopupsSection;
  })();

  /**
   * This code is extracted from Slate
   */
  var SectionContainer = /*#__PURE__*/ (function () {
    function SectionContainer() {
      _classCallCheck(this, SectionContainer);

      this.constructors = [];
      this.instances = [];

      this._attachListeners();
    }

    _createClass(SectionContainer, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
          document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
          document.addEventListener("shopify:section:select", this._onSelect.bind(this));
          document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
          document.addEventListener("shopify:section:reorder", this._onReorder.bind(this));
          document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
          document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
        },
      },
      {
        key: "register",
        value: function register(type, constructor) {
          var _this = this;

          this.constructors[type] = constructor;
          document
            .querySelectorAll("[data-section-type=".concat(type, "]"))
            .forEach(function (container) {
              _this._createInstance(container, constructor);
            });
        },
        /**
         * Return an object from an array of objects that matches the provided key and value
         */
      },
      {
        key: "_findInstance",
        value: function _findInstance(array, key, value) {
          for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
              return array[i];
            }
          }
        },
        /**
         * Remove an object from an array of objects by matching the provided key and value
         */
      },
      {
        key: "_removeInstance",
        value: function _removeInstance(array, key, value) {
          var i = array.length;

          while (i--) {
            if (array[i][key] === value) {
              array.splice(i, 1);
              break;
            }
          }

          return array;
        },
      },
      {
        key: "_onSectionLoad",
        value: function _onSectionLoad(event) {
          var container = event.target.querySelector("[data-section-id]");

          if (container) {
            this._createInstance(container);
          }
        },
      },
      {
        key: "_onSectionUnload",
        value: function _onSectionUnload(event) {
          var instance = this._findInstance(this.instances, "id", event.detail.sectionId);

          if (!instance) {
            return;
          }

          if (typeof instance.onUnload === "function") {
            instance.onUnload(event);
          }

          this.instances = this._removeInstance(this.instances, "id", event.detail.sectionId);
        },
      },
      {
        key: "_onSelect",
        value: function _onSelect(event) {
          var instance = this._findInstance(this.instances, "id", event.detail.sectionId);

          if (instance && typeof instance.onSelect === "function") {
            instance.onSelect(event);
          }
        },
      },
      {
        key: "_onDeselect",
        value: function _onDeselect(event) {
          var instance = this._findInstance(this.instances, "id", event.detail.sectionId);

          if (instance && typeof instance.onDeselect === "function") {
            instance.onDeselect(event);
          }
        },
      },
      {
        key: "_onReorder",
        value: function _onReorder(event) {
          var instance = this._findInstance(this.instances, "id", event.detail.sectionId);

          if (instance && typeof instance.onReorder === "function") {
            instance.onReorder(event);
          }
        },
      },
      {
        key: "_onBlockSelect",
        value: function _onBlockSelect(event) {
          var instance = this._findInstance(this.instances, "id", event.detail.sectionId);

          if (instance && typeof instance.onBlockSelect === "function") {
            instance.onBlockSelect(event);
          }
        },
      },
      {
        key: "_onBlockDeselect",
        value: function _onBlockDeselect(event) {
          var instance = this._findInstance(this.instances, "id", event.detail.sectionId);

          if (instance && typeof instance.onBlockDeselect === "function") {
            instance.onBlockDeselect(event);
          }
        },
      },
      {
        key: "_createInstance",
        value: function _createInstance(container, constructor) {
          var id = container.getAttribute("data-section-id"),
            type = container.getAttribute("data-section-type");
          constructor = constructor || this.constructors[type];

          if (typeof constructor === "undefined") {
            return;
          }

          try {
            var instance = Object.assign(new constructor(container), {
              id: id,
              type: type,
              container: container,
            });
            this.instances.push(instance);
          } catch (exception) {
            console.log(exception);
            console.error(
              "Logged exception (this may happen if you have tried to edit the code without properly adjusting the JavaScript): " +
                exception.message,
            );
          }
        },
      },
    ]);

    return SectionContainer;
  })();

  var VideoSection = /*#__PURE__*/ (function () {
    function VideoSection(element) {
      _classCallCheck(this, VideoSection);
      this.element = element;
      this.domDelegate = new Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

      this._attachListeners();
    }

    _createClass(VideoSection, [
      {
        key: "onUnload",
        value: function onUnload() {
          this.domDelegate.off("click");
        },
      },
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.domDelegate.on("click", '[data-action="play-video"]', this._playVideo.bind(this));
        },
      },
      {
        key: "_playVideo",
        value: function _playVideo(event, target) {
          // To start the video, we simply replace the iframe source
          var iframe = target.querySelector("iframe");
          iframe.src = iframe.getAttribute("data-src");
          target.classList.add("is-playing");
        },
      },
    ]);

    return VideoSection;
  })();

  var smoothscroll = createCommonjsModule(function (module, exports) {
    /* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
    (function () {
      function polyfill() {
        // aliases
        var w = window;
        var d = document; // return if scroll behavior is supported and polyfill is not forced

        if (
          "scrollBehavior" in d.documentElement.style &&
          w.__forceSmoothScrollPolyfill__ !== true
        ) {
          return;
        } // globals

        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468; // object gathering original scroll methods

        var original = {
          scroll: w.scroll || w.scrollTo,
          scrollBy: w.scrollBy,
          elementScroll: Element.prototype.scroll || scrollElement,
          scrollIntoView: Element.prototype.scrollIntoView,
        }; // define timing method

        var now =
          w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
         * indicates if a the current browser is made by Microsoft
         * @method isMicrosoftBrowser
         * @param {String} userAgent
         * @returns {Boolean}
         */

        function isMicrosoftBrowser(userAgent) {
          var userAgentPatterns = ["MSIE ", "Trident/", "Edge/"];
          return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
         * IE has rounding bug rounding down clientHeight and clientWidth and
         * rounding up scrollHeight and scrollWidth causing false positives
         * on hasScrollableSpace
         */

        var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
         * changes scroll position inside an element
         * @method scrollElement
         * @param {Number} x
         * @param {Number} y
         * @returns {undefined}
         */

        function scrollElement(x, y) {
          this.scrollLeft = x;
          this.scrollTop = y;
        }
        /**
         * returns result of applying ease math function to a number
         * @method ease
         * @param {Number} k
         * @returns {Number}
         */

        function ease(k) {
          return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
         * indicates if a smooth behavior should be applied
         * @method shouldBailOut
         * @param {Number|Object} firstArg
         * @returns {Boolean}
         */

        function shouldBailOut(firstArg) {
          if (
            firstArg === null ||
            _typeof(firstArg) !== "object" ||
            firstArg.behavior === undefined ||
            firstArg.behavior === "auto" ||
            firstArg.behavior === "instant"
          ) {
            // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
          }

          if (_typeof(firstArg) === "object" && firstArg.behavior === "smooth") {
            // first argument is an object and behavior is smooth
            return false;
          } // throw error when behavior is not supported

          throw new TypeError(
            "behavior member of ScrollOptions " +
              firstArg.behavior +
              " is not a valid value for enumeration ScrollBehavior.",
          );
        }
        /**
         * indicates if an element has scrollable space in the provided axis
         * @method hasScrollableSpace
         * @param {Node} el
         * @param {String} axis
         * @returns {Boolean}
         */

        function hasScrollableSpace(el, axis) {
          if (axis === "Y") {
            return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
          }

          if (axis === "X") {
            return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
          }
        }
        /**
         * indicates if an element has a scrollable overflow property in the axis
         * @method canOverflow
         * @param {Node} el
         * @param {String} axis
         * @returns {Boolean}
         */

        function canOverflow(el, axis) {
          var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
          return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
         * indicates if an element can be scrolled in either axis
         * @method isScrollable
         * @param {Node} el
         * @param {String} axis
         * @returns {Boolean}
         */

        function isScrollable(el) {
          var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
          var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
          return isScrollableY || isScrollableX;
        }
        /**
         * finds scrollable parent of an element
         * @method findScrollableParent
         * @param {Node} el
         * @returns {Node} el
         */

        function findScrollableParent(el) {
          while (el !== d.body && isScrollable(el) === false) {
            el = el.parentNode || el.host;
          }

          return el;
        }
        /**
         * self invoked function that, given a context, steps through scrolling
         * @method step
         * @param {Object} context
         * @returns {undefined}
         */

        function step(context) {
          var time = now();
          var value;
          var currentX;
          var currentY;
          var elapsed = (time - context.startTime) / SCROLL_TIME; // avoid elapsed times higher than one

          elapsed = elapsed > 1 ? 1 : elapsed; // apply easing to elapsed time

          value = ease(elapsed);
          currentX = context.startX + (context.x - context.startX) * value;
          currentY = context.startY + (context.y - context.startY) * value;
          context.method.call(context.scrollable, currentX, currentY); // scroll more if we have not reached our destination

          if (currentX !== context.x || currentY !== context.y) {
            w.requestAnimationFrame(step.bind(w, context));
          }
        }
        /**
         * scrolls window or element with a smooth behavior
         * @method smoothScroll
         * @param {Object|Node} el
         * @param {Number} x
         * @param {Number} y
         * @returns {undefined}
         */

        function smoothScroll(el, x, y) {
          var scrollable;
          var startX;
          var startY;
          var method;
          var startTime = now(); // define scroll context

          if (el === d.body) {
            scrollable = w;
            startX = w.scrollX || w.pageXOffset;
            startY = w.scrollY || w.pageYOffset;
            method = original.scroll;
          } else {
            scrollable = el;
            startX = el.scrollLeft;
            startY = el.scrollTop;
            method = scrollElement;
          } // scroll looping over a frame

          step({
            scrollable: scrollable,
            method: method,
            startTime: startTime,
            startX: startX,
            startY: startY,
            x: x,
            y: y,
          });
        } // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo

        w.scroll = w.scrollTo = function () {
          // avoid action when no arguments are passed
          if (arguments[0] === undefined) {
            return;
          } // avoid smooth behavior if not required

          if (shouldBailOut(arguments[0]) === true) {
            original.scroll.call(
              w,
              arguments[0].left !== undefined
                ? arguments[0].left
                : _typeof(arguments[0]) !== "object"
                  ? arguments[0]
                  : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
              arguments[0].top !== undefined
                ? arguments[0].top
                : arguments[1] !== undefined
                  ? arguments[1]
                  : w.scrollY || w.pageYOffset,
            );
            return;
          } // LET THE SMOOTHNESS BEGIN!

          smoothScroll.call(
            w,
            d.body,
            arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset,
            arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset,
          );
        }; // w.scrollBy

        w.scrollBy = function () {
          // avoid action when no arguments are passed
          if (arguments[0] === undefined) {
            return;
          } // avoid smooth behavior if not required

          if (shouldBailOut(arguments[0])) {
            original.scrollBy.call(
              w,
              arguments[0].left !== undefined
                ? arguments[0].left
                : _typeof(arguments[0]) !== "object"
                  ? arguments[0]
                  : 0,
              arguments[0].top !== undefined
                ? arguments[0].top
                : arguments[1] !== undefined
                  ? arguments[1]
                  : 0,
            );
            return;
          } // LET THE SMOOTHNESS BEGIN!

          smoothScroll.call(
            w,
            d.body,
            ~~arguments[0].left + (w.scrollX || w.pageXOffset),
            ~~arguments[0].top + (w.scrollY || w.pageYOffset),
          );
        }; // Element.prototype.scroll and Element.prototype.scrollTo

        Element.prototype.scroll = Element.prototype.scrollTo = function () {
          // avoid action when no arguments are passed
          if (arguments[0] === undefined) {
            return;
          } // avoid smooth behavior if not required

          if (shouldBailOut(arguments[0]) === true) {
            // if one number is passed, throw error to match Firefox implementation
            if (typeof arguments[0] === "number" && arguments[1] === undefined) {
              throw new SyntaxError("Value could not be converted");
            }

            original.elementScroll.call(
              this, // use left prop, first number argument or fallback to scrollLeft
              arguments[0].left !== undefined
                ? ~~arguments[0].left
                : _typeof(arguments[0]) !== "object"
                  ? ~~arguments[0]
                  : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
              arguments[0].top !== undefined
                ? ~~arguments[0].top
                : arguments[1] !== undefined
                  ? ~~arguments[1]
                  : this.scrollTop,
            );
            return;
          }

          var left = arguments[0].left;
          var top = arguments[0].top; // LET THE SMOOTHNESS BEGIN!

          smoothScroll.call(
            this,
            this,
            typeof left === "undefined" ? this.scrollLeft : ~~left,
            typeof top === "undefined" ? this.scrollTop : ~~top,
          );
        }; // Element.prototype.scrollBy

        Element.prototype.scrollBy = function () {
          // avoid action when no arguments are passed
          if (arguments[0] === undefined) {
            return;
          } // avoid smooth behavior if not required

          if (shouldBailOut(arguments[0]) === true) {
            original.elementScroll.call(
              this,
              arguments[0].left !== undefined
                ? ~~arguments[0].left + this.scrollLeft
                : ~~arguments[0] + this.scrollLeft,
              arguments[0].top !== undefined
                ? ~~arguments[0].top + this.scrollTop
                : ~~arguments[1] + this.scrollTop,
            );
            return;
          }

          this.scroll({
            left: ~~arguments[0].left + this.scrollLeft,
            // top: ~~arguments[0].top + this.scrollTop,
            behavior: arguments[0].behavior,
          });
        }; // Element.prototype.scrollIntoView

        Element.prototype.scrollIntoView = function () {
          // avoid smooth behavior if not required
          if (shouldBailOut(arguments[0]) === true) {
            original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
            return;
          } // LET THE SMOOTHNESS BEGIN!

          var scrollableParent = findScrollableParent(this);
          var parentRects = scrollableParent.getBoundingClientRect();
          var clientRects = this.getBoundingClientRect();

          if (scrollableParent !== d.body) {
            // reveal element inside parent
            smoothScroll.call(
              this,
              scrollableParent,
              scrollableParent.scrollLeft + clientRects.left - parentRects.left,
              scrollableParent.scrollTop + clientRects.top - parentRects.top,
            ); // reveal parent in viewport unless is fixed

            if (w.getComputedStyle(scrollableParent).position !== "fixed") {
              w.scrollBy({
                left: parentRects.left,
                top: parentRects.top,
                behavior: "smooth",
              });
            }
          } else {
            // reveal element in viewport
            w.scrollBy({
              left: clientRects.left,
              top: clientRects.top,
              behavior: "smooth",
            });
          }
        };
      }

      {
        // commonjs
        module.exports = {
          polyfill: polyfill,
        };
      }
    })();
  });

  /*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
  var mouseoverTimer;
  var lastTouchTimestamp;
  var prefetches = new Set();
  var prefetchElement = document.createElement("link");
  var isSupported =
    prefetchElement.relList &&
    prefetchElement.relList.supports &&
    prefetchElement.relList.supports("prefetch") &&
    window.IntersectionObserver &&
    "isIntersecting" in IntersectionObserverEntry.prototype;
  var allowQueryString = "instantAllowQueryString" in document.body.dataset;
  var allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;
  var useWhitelist = "instantWhitelist" in document.body.dataset;
  var mousedownShortcut = "instantMousedownShortcut" in document.body.dataset;
  var DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
  var delayOnHover = 65;
  var useMousedown = false;
  var useMousedownOnly = false;
  var useViewport = false;

  if ("instantIntensity" in document.body.dataset) {
    var intensity = document.body.dataset.instantIntensity;

    if (intensity.substr(0, "mousedown".length) == "mousedown") {
      useMousedown = true;

      if (intensity == "mousedown-only") {
        useMousedownOnly = true;
      }
    } else if (intensity.substr(0, "viewport".length) == "viewport") {
      if (
        !(
          navigator.connection &&
          (navigator.connection.saveData ||
            (navigator.connection.effectiveType &&
              navigator.connection.effectiveType.includes("2g")))
        )
      ) {
        if (intensity == "viewport") {
          /* Biggest iPhone resolution (which we want): 414 × 896 = 370944
           * Small 7" tablet resolution (which we don’t want): 600 × 1024 = 614400
           * Note that the viewport (which we check here) is smaller than the resolution due to the UI’s chrome */
          if (
            document.documentElement.clientWidth * document.documentElement.clientHeight <
            450000
          ) {
            useViewport = true;
          }
        } else if (intensity == "viewport-all") {
          useViewport = true;
        }
      }
    } else {
      var milliseconds = parseInt(intensity);

      if (!isNaN(milliseconds)) {
        delayOnHover = milliseconds;
      }
    }
  }

  if (isSupported) {
    var eventListenersOptions = {
      capture: true,
      passive: true,
    };

    if (!useMousedownOnly) {
      document.addEventListener("touchstart", touchstartListener, eventListenersOptions);
    }

    if (!useMousedown) {
      document.addEventListener("mouseover", mouseoverListener, eventListenersOptions);
    } else if (!mousedownShortcut) {
      document.addEventListener("mousedown", mousedownListener, eventListenersOptions);
    }

    if (mousedownShortcut) {
      document.addEventListener("mousedown", mousedownShortcutListener, eventListenersOptions);
    }

    if (useViewport) {
      var triggeringFunction;

      if (window.requestIdleCallback) {
        triggeringFunction = function triggeringFunction(callback) {
          requestIdleCallback(callback, {
            timeout: 1500,
          });
        };
      } else {
        triggeringFunction = function triggeringFunction(callback) {
          callback();
        };
      }

      triggeringFunction(function () {
        var intersectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var linkElement = entry.target;
              intersectionObserver.unobserve(linkElement);
              preload(linkElement.href);
            }
          });
        });
        document.querySelectorAll("a").forEach(function (linkElement) {
          if (isPreloadable(linkElement)) {
            intersectionObserver.observe(linkElement);
          }
        });
      });
    }
  }

  function touchstartListener(event) {
    /* Chrome on Android calls mouseover before touchcancel so `lastTouchTimestamp`
     * must be assigned on touchstart to be measured on mouseover. */
    lastTouchTimestamp = performance.now();
    var linkElement = event.target.closest("a");

    if (!isPreloadable(linkElement)) {
      return;
    }

    preload(linkElement.href);
  }

  function mouseoverListener(event) {
    if (
      performance.now() - lastTouchTimestamp <
      DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION
    ) {
      return;
    }

    var linkElement = event.target.closest("a");

    if (!isPreloadable(linkElement)) {
      return;
    }

    linkElement.addEventListener("mouseout", mouseoutListener, {
      passive: true,
    });
    mouseoverTimer = setTimeout(function () {
      preload(linkElement.href);
      mouseoverTimer = undefined;
    }, delayOnHover);
  }

  function mousedownListener(event) {
    var linkElement = event.target.closest("a");

    if (!isPreloadable(linkElement)) {
      return;
    }

    preload(linkElement.href);
  }

  function mouseoutListener(event) {
    if (event.relatedTarget && event.target.closest("a") == event.relatedTarget.closest("a")) {
      return;
    }

    if (mouseoverTimer) {
      clearTimeout(mouseoverTimer);
      mouseoverTimer = undefined;
    }
  }

  function mousedownShortcutListener(event) {
    if (
      performance.now() - lastTouchTimestamp <
      DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION
    ) {
      return;
    }

    var linkElement = event.target.closest("a");

    if (event.which > 1 || event.metaKey || event.ctrlKey) {
      return;
    }

    if (!linkElement) {
      return;
    }

    linkElement.addEventListener(
      "click",
      function (event) {
        if (event.detail == 1337) {
          return;
        }

        event.preventDefault();
      },
      {
        capture: true,
        passive: false,
        once: true,
      },
    );
    var customEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: false,
      detail: 1337,
    });
    linkElement.dispatchEvent(customEvent);
  }

  function isPreloadable(linkElement) {
    if (!linkElement || !linkElement.href) {
      return;
    }

    if (useWhitelist && !("instant" in linkElement.dataset)) {
      return;
    }

    if (
      !allowExternalLinks &&
      linkElement.origin != location.origin &&
      !("instant" in linkElement.dataset)
    ) {
      return;
    }

    if (!["http:", "https:"].includes(linkElement.protocol)) {
      return;
    }

    if (linkElement.protocol == "http:" && location.protocol == "https:") {
      return;
    }

    if (!allowQueryString && linkElement.search && !("instant" in linkElement.dataset)) {
      return;
    }

    if (
      linkElement.hash &&
      linkElement.pathname + linkElement.search == location.pathname + location.search
    ) {
      return;
    }

    if ("noInstant" in linkElement.dataset) {
      return;
    }

    return true;
  }

  function preload(url) {
    if (prefetches.has(url)) {
      return;
    }

    // var prefetcher = document.createElement("link");
    // prefetcher.rel = "prefetch";
    // prefetcher.href = url;
    // document.head.appendChild(prefetcher);
    // prefetches.add(url);
  }

  var lazysizes = createCommonjsModule(function (module) {
    (function (window, factory) {
      var lazySizes = factory(window, window.document, Date);
      window.lazySizes = lazySizes;

      if (module.exports) {
        module.exports = lazySizes;
      }
    })(typeof window != "undefined" ? window : {}, function l(window, document, Date) {
      /*jshint eqnull:true */

      var lazysizes, lazySizesCfg;

      (function () {
        var prop;
        var lazySizesDefaults = {
          lazyClass: "lazyload",
          loadedClass: "lazyloaded",
          loadingClass: "lazyloading",
          preloadClass: "lazypreload",
          errorClass: "lazyerror",
          //strictClass: 'lazystrict',
          autosizesClass: "lazyautosizes",
          srcAttr: "data-src",
          srcsetAttr: "data-srcset",
          sizesAttr: "data-sizes",
          //preloadAfterLoad: false,
          minSize: 40,
          customMedia: {},
          init: true,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: true,
          ricTimeout: 0,
          throttleDelay: 125,
        };
        lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

        for (prop in lazySizesDefaults) {
          if (!(prop in lazySizesCfg)) {
            lazySizesCfg[prop] = lazySizesDefaults[prop];
          }
        }
      })();

      if (!document || !document.getElementsByClassName) {
        return {
          init: function init() {},
          cfg: lazySizesCfg,
          noSupport: true,
        };
      }

      var docElem = document.documentElement;
      var supportPicture = window.HTMLPictureElement;
      var _addEventListener = "addEventListener";
      var _getAttribute = "getAttribute";
      /**
       * Update to bind to window because 'this' becomes null during SSR
       * builds.
       */

      var addEventListener = window[_addEventListener].bind(window);

      var setTimeout = window.setTimeout;
      var requestAnimationFrame = window.requestAnimationFrame || setTimeout;
      var requestIdleCallback = window.requestIdleCallback;
      var regPicture = /^picture$/i;
      var loadEvents = ["load", "error", "lazyincluded", "_lazyloaded"];
      var regClassCache = {};
      var forEach = Array.prototype.forEach;

      var hasClass = function hasClass(ele, cls) {
        if (!regClassCache[cls]) {
          regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        }

        return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
      };

      var addClass = function addClass(ele, cls) {
        if (!hasClass(ele, cls)) {
          ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
        }
      };

      var removeClass = function removeClass(ele, cls) {
        var reg;

        if ((reg = hasClass(ele, cls))) {
          ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
        }
      };

      var addRemoveLoadEvents = function addRemoveLoadEvents(dom, fn, add) {
        var action = add ? _addEventListener : "removeEventListener";

        if (add) {
          addRemoveLoadEvents(dom, fn);
        }

        loadEvents.forEach(function (evt) {
          dom[action](evt, fn);
        });
      };

      var triggerEvent = function triggerEvent(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent("Event");

        if (!detail) {
          detail = {};
        }

        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
      };

      var updatePolyfill = function updatePolyfill(el, full) {
        var polyfill;

        if (!supportPicture && (polyfill = window.picturefill || lazySizesCfg.pf)) {
          if (full && full.src && !el[_getAttribute]("srcset")) {
            el.setAttribute("srcset", full.src);
          }

          polyfill({
            reevaluate: true,
            elements: [el],
          });
        } else if (full && full.src) {
          el.src = full.src;
        }
      };

      var getCSS = function getCSS(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
      };

      var getWidth = function getWidth(elem, parent, width) {
        width = width || elem.offsetWidth;

        while (width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth) {
          width = parent.offsetWidth;
          parent = parent.parentNode;
        }

        return width;
      };

      var rAF = (function () {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;

        var run = function run() {
          var runFns = fns;
          fns = firstFns.length ? secondFns : firstFns;
          running = true;
          waiting = false;

          while (runFns.length) {
            runFns.shift()();
          }

          running = false;
        };

        var rafBatch = function rafBatch(fn, queue) {
          if (running && !queue) {
            fn.apply(this, arguments);
          } else {
            fns.push(fn);

            if (!waiting) {
              waiting = true;
              (document.hidden ? setTimeout : requestAnimationFrame)(run);
            }
          }
        };

        rafBatch._lsFlush = run;
        return rafBatch;
      })();

      var rAFIt = function rAFIt(fn, simple) {
        return simple
          ? function () {
              rAF(fn);
            }
          : function () {
              var that = this;
              var args = arguments;
              rAF(function () {
                fn.apply(that, args);
              });
            };
      };

      var throttle = function throttle(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;

        var run = function run() {
          running = false;
          lastTime = Date.now();
          fn();
        };

        var idleCallback =
          requestIdleCallback && rICTimeout > 49
            ? function () {
                requestIdleCallback(run, {
                  timeout: rICTimeout,
                });

                if (rICTimeout !== lazySizesCfg.ricTimeout) {
                  rICTimeout = lazySizesCfg.ricTimeout;
                }
              }
            : rAFIt(function () {
                setTimeout(run);
              }, true);
        return function (isPriority) {
          var delay;

          if ((isPriority = isPriority === true)) {
            rICTimeout = 33;
          }

          if (running) {
            return;
          }

          running = true;
          delay = gDelay - (Date.now() - lastTime);

          if (delay < 0) {
            delay = 0;
          }

          if (isPriority || delay < 9) {
            idleCallback();
          } else {
            setTimeout(idleCallback, delay);
          }
        };
      }; //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html

      var debounce = function debounce(func) {
        var timeout, timestamp;
        var wait = 99;

        var run = function run() {
          timeout = null;
          func();
        };

        var later = function later() {
          var last = Date.now() - timestamp;

          if (last < wait) {
            setTimeout(later, wait - last);
          } else {
            (requestIdleCallback || run)(run);
          }
        };

        return function () {
          timestamp = Date.now();

          if (!timeout) {
            timeout = setTimeout(later, wait);
          }
        };
      };

      var loader = (function () {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = "onscroll" in window && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;

        var resetPreloading = function resetPreloading(e) {
          isLoading--;

          if (!e || isLoading < 0 || !e.target) {
            isLoading = 0;
          }
        };

        var isVisible = function isVisible(elem) {
          if (isBodyHidden == null) {
            isBodyHidden = getCSS(document.body, "visibility") == "hidden";
          }

          return (
            isBodyHidden ||
            !(
              getCSS(elem.parentNode, "visibility") == "hidden" &&
              getCSS(elem, "visibility") == "hidden"
            )
          );
        };

        var isNestedVisible = function isNestedVisible(elem, elemExpand) {
          var outerRect;
          var parent = elem;
          var visible = isVisible(elem);
          eLtop -= elemExpand;
          eLbottom += elemExpand;
          eLleft -= elemExpand;
          eLright += elemExpand;

          while (
            visible &&
            (parent = parent.offsetParent) &&
            parent != document.body &&
            parent != docElem
          ) {
            visible = (getCSS(parent, "opacity") || 1) > 0;

            if (visible && getCSS(parent, "overflow") != "visible") {
              outerRect = parent.getBoundingClientRect();
              visible =
                eLright > outerRect.left &&
                eLleft < outerRect.right &&
                eLbottom > outerRect.top - 1 &&
                eLtop < outerRect.bottom + 1;
            }
          }

          return visible;
        };

        var checkElements = function checkElements() {
          var eLlen,
            i,
            rect,
            autoLoadElem,
            loadedSomething,
            elemExpand,
            elemNegativeExpand,
            elemExpandVal,
            beforeExpandVal,
            defaultExpand,
            preloadExpand,
            hFac;
          var lazyloadElems = lazysizes.elements;

          if (
            (loadMode = lazySizesCfg.loadMode) &&
            isLoading < 8 &&
            (eLlen = lazyloadElems.length)
          ) {
            i = 0;
            lowRuns++;

            for (; i < eLlen; i++) {
              if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
                continue;
              }

              if (
                !supportScroll ||
                (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))
              ) {
                unveilElement(lazyloadElems[i]);
                continue;
              }

              if (
                !(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) ||
                !(elemExpand = elemExpandVal * 1)
              ) {
                elemExpand = currentExpand;
              }

              if (!defaultExpand) {
                defaultExpand =
                  !lazySizesCfg.expand || lazySizesCfg.expand < 1
                    ? docElem.clientHeight > 500 && docElem.clientWidth > 500
                      ? 500
                      : 370
                    : lazySizesCfg.expand;
                lazysizes._defEx = defaultExpand;
                preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                hFac = lazySizesCfg.hFac;
                isBodyHidden = null;

                if (
                  currentExpand < preloadExpand &&
                  isLoading < 1 &&
                  lowRuns > 2 &&
                  loadMode > 2 &&
                  !document.hidden
                ) {
                  currentExpand = preloadExpand;
                  lowRuns = 0;
                } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
                  currentExpand = defaultExpand;
                } else {
                  currentExpand = shrinkExpand;
                }
              }

              if (beforeExpandVal !== elemExpand) {
                eLvW = innerWidth + elemExpand * hFac;
                elvH = innerHeight + elemExpand;
                elemNegativeExpand = elemExpand * -1;
                beforeExpandVal = elemExpand;
              }

              rect = lazyloadElems[i].getBoundingClientRect();

              if (
                (eLbottom = rect.bottom) >= elemNegativeExpand &&
                (eLtop = rect.top) <= elvH &&
                (eLright = rect.right) >= elemNegativeExpand * hFac &&
                (eLleft = rect.left) <= eLvW &&
                (eLbottom || eLright || eLleft || eLtop) &&
                (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
                ((isCompleted &&
                  isLoading < 3 &&
                  !elemExpandVal &&
                  (loadMode < 3 || lowRuns < 4)) ||
                  isNestedVisible(lazyloadElems[i], elemExpand))
              ) {
                unveilElement(lazyloadElems[i]);
                loadedSomething = true;

                if (isLoading > 9) {
                  break;
                }
              } else if (
                !loadedSomething &&
                isCompleted &&
                !autoLoadElem &&
                isLoading < 4 &&
                lowRuns < 4 &&
                loadMode > 2 &&
                (preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
                (preloadElems[0] ||
                  (!elemExpandVal &&
                    (eLbottom ||
                      eLright ||
                      eLleft ||
                      eLtop ||
                      lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto")))
              ) {
                autoLoadElem = preloadElems[0] || lazyloadElems[i];
              }
            }

            if (autoLoadElem && !loadedSomething) {
              unveilElement(autoLoadElem);
            }
          }
        };

        var throttledCheckElements = throttle(checkElements);

        var switchLoadingClass = function switchLoadingClass(e) {
          var elem = e.target;

          if (elem._lazyCache) {
            delete elem._lazyCache;
            return;
          }

          resetPreloading(e);
          addClass(elem, lazySizesCfg.loadedClass);
          removeClass(elem, lazySizesCfg.loadingClass);
          addRemoveLoadEvents(elem, rafSwitchLoadingClass);
          triggerEvent(elem, "lazyloaded");
        };

        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);

        var rafSwitchLoadingClass = function rafSwitchLoadingClass(e) {
          rafedSwitchLoadingClass({
            target: e.target,
          });
        };

        var changeIframeSrc = function changeIframeSrc(elem, src) {
          try {
            elem.contentWindow.location.replace(src);
          } catch (e) {
            elem.src = src;
          }
        };

        var handleSources = function handleSources(source) {
          var customMedia;

          var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

          if (
            (customMedia =
              lazySizesCfg.customMedia[
                source[_getAttribute]("data-media") || source[_getAttribute]("media")
              ])
          ) {
            source.setAttribute("media", customMedia);
          }

          if (sourceSrcset) {
            source.setAttribute("srcset", sourceSrcset);
          }
        };

        var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg) {
          var src, srcset, parent, isPicture, event, firesLoad;

          if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
            if (sizes) {
              if (isAuto) {
                addClass(elem, lazySizesCfg.autosizesClass);
              } else {
                elem.setAttribute("sizes", sizes);
              }
            }

            srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
            src = elem[_getAttribute](lazySizesCfg.srcAttr);

            if (isImg) {
              parent = elem.parentNode;
              isPicture = parent && regPicture.test(parent.nodeName || "");
            }

            firesLoad = detail.firesLoad || ("src" in elem && (srcset || src || isPicture));
            event = {
              target: elem,
            };
            addClass(elem, lazySizesCfg.loadingClass);

            if (firesLoad) {
              clearTimeout(resetPreloadingTimer);
              resetPreloadingTimer = setTimeout(resetPreloading, 2500);
              addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
            }

            if (isPicture) {
              forEach.call(parent.getElementsByTagName("source"), handleSources);
            }

            if (srcset) {
              elem.setAttribute("srcset", srcset);
            } else if (src && !isPicture) {
              if (regIframe.test(elem.nodeName)) {
                changeIframeSrc(elem, src);
              } else {
                elem.src = src;
              }
            }

            if (isImg && (srcset || isPicture)) {
              updatePolyfill(elem, {
                src: src,
              });
            }
          }

          if (elem._lazyRace) {
            delete elem._lazyRace;
          }

          removeClass(elem, lazySizesCfg.lazyClass);
          rAF(function () {
            // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
            var isLoaded = elem.complete && elem.naturalWidth > 1;

            if (!firesLoad || isLoaded) {
              if (isLoaded) {
                addClass(elem, "ls-is-cached");
              }

              switchLoadingClass(event);
              elem._lazyCache = true;
              setTimeout(function () {
                if ("_lazyCache" in elem) {
                  delete elem._lazyCache;
                }
              }, 9);
            }

            if (elem.loading == "lazy") {
              isLoading--;
            }
          }, true);
        });

        var unveilElement = function unveilElement(elem) {
          if (elem._lazyRace) {
            return;
          }

          var detail;
          var isImg = regImg.test(elem.nodeName); //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")

          var sizes =
            isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));

          var isAuto = sizes == "auto";

          if (
            (isAuto || !isCompleted) &&
            isImg &&
            (elem[_getAttribute]("src") || elem.srcset) &&
            !elem.complete &&
            !hasClass(elem, lazySizesCfg.errorClass) &&
            hasClass(elem, lazySizesCfg.lazyClass)
          ) {
            return;
          }

          detail = triggerEvent(elem, "lazyunveilread").detail;

          if (isAuto) {
            autoSizer.updateElem(elem, true, elem.offsetWidth);
          }

          elem._lazyRace = true;
          isLoading++;
          lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };

        var afterScroll = debounce(function () {
          lazySizesCfg.loadMode = 3;
          throttledCheckElements();
        });

        var altLoadmodeScrollListner = function altLoadmodeScrollListner() {
          if (lazySizesCfg.loadMode == 3) {
            lazySizesCfg.loadMode = 2;
          }

          afterScroll();
        };

        var onload = function onload() {
          if (isCompleted) {
            return;
          }

          if (Date.now() - started < 999) {
            setTimeout(onload, 999);
            return;
          }

          isCompleted = true;
          lazySizesCfg.loadMode = 3;
          throttledCheckElements();
          addEventListener("scroll", altLoadmodeScrollListner, true);
        };

        return {
          _: function _() {
            started = Date.now();
            lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
            preloadElems = document.getElementsByClassName(
              lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass,
            );
            addEventListener("scroll", throttledCheckElements, true);
            addEventListener("resize", throttledCheckElements, true);
            addEventListener("pageshow", function (e) {
              if (e.persisted) {
                var loadingElements = document.querySelectorAll("." + lazySizesCfg.loadingClass);

                if (loadingElements.length && loadingElements.forEach) {
                  requestAnimationFrame(function () {
                    loadingElements.forEach(function (img) {
                      if (img.complete) {
                        unveilElement(img);
                      }
                    });
                  });
                }
              }
            });

            if (window.MutationObserver) {
              new MutationObserver(throttledCheckElements).observe(docElem, {
                childList: true,
                subtree: true,
                attributes: true,
              });
            } else {
              docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);

              docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);

              setInterval(throttledCheckElements, 999);
            }

            addEventListener("hashchange", throttledCheckElements, true); //, 'fullscreenchange'

            ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(
              function (name) {
                document[_addEventListener](name, throttledCheckElements, true);
              },
            );

            if (/d$|^c/.test(document.readyState)) {
              onload();
            } else {
              addEventListener("load", onload);

              document[_addEventListener]("DOMContentLoaded", throttledCheckElements);

              setTimeout(onload, 20000);
            }

            if (lazysizes.elements.length) {
              checkElements();

              rAF._lsFlush();
            } else {
              throttledCheckElements();
            }
          },
          checkElems: throttledCheckElements,
          unveil: unveilElement,
          _aLSL: altLoadmodeScrollListner,
        };
      })();

      var autoSizer = (function () {
        var autosizesElems;
        var sizeElement = rAFIt(function (elem, parent, event, width) {
          var sources, i, len;
          elem._lazysizesWidth = width;
          width += "px";
          elem.setAttribute("sizes", width);

          if (regPicture.test(parent.nodeName || "")) {
            sources = parent.getElementsByTagName("source");

            for (i = 0, len = sources.length; i < len; i++) {
              sources[i].setAttribute("sizes", width);
            }
          }

          if (!event.detail.dataAttr) {
            updatePolyfill(elem, event.detail);
          }
        });

        var getSizeElement = function getSizeElement(elem, dataAttr, width) {
          var event;
          var parent = elem.parentNode;

          if (parent) {
            width = getWidth(elem, parent, width);
            event = triggerEvent(elem, "lazybeforesizes", {
              width: width,
              dataAttr: !!dataAttr,
            });

            if (!event.defaultPrevented) {
              width = event.detail.width;

              if (width && width !== elem._lazysizesWidth) {
                sizeElement(elem, parent, event, width);
              }
            }
          }
        };

        var updateElementsSizes = function updateElementsSizes() {
          var i;
          var len = autosizesElems.length;

          if (len) {
            i = 0;

            for (; i < len; i++) {
              getSizeElement(autosizesElems[i]);
            }
          }
        };

        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
          _: function _() {
            autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
            addEventListener("resize", debouncedUpdateElementsSizes);
          },
          checkElems: debouncedUpdateElementsSizes,
          updateElem: getSizeElement,
        };
      })();

      var init = function init() {
        if (!init.i && document.getElementsByClassName) {
          init.i = true;

          autoSizer._();

          loader._();
        }
      };

      setTimeout(function () {
        if (lazySizesCfg.init) {
          init();
        }
      });
      lazysizes = {
        cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF,
      };
      return lazysizes;
    });
  });

  var ls_rias = createCommonjsModule(function (module) {
    (function (window, factory) {
      var globalInstall = function globalInstall() {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (module.exports) {
        factory(lazysizes);
      } else if (window.lazySizes) {
        globalInstall();
      } else {
        window.addEventListener("lazyunveilread", globalInstall, true);
      }
    })(window, function (window, document, lazySizes) {
      var config, riasCfg;
      var lazySizesCfg = lazySizes.cfg;
      var replaceTypes = {
        string: 1,
        number: 1,
      };
      var regNumber = /^\-*\+*\d+\.*\d*$/;
      var regPicture = /^picture$/i;
      var regWidth = /\s*\{\s*width\s*\}\s*/i;
      var regHeight = /\s*\{\s*height\s*\}\s*/i;
      var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi;
      var regObj = /^\[.*\]|\{.*\}$/;
      var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
      var anchor = document.createElement("a");
      var img = document.createElement("img");
      var buggySizes = "srcset" in img && !("sizes" in img);
      var supportPicture = !!window.HTMLPictureElement && !buggySizes;

      (function () {
        var prop;

        var noop = function noop() {};

        var riasDefaults = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: false,
          modifyOptions: noop,
          widthmap: {},
          ratio: false,
          traditionalRatio: false,
          aspectratio: false,
        };
        config = lazySizes && lazySizes.cfg;

        if (!config.supportsType) {
          config.supportsType = function (
            type,
            /*, elem*/
          ) {
            return !type;
          };
        }

        if (!config.rias) {
          config.rias = {};
        }

        riasCfg = config.rias;

        if (!("widths" in riasCfg)) {
          riasCfg.widths = [];

          (function (widths) {
            var width;
            var i = 0;

            while (!width || width < 3000) {
              i += 5;

              if (i > 30) {
                i += 1;
              }

              width = 36 * i;
              widths.push(width);
            }
          })(riasCfg.widths);
        }

        for (prop in riasDefaults) {
          if (!(prop in riasCfg)) {
            riasCfg[prop] = riasDefaults[prop];
          }
        }
      })();

      function getElementOptions(elem, src) {
        var attr, parent, setOption, options;
        var elemStyles = window.getComputedStyle(elem);
        parent = elem.parentNode;
        options = {
          isPicture: !!(parent && regPicture.test(parent.nodeName || "")),
        };

        setOption = function setOption(attr, run) {
          var attrVal = elem.getAttribute("data-" + attr);

          if (!attrVal) {
            // no data- attr, get value from the CSS
            var styles = elemStyles.getPropertyValue("--ls-" + attr); // at least Safari 9 returns null rather than
            // an empty string for getPropertyValue causing
            // .trim() to fail

            if (styles) {
              attrVal = styles.trim();
            }
          }

          if (attrVal) {
            if (attrVal == "true") {
              attrVal = true;
            } else if (attrVal == "false") {
              attrVal = false;
            } else if (regNumber.test(attrVal)) {
              attrVal = parseFloat(attrVal);
            } else if (typeof riasCfg[attr] == "function") {
              attrVal = riasCfg[attr](elem, attrVal);
            } else if (regObj.test(attrVal)) {
              try {
                attrVal = JSON.parse(attrVal);
              } catch (e) {}
            }

            options[attr] = attrVal;
          } else if (attr in riasCfg && typeof riasCfg[attr] != "function") {
            options[attr] = riasCfg[attr];
          } else if (run && typeof riasCfg[attr] == "function") {
            options[attr] = riasCfg[attr](elem, attrVal);
          }
        };

        for (attr in riasCfg) {
          setOption(attr);
        }

        src.replace(regPlaceholder, function (full, match) {
          if (!(match in options)) {
            setOption(match, true);
          }
        });
        return options;
      }

      function replaceUrlProps(url, options) {
        var candidates = [];

        var replaceFn = function replaceFn(full, match) {
          return replaceTypes[_typeof(options[match])] ? options[match] : full;
        };

        candidates.srcset = [];

        if (options.absUrl) {
          anchor.setAttribute("href", url);
          url = anchor.href;
        }

        url = ((options.prefix || "") + url + (options.postfix || "")).replace(
          regPlaceholder,
          replaceFn,
        );
        options.widths.forEach(function (width) {
          var widthAlias = options.widthmap[width] || width;
          var ratio = options.aspectratio || options.ratio;
          var traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio;
          var candidate = {
            u: url
              .replace(regWidth, widthAlias)
              .replace(
                regHeight,
                ratio
                  ? traditionalRatio
                    ? Math.round(width * ratio)
                    : Math.round(width / ratio)
                  : "",
              ),
            w: width,
          };
          candidates.push(candidate);
          candidates.srcset.push((candidate.c = candidate.u + " " + width + "w"));
        });
        return candidates;
      }

      function setSrc(src, opts, elem) {
        var elemW = 0;
        var elemH = 0;
        var sizeElement = elem;

        if (!src) {
          return;
        }

        if (opts.ratio === "container") {
          // calculate image or parent ratio
          elemW = sizeElement.scrollWidth;
          elemH = sizeElement.scrollHeight;

          while ((!elemW || !elemH) && sizeElement !== document) {
            sizeElement = sizeElement.parentNode;
            elemW = sizeElement.scrollWidth;
            elemH = sizeElement.scrollHeight;
          }

          if (elemW && elemH) {
            opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH;
          }
        }

        src = replaceUrlProps(src, opts);
        src.isPicture = opts.isPicture;

        if (buggySizes && elem.nodeName.toUpperCase() == "IMG") {
          elem.removeAttribute(config.srcsetAttr);
        } else {
          elem.setAttribute(config.srcsetAttr, src.srcset.join(", "));
        }

        Object.defineProperty(elem, "_lazyrias", {
          value: src,
          writable: true,
        });
      }

      function createAttrObject(elem, src) {
        var opts = getElementOptions(elem, src);
        riasCfg.modifyOptions.call(elem, {
          target: elem,
          details: opts,
          detail: opts,
        });
        lazySizes.fire(elem, "lazyriasmodifyoptions", opts);
        return opts;
      }

      function getSrc(elem) {
        return (
          elem.getAttribute(elem.getAttribute("data-srcattr") || riasCfg.srcAttr) ||
          elem.getAttribute(config.srcsetAttr) ||
          elem.getAttribute(config.srcAttr) ||
          elem.getAttribute("data-pfsrcset") ||
          ""
        );
      }

      addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance != lazySizes) {
            return;
          }

          var elem,
            src,
            elemOpts,
            parent,
            sources,
            i,
            len,
            sourceSrc,
            sizes,
            detail,
            hasPlaceholder,
            modified,
            emptyList;
          elem = e.target;

          if (
            !e.detail.dataAttr ||
            e.defaultPrevented ||
            riasCfg.disabled ||
            !(
              (sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute("sizes")) &&
              regAllowedSizes.test(sizes)
            )
          ) {
            return;
          }

          src = getSrc(elem);
          elemOpts = createAttrObject(elem, src);
          hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);

          if (elemOpts.isPicture && (parent = elem.parentNode)) {
            sources = parent.getElementsByTagName("source");

            for (i = 0, len = sources.length; i < len; i++) {
              if (hasPlaceholder || regWidth.test((sourceSrc = getSrc(sources[i])))) {
                setSrc(sourceSrc, elemOpts, sources[i]);
                modified = true;
              }
            }
          }

          if (hasPlaceholder || regWidth.test(src)) {
            setSrc(src, elemOpts, elem);
            modified = true;
          } else if (modified) {
            emptyList = [];
            emptyList.srcset = [];
            emptyList.isPicture = true;
            Object.defineProperty(elem, "_lazyrias", {
              value: emptyList,
              writable: true,
            });
          }

          if (modified) {
            if (supportPicture) {
              elem.removeAttribute(config.srcAttr);
            } else if (sizes != "auto") {
              detail = {
                width: parseInt(sizes, 10),
              };
              polyfill({
                target: elem,
                detail: detail,
              });
            }
          }
        },
        true,
      ); // partial polyfill

      var polyfill = (function () {
        var ascendingSort = function ascendingSort(a, b) {
          return a.w - b.w;
        };

        var reduceCandidate = function reduceCandidate(srces) {
          var lowerCandidate, bonusFactor;
          var len = srces.length;
          var candidate = srces[len - 1];
          var i = 0;

          for (i; i < len; i++) {
            candidate = srces[i];
            candidate.d = candidate.w / srces.w;

            if (candidate.d >= srces.d) {
              if (
                !candidate.cached &&
                (lowerCandidate = srces[i - 1]) &&
                lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)
              ) {
                bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

                if (lowerCandidate.cached) {
                  lowerCandidate.d += 0.15 * bonusFactor;
                }

                if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) {
                  candidate = lowerCandidate;
                }
              }

              break;
            }
          }

          return candidate;
        };

        var getWSet = function getWSet(elem, testPicture) {
          var src;

          if (
            !elem._lazyrias &&
            lazySizes.pWS &&
            (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ""))).length
          ) {
            Object.defineProperty(elem, "_lazyrias", {
              value: src,
              writable: true,
            });

            if (testPicture && elem.parentNode) {
              src.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE";
            }
          }

          return elem._lazyrias;
        };

        var getX = function getX(elem) {
          var dpr = window.devicePixelRatio || 1;
          var optimum = lazySizes.getX && lazySizes.getX(elem);
          return Math.min(optimum || dpr, 2.4, dpr);
        };

        var getCandidate = function getCandidate(elem, width) {
          var sources, i, len, media, srces, src;
          srces = elem._lazyrias;

          if (srces.isPicture && window.matchMedia) {
            for (
              i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length;
              i < len;
              i++
            ) {
              if (
                getWSet(sources[i]) &&
                !sources[i].getAttribute("type") &&
                (!(media = sources[i].getAttribute("media")) || (matchMedia(media) || {}).matches)
              ) {
                srces = sources[i]._lazyrias;
                break;
              }
            }
          }

          if (!srces.w || srces.w < width) {
            srces.w = width;
            srces.d = getX(elem);
            src = reduceCandidate(srces.sort(ascendingSort));
          }

          return src;
        };

        var _polyfill = function polyfill(e) {
          if (e.detail.instance != lazySizes) {
            return;
          }

          var candidate;
          var elem = e.target;

          if (!buggySizes && (window.respimage || window.picturefill || lazySizesCfg.pf)) {
            document.removeEventListener("lazybeforesizes", _polyfill);
            return;
          }

          if (!("_lazyrias" in elem) && (!e.detail.dataAttr || !getWSet(elem, true))) {
            return;
          }

          candidate = getCandidate(elem, e.detail.width);

          if (candidate && candidate.u && elem._lazyrias.cur != candidate.u) {
            elem._lazyrias.cur = candidate.u;
            candidate.cached = true;
            lazySizes.rAF(function () {
              elem.setAttribute(config.srcAttr, candidate.u);
              elem.setAttribute("src", candidate.u);
            });
          }
        };

        if (!supportPicture) {
          addEventListener("lazybeforesizes", _polyfill);
        } else {
          _polyfill = function _polyfill() {};
        }

        return _polyfill;
      })();
    });
  });

  var ls_unveilhooks = createCommonjsModule(function (module) {
    /*
    This plugin extends lazySizes to lazyLoad:
    background images, videos/posters and scripts
    
    Background-Image:
    For background images, use data-bg attribute:
    <div class="lazyload" data-bg="bg-img.jpg"></div>
    
     Video:
     For video/audio use data-poster and preload="none":
     <video class="lazyload" preload="none" data-poster="poster.jpg" src="src.mp4">
     <!-- sources -->
     </video>
    
     For video that plays automatically if in view:
     <video
    	class="lazyload"
    	preload="none"
    	muted=""
    	data-autoplay=""
    	data-poster="poster.jpg"
    	src="src.mp4">
    </video>
    
     Scripts:
     For scripts use data-script:
     <div class="lazyload" data-script="module-name.js"></div>
    
    
     Script modules using require:
     For modules using require use data-require:
     <div class="lazyload" data-require="module-name"></div>
    */
    (function (window, factory) {
      var globalInstall = function globalInstall() {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (module.exports) {
        factory(lazysizes);
      } else if (window.lazySizes) {
        globalInstall();
      } else {
        window.addEventListener("lazyunveilread", globalInstall, true);
      }
    })(window, function (window, document, lazySizes) {
      var bgLoad, regBgUrlEscape;
      var uniqueUrls = {};

      if (document.addEventListener) {
        regBgUrlEscape = /\(|\)|\s|'/;

        bgLoad = function bgLoad(url, cb) {
          var img = document.createElement("img");

          img.onload = function () {
            img.onload = null;
            img.onerror = null;
            img = null;
            cb();
          };

          img.onerror = img.onload;
          img.src = url;

          if (img && img.complete && img.onload) {
            img.onload();
          }
        };

        addEventListener(
          "lazybeforeunveil",
          function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }

            var tmp, load, bg, poster;

            if (!e.defaultPrevented) {
              var target = e.target;

              if (target.preload == "none") {
                target.preload = target.getAttribute("data-preload") || "auto";
              }

              if (target.getAttribute("data-autoplay") != null) {
                if (target.getAttribute("data-expand") && !target.autoplay) {
                  try {
                    target.play();
                  } catch (er) {}
                } else {
                  requestAnimationFrame(function () {
                    target.setAttribute("data-expand", "-10");
                    lazySizes.aC(target, lazySizes.cfg.lazyClass);
                  });
                }
              }

              tmp = target.getAttribute("data-link");

              if (tmp) {
                addStyleScript(tmp, true);
              } // handle data-script

              tmp = target.getAttribute("data-script");

              if (tmp) {
                addStyleScript(tmp);
              } // handle data-require

              tmp = target.getAttribute("data-require");

              if (tmp) {
                if (lazySizes.cfg.requireJs) {
                  lazySizes.cfg.requireJs([tmp]);
                } else {
                  addStyleScript(tmp);
                }
              } // handle data-bg

              bg = target.getAttribute("data-bg");

              if (bg) {
                e.detail.firesLoad = true;

                load = function load() {
                  target.style.backgroundImage =
                    "url(" + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg) + ")";
                  e.detail.firesLoad = false;
                  lazySizes.fire(target, "_lazyloaded", {}, true, true);
                };

                bgLoad(bg, load);
              } // handle data-poster

              poster = target.getAttribute("data-poster");

              if (poster) {
                e.detail.firesLoad = true;

                load = function load() {
                  target.poster = poster;
                  e.detail.firesLoad = false;
                  lazySizes.fire(target, "_lazyloaded", {}, true, true);
                };

                bgLoad(poster, load);
              }
            }
          },
          false,
        );
      }

      function addStyleScript(src, style) {
        if (uniqueUrls[src]) {
          return;
        }

        var elem = document.createElement(style ? "link" : "script");
        var insertElem = document.getElementsByTagName("script")[0];

        if (style) {
          elem.rel = "stylesheet";
          elem.href = src;
        } else {
          elem.src = src;
        }

        uniqueUrls[src] = true;
        uniqueUrls[elem.src || elem.href] = true;
        insertElem.parentNode.insertBefore(elem, insertElem);
      }
    });
  });

  var ls_bgset = createCommonjsModule(function (module) {
    (function (window, factory) {
      var globalInstall = function globalInstall() {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (module.exports) {
        factory(lazysizes);
      } else if (window.lazySizes) {
        globalInstall();
      } else {
        window.addEventListener("lazyunveilread", globalInstall, true);
      }
    })(window, function (window, document, lazySizes) {
      if (!window.addEventListener) {
        return;
      }

      var lazySizesCfg = lazySizes.cfg;
      var regWhite = /\s+/g;
      var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
      var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
      var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
      var regBgUrlEscape = /\(|\)|'/;
      var allowedBackgroundSize = {
        contain: 1,
        cover: 1,
      };

      var proxyWidth = function proxyWidth(elem) {
        var width = lazySizes.gW(elem, elem.parentNode);

        if (!elem._lazysizesWidth || width > elem._lazysizesWidth) {
          elem._lazysizesWidth = width;
        }

        return elem._lazysizesWidth;
      };

      var getBgSize = function getBgSize(elem) {
        var bgSize;
        bgSize = (
          getComputedStyle(elem) || {
            getPropertyValue: function getPropertyValue() {},
          }
        ).getPropertyValue("background-size");

        if (!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]) {
          bgSize = elem.style.backgroundSize;
        }

        return bgSize;
      };

      var setTypeOrMedia = function setTypeOrMedia(source, match) {
        if (match) {
          var typeMatch = match.match(regType);

          if (typeMatch && typeMatch[1]) {
            source.setAttribute("type", typeMatch[1]);
          } else {
            source.setAttribute("media", lazySizesCfg.customMedia[match] || match);
          }
        }
      };

      var createPicture = function createPicture(sets, elem, img) {
        var picture = document.createElement("picture");
        var sizes = elem.getAttribute(lazySizesCfg.sizesAttr);
        var ratio = elem.getAttribute("data-ratio");
        var optimumx = elem.getAttribute("data-optimumx");

        if (elem._lazybgset && elem._lazybgset.parentNode == elem) {
          elem.removeChild(elem._lazybgset);
        }

        Object.defineProperty(img, "_lazybgset", {
          value: elem,
          writable: true,
        });
        Object.defineProperty(elem, "_lazybgset", {
          value: picture,
          writable: true,
        });
        sets = sets.replace(regWhite, " ").split(regSplitSet);
        picture.style.display = "none";
        img.className = lazySizesCfg.lazyClass;

        if (sets.length == 1 && !sizes) {
          sizes = "auto";
        }

        sets.forEach(function (set) {
          var match;
          var source = document.createElement("source");

          if (sizes && sizes != "auto") {
            source.setAttribute("sizes", sizes);
          }

          if ((match = set.match(regSource))) {
            source.setAttribute(lazySizesCfg.srcsetAttr, match[1]);
            setTypeOrMedia(source, match[2]);
            setTypeOrMedia(source, match[3]);
          } else {
            source.setAttribute(lazySizesCfg.srcsetAttr, set);
          }

          picture.appendChild(source);
        });

        if (sizes) {
          img.setAttribute(lazySizesCfg.sizesAttr, sizes);
          elem.removeAttribute(lazySizesCfg.sizesAttr);
          elem.removeAttribute("sizes");
        }

        if (optimumx) {
          img.setAttribute("data-optimumx", optimumx);
        }

        if (ratio) {
          img.setAttribute("data-ratio", ratio);
        }

        picture.appendChild(img);
        elem.appendChild(picture);
      };

      var proxyLoad = function proxyLoad(e) {
        if (!e.target._lazybgset) {
          return;
        }

        var image = e.target;
        var elem = image._lazybgset;
        var bg = image.currentSrc || image.src;

        if (bg) {
          var event = lazySizes.fire(elem, "bgsetproxy", {
            src: bg,
            useSrc: regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg,
          });

          if (!event.defaultPrevented) {
            elem.style.backgroundImage = "url(" + event.detail.useSrc + ")";
          }
        }

        if (image._lazybgsetLoading) {
          lazySizes.fire(elem, "_lazyloaded", {}, false, true);
          delete image._lazybgsetLoading;
        }
      };

      addEventListener("lazybeforeunveil", function (e) {
        var set, image, elem;

        if (e.defaultPrevented || !(set = e.target.getAttribute("data-bgset"))) {
          return;
        }

        elem = e.target;
        image = document.createElement("img");
        image.alt = "";
        image._lazybgsetLoading = true;
        e.detail.firesLoad = true;
        createPicture(set, elem, image);
        setTimeout(function () {
          lazySizes.loader.unveil(image);
          lazySizes.rAF(function () {
            lazySizes.fire(image, "_lazyloaded", {}, true, true);

            if (image.complete) {
              proxyLoad({
                target: image,
              });
            }
          });
        });
      });
      document.addEventListener("load", proxyLoad, true);
      window.addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance != lazySizes) {
            return;
          }

          if (e.target._lazybgset && e.detail.dataAttr) {
            var elem = e.target._lazybgset;
            var bgSize = getBgSize(elem);

            if (allowedBackgroundSize[bgSize]) {
              e.target._lazysizesParentFit = bgSize;
              lazySizes.rAF(function () {
                e.target.setAttribute("data-parent-fit", bgSize);

                if (e.target._lazysizesParentFit) {
                  delete e.target._lazysizesParentFit;
                }
              });
            }
          }
        },
        true,
      );
      document.documentElement.addEventListener("lazybeforesizes", function (e) {
        if (e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes) {
          return;
        }

        e.detail.width = proxyWidth(e.target._lazybgset);
      });
    });
  });

  var ls_respimg = createCommonjsModule(function (module) {
    (function (window, factory) {
      if (!window) {
        return;
      }

      var globalInstall = function globalInstall() {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (module.exports) {
        factory(lazysizes);
      } else if (window.lazySizes) {
        globalInstall();
      } else {
        window.addEventListener("lazyunveilread", globalInstall, true);
      }
    })(typeof window != "undefined" ? window : 0, function (window, document, lazySizes) {
      var polyfill;
      var lazySizesCfg = lazySizes.cfg;
      var img = document.createElement("img");
      var supportSrcset = "sizes" in img && "srcset" in img;
      var regHDesc = /\s+\d+h/g;

      var fixEdgeHDescriptor = (function () {
        var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
        var forEach = Array.prototype.forEach;
        return function () {
          var img = document.createElement("img");

          var removeHDescriptors = function removeHDescriptors(source) {
            var ratio, match;
            var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);

            if (srcset) {
              if ((match = srcset.match(regDescriptors))) {
                if (match[2] == "w") {
                  ratio = match[1] / match[3];
                } else {
                  ratio = match[3] / match[1];
                }

                if (ratio) {
                  source.setAttribute("data-aspectratio", ratio);
                }

                source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ""));
              }
            }
          };

          var handler = function handler(e) {
            if (e.detail.instance != lazySizes) {
              return;
            }

            var picture = e.target.parentNode;

            if (picture && picture.nodeName == "PICTURE") {
              forEach.call(picture.getElementsByTagName("source"), removeHDescriptors);
            }

            removeHDescriptors(e.target);
          };

          var test = function test() {
            if (!!img.currentSrc) {
              document.removeEventListener("lazybeforeunveil", handler);
            }
          };

          document.addEventListener("lazybeforeunveil", handler);
          img.onload = test;
          img.onerror = test;
          img.srcset = "data:,a 1w 1h";

          if (img.complete) {
            test();
          }
        };
      })();

      if (!lazySizesCfg.supportsType) {
        lazySizesCfg.supportsType = function (
          type,
          /*, elem*/
        ) {
          return !type;
        };
      }

      if (window.HTMLPictureElement && supportSrcset) {
        if (!lazySizes.hasHDescriptorFix && document.msElementsFromPoint) {
          lazySizes.hasHDescriptorFix = true;
          fixEdgeHDescriptor();
        }

        return;
      }

      if (window.picturefill || lazySizesCfg.pf) {
        return;
      }

      lazySizesCfg.pf = function (options) {
        var i, len;

        if (window.picturefill) {
          return;
        }

        for (i = 0, len = options.elements.length; i < len; i++) {
          polyfill(options.elements[i]);
        }
      }; // partial polyfill

      polyfill = (function () {
        var ascendingSort = function ascendingSort(a, b) {
          return a.w - b.w;
        };

        var regPxLength = /^\s*\d+\.*\d*px\s*$/;

        var reduceCandidate = function reduceCandidate(srces) {
          var lowerCandidate, bonusFactor;
          var len = srces.length;
          var candidate = srces[len - 1];
          var i = 0;

          for (i; i < len; i++) {
            candidate = srces[i];
            candidate.d = candidate.w / srces.w;

            if (candidate.d >= srces.d) {
              if (
                !candidate.cached &&
                (lowerCandidate = srces[i - 1]) &&
                lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)
              ) {
                bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

                if (lowerCandidate.cached) {
                  lowerCandidate.d += 0.15 * bonusFactor;
                }

                if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) {
                  candidate = lowerCandidate;
                }
              }

              break;
            }
          }

          return candidate;
        };

        var parseWsrcset = (function () {
          var candidates;
          var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
          var regMultiple = /\s/;

          var addCandidate = function addCandidate(match, candidate, url, wDescriptor) {
            candidates.push({
              c: candidate,
              u: url,
              w: wDescriptor * 1,
            });
          };

          return function (input) {
            candidates = [];
            input = input.trim();
            input.replace(regHDesc, "").replace(regWCandidates, addCandidate);

            if (!candidates.length && input && !regMultiple.test(input)) {
              candidates.push({
                c: input,
                u: input,
                w: 99,
              });
            }

            return candidates;
          };
        })();

        var runMatchMedia = function runMatchMedia() {
          if (runMatchMedia.init) {
            return;
          }

          runMatchMedia.init = true;
          addEventListener(
            "resize",
            (function () {
              var timer;
              var matchMediaElems = document.getElementsByClassName("lazymatchmedia");

              var run = function run() {
                var i, len;

                for (i = 0, len = matchMediaElems.length; i < len; i++) {
                  polyfill(matchMediaElems[i]);
                }
              };

              return function () {
                clearTimeout(timer);
                timer = setTimeout(run, 66);
              };
            })(),
          );
        };

        var createSrcset = function createSrcset(elem, isImage) {
          var parsedSet;
          var srcSet = elem.getAttribute("srcset") || elem.getAttribute(lazySizesCfg.srcsetAttr);

          if (!srcSet && isImage) {
            srcSet = !elem._lazypolyfill
              ? elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute("src")
              : elem._lazypolyfill._set;
          }

          if (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) {
            parsedSet = parseWsrcset(srcSet || "");

            if (isImage && elem.parentNode) {
              parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE";

              if (parsedSet.isPicture) {
                if (window.matchMedia) {
                  lazySizes.aC(elem, "lazymatchmedia");
                  runMatchMedia();
                }
              }
            }

            parsedSet._set = srcSet;
            Object.defineProperty(elem, "_lazypolyfill", {
              value: parsedSet,
              writable: true,
            });
          }
        };

        var getX = function getX(elem) {
          var dpr = window.devicePixelRatio || 1;
          var optimum = lazySizes.getX && lazySizes.getX(elem);
          return Math.min(optimum || dpr, 2.5, dpr);
        };

        var _matchesMedia = function matchesMedia(media) {
          if (window.matchMedia) {
            _matchesMedia = function matchesMedia(media) {
              return !media || (matchMedia(media) || {}).matches;
            };
          } else {
            return !media;
          }

          return _matchesMedia(media);
        };

        var getCandidate = function getCandidate(elem) {
          var sources, i, len, source, srces, src, width;
          source = elem;
          createSrcset(source, true);
          srces = source._lazypolyfill;

          if (srces.isPicture) {
            for (
              i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length;
              i < len;
              i++
            ) {
              if (
                lazySizesCfg.supportsType(sources[i].getAttribute("type"), elem) &&
                _matchesMedia(sources[i].getAttribute("media"))
              ) {
                source = sources[i];
                createSrcset(source);
                srces = source._lazypolyfill;
                break;
              }
            }
          }

          if (srces.length > 1) {
            width = source.getAttribute("sizes") || "";
            width =
              (regPxLength.test(width) && parseInt(width, 10)) ||
              lazySizes.gW(elem, elem.parentNode);
            srces.d = getX(elem);

            if (!srces.src || !srces.w || srces.w < width) {
              srces.w = width;
              src = reduceCandidate(srces.sort(ascendingSort));
              srces.src = src;
            } else {
              src = srces.src;
            }
          } else {
            src = srces[0];
          }

          return src;
        };

        var p = function p(elem) {
          if (
            supportSrcset &&
            elem.parentNode &&
            elem.parentNode.nodeName.toUpperCase() != "PICTURE"
          ) {
            return;
          }

          var candidate = getCandidate(elem);

          if (candidate && candidate.u && elem._lazypolyfill.cur != candidate.u) {
            elem._lazypolyfill.cur = candidate.u;
            candidate.cached = true;
            elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
            elem.setAttribute("src", candidate.u);
          }
        };

        p.parse = parseWsrcset;
        return p;
      })();

      if (lazySizesCfg.loadedClass && lazySizesCfg.loadingClass) {
        (function () {
          var sels = [];
          ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (sel) {
            sels.push(sel + lazySizesCfg.loadedClass);
            sels.push(sel + lazySizesCfg.loadingClass);
          });
          lazySizesCfg.pf({
            elements: document.querySelectorAll(sels.join(", ")),
          });
        })();
      }
    });
  });

  var PriceRange = /*#__PURE__*/ (function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement);

    var _super = _createSuper(PriceRange);

    function PriceRange() {
      _classCallCheck(this, PriceRange);

      return _super.apply(this, arguments);
    }

    _createClass(PriceRange, [
      {
        key: "connectedCallback",
        value: function connectedCallback() {
          var _this = this;

          this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
          this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
          this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
          this.textInputHigherBound = this.querySelector(".price-range__input:last-child input"); // Select whole text on focus for text field to improve user experience

          this.textInputLowerBound.addEventListener("focus", function () {
            return _this.textInputLowerBound.select();
          });
          this.textInputHigherBound.addEventListener("focus", function () {
            return _this.textInputHigherBound.select();
          }); // Keep in sync the range with the text input fields

          this.textInputLowerBound.addEventListener("change", function (event) {
            event.target.value = Math.max(
              Math.min(
                parseInt(event.target.value),
                parseInt(_this.textInputHigherBound.value || event.target.max) - 1,
              ),
              event.target.min,
            );
            _this.rangeLowerBound.value = event.target.value;

            _this.rangeLowerBound.parentElement.style.setProperty(
              "--range-min",
              "".concat(
                (parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max)) * 100,
                "%",
              ),
            );
          });
          this.textInputHigherBound.addEventListener("change", function (event) {
            event.target.value = Math.min(
              Math.max(
                parseInt(event.target.value),
                parseInt(_this.textInputLowerBound.value || event.target.min) + 1,
              ),
              event.target.max,
            );
            _this.rangeHigherBound.value = event.target.value;

            _this.rangeHigherBound.parentElement.style.setProperty(
              "--range-max",
              "".concat(
                (parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max)) *
                  100,
                "%",
              ),
            );
          });
          this.rangeLowerBound.addEventListener("change", function (event) {
            _this.textInputLowerBound.value = event.target.value;

            _this.textInputLowerBound.dispatchEvent(
              new Event("change", {
                bubbles: true,
              }),
            );
          });
          this.rangeHigherBound.addEventListener("change", function (event) {
            _this.textInputHigherBound.value = event.target.value;

            _this.textInputHigherBound.dispatchEvent(
              new Event("change", {
                bubbles: true,
              }),
            );
          }); // We also have to bound the two range sliders

          this.rangeLowerBound.addEventListener("input", function (event) {
            _this.dispatchEvent(
              new CustomEvent("collection:abort-loading", {
                bubbles: true,
              }),
            );

            event.target.value = Math.min(
              parseInt(event.target.value),
              parseInt(_this.textInputHigherBound.value || event.target.max) - 1,
            ); // Bound the value

            event.target.parentElement.style.setProperty(
              "--range-min",
              "".concat((parseInt(event.target.value) / parseInt(event.target.max)) * 100, "%"),
            );
            _this.textInputLowerBound.value = event.target.value;
          });
          this.rangeHigherBound.addEventListener("input", function (event) {
            _this.dispatchEvent(
              new CustomEvent("collection:abort-loading", {
                bubbles: true,
              }),
            );

            event.target.value = Math.max(
              parseInt(event.target.value),
              parseInt(_this.textInputLowerBound.value || event.target.min) + 1,
            ); // Bound the value

            event.target.parentElement.style.setProperty(
              "--range-max",
              "".concat((parseInt(event.target.value) / parseInt(event.target.max)) * 100, "%"),
            );
            _this.textInputHigherBound.value = event.target.value;
          });
        },
      },
    ]);

    return PriceRange;
  })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));
  window.customElements.define("price-range", PriceRange);

  (function () {
    var bootTheme = function bootTheme() {
      // Some polyfills not provided yet by polyfills.io
      if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;

          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
      } // Use for the smooth scroll polyfill

      smoothscroll.polyfill(); // Instantiate global plugins

      new CollapsibleManager();
      new LoadingBar();
      new ModalManager();
      new PopoverManager(); // Then, we instantiate specific sections that may appear in all pages, and then only the template specific sections

      var sections = new SectionContainer();
      sections.register("account", AccountSection);
      sections.register("announcement-bar", AnnouncementBarSection);
      sections.register("blog", BlogSection);
      sections.register("blog-sidebar", BlogSidebarSection);
      sections.register("blog-post", BlogPostSection);
      sections.register("cart", CartSection);
      sections.register("collection", CollectionSection);
      sections.register("footer", FooterSection);
      sections.register("gift-card", GiftCardSection);
      sections.register("header", HeaderSection);
      sections.register("login", LoginSection);
      sections.register("map", MapSection);
      sections.register("minimal-header", MinimalHeaderSection);
      sections.register("popups", PopupsSection);
      sections.register("quick-links", QuickLinksSection);
      sections.register("video", VideoSection);
      sections.register("image-with-text", VideoSection);
      /**
       * ----------------------------------------------------------------------------
       * RTE
       * ----------------------------------------------------------------------------
       */

      (function () {
        // We wrap each RTE table by a specific class to allow wrapping
        document.querySelectorAll(".rte table").forEach(function (table) {
          table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + "</div>";
        });
        document.querySelectorAll(".rte iframe").forEach(function (iframe) {
          // We scope the wrapping only for YouTube and Vimeo
          if (
            iframe.src.indexOf("youtube") !== -1 ||
            iframe.src.indexOf("youtu.be") !== -1 ||
            iframe.src.indexOf("vimeo") !== -1
          ) {
            iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + "</div>"; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

            iframe.src = iframe.src;
          }
        });
      })();
      /**
       * ----------------------------------------------------------------------------
       * UTILS
       * ----------------------------------------------------------------------------
       */

      /**
       * NOTE: I'm really not satisfied with the way this is handled, but this has been asked by design at the very
       *       end of the process. This should be abstracted at some point to make it easier to re-use and with slightly
       *       cleaner code!
       */

      (function () {
        // In card, elements that have a "card__section" with a [aria-expanded] attribute can be clickable to open the content
        // of the card itself
        var documentDelegate = new Delegate(document.body);
        documentDelegate.on(
          "click",
          ".expandable-content__toggle",
          function (item, expandableButton) {
            var parentSection = expandableButton.closest(".expandable-content");

            if (parentSection.getAttribute("aria-expanded") === "true") {
              // Previously expanded, so we have to close it
              parentSection.setAttribute("aria-expanded", "false");
              parentSection.style["max-height"] = "".concat(parentSection.offsetHeight, "px");
              parentSection.offsetHeight; // Use to force a redraw

              parentSection.style["max-height"] = null; // Remove the attribute to let the CSS decide the max-height

              var expandableText = expandableButton.querySelector(
                ".expandable-content__toggle-text",
              );
              expandableText.innerHTML = expandableText.getAttribute("data-view-more"); // We also have to scroll back to the top to preserve scroll position

              var parentCard = parentSection.closest(".card");

              if (parentCard) {
                var amountToScroll =
                  parentCard.getBoundingClientRect().top -
                  15 -
                  parseInt(
                    getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
                  );
                window.scrollBy({
                  top: amountToScroll,
                  behavior: "smooth",
                });
              }
            } else {
              // Previously collapsed, so we have to open it
              parentSection.setAttribute("aria-expanded", "true"); // Because the expandable button is still positioned absolutely, we need to add margin to the sibling
              // text to account the button. It's a bit ugly and hacky but this was the simplest I've found

              if (expandableButton.previousElementSibling) {
                expandableButton.previousElementSibling.style["margin-bottom"] = "".concat(
                  parseInt(expandableButton.clientHeight),
                  "px",
                );
              }

              Animation.slideDown(parentSection, null, "max-height");

              var _expandableText = expandableButton.querySelector(
                ".expandable-content__toggle-text",
              );

              _expandableText.innerHTML = _expandableText.getAttribute("data-view-less");
            }
          },
        );

        var processCollapsibles = function processCollapsibles() {
          document.querySelectorAll(".expandable-content[aria-expanded]").forEach(function (item) {
            if (item.scrollHeight > item.clientHeight) {
              item.classList.add("expandable-content--expandable");
            } else {
              item.setAttribute("aria-expanded", "true");
            }
          });
        };

        document.addEventListener("shopify:section:load", function (event) {
          processCollapsibles();
        });
        processCollapsibles();
      })();

      (function () {
        // Mobile browsers (like iOS) do not support opening keyboard, so we simply prevent the autofocus by unblurring
        // all the fields
        if (Responsive.getCurrentBreakpoint() === "phone") {
          var autoFocusedElements = document.querySelectorAll("input[autofocus]");

          for (var i = 0; i < autoFocusedElements.length; i++) {
            autoFocusedElements[i].blur();
            autoFocusedElements[i].removeAttribute("autofocus");
          }
        }
      })();

      (function () {
        function handleFirstTab(event) {
          if (event.key === "Tab") {
            document.body.classList.add("is-tabbing");
            window.removeEventListener("keydown", handleFirstTab);
          }
        }

        window.addEventListener("keydown", handleFirstTab);
      })();

      (function () {
        var documentDelegate = new Delegate(document.body);
        documentDelegate.on("keyup", "input, textarea", function (event, target) {
          target.classList.toggle("is-filled", target.value !== "");
        });
        documentDelegate.on("change", "select", function (event, target) {
          target.parentNode.classList.toggle("is-filled", target.value !== "");
        });
      })(); // This snippet allows to automatically adds a target="_blank" to any link that is external. This is actually
      // somewhat always desired by merchant and will allow to reduce support

      (function () {
        var links = document.links;
        fastdom.mutate(function () {
          for (var i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname !== window.location.hostname) {
              links[i].target = "_blank";
              links[i].relList.add("noopener");
              links[i].setAttribute("aria-describedby", "a11y-new-window-message");
            }
          }
        });
      })();
    }; // In order to prevent loading polyfills on modern browser, we first detect if the browser support fetch and assign (if
    // it does then it supports actually all the features we need). If that's not the case we first load the polyfill from
    // polyfill.io and then boot the theme, otherwise we can skip this step completely

    if ("fetch" in window && "assign" in Object) {
      bootTheme();
    } else {
      var scriptEl = document.createElement("script");
      scriptEl.src =
        "//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList";
      scriptEl.async = false;

      scriptEl.onload = function () {
        bootTheme();
      };

      document.head.appendChild(scriptEl);
    }
  })();
});

const toggleQuestion = (e) => {
  var question = e.currentTarget;
  var answer = e.currentTarget.nextElementSibling;
  if (question.classList.contains("question-expanded")) {
    question.classList.remove("question-expanded");
    answer.style.height = "0px";
  } else {
    question.classList.add("question-expanded");
    answer.style.height = answer.scrollHeight + "px";
  }
};

// Check to see if the cart is available to us when the 'addToCartFinish' custom event is triggered. If not fetch it. Then pass it to updateAnouncementBar Function
async function fetchCart(e) {
  let cart = e?.detail;
  const announcementBannerText = document.querySelector(".announcement-bar__content");
  const announcementBanner = document.querySelector(".announcement-bar");
  if (announcementBannerText) {
    if (!cart) {
      // fetch the cart and mutate announcement banner
      try {
        const res = await fetch("/cart.js");
        if (!res.ok) {
          announcementBannerText.innerText = "FREE SHIPPING ON ORDERS OVER $25*";
          announcementBanner.style.backgroundColor = "#ee8945";
          throw new Error(JSON.stringify(`${res.status} - ${res.message}: ${res.description}`));
        }
        cart = await res.json();
        updateAnnouncementBar(cart, announcementBannerText, announcementBanner);
      } catch (err) {
        console.log(err);
        return;
      }
    } else {
      updateAnnouncementBar(cart, announcementBannerText, announcementBanner);
    }
  }
}

// Update the announcement bar using the cart.
function updateAnnouncementBar(cart, announcementBannerText, announcementBanner) {
  const freeShipThresh = 2500;
  if (cart.item_count < 1) {
    announcementBannerText.innerText = "FREE SHIPPING ON ORDERS OVER $25*";
    announcementBanner.style.backgroundColor = "#ee8945";
    announcementBanner.style.color = "#FFF";
  } else {
    if (cart.items_subtotal_price >= 2500) {
      announcementBannerText.innerText = "You are eligible for free shipping!";
      announcementBanner.style.backgroundColor = "#FFF";
      announcementBanner.style.color = "#ee8945";
    } else {
      let remainingMoney = freeShipThresh - cart.items_subtotal_price;
      announcementBannerText.innerText = `Spend $${(remainingMoney / 100).toFixed(
        2,
      )} more and get free shipping!`;
      announcementBanner.style.backgroundColor = "#FFF";
      announcementBanner.style.color = "#ee8945";
    }
  }
}

document.addEventListener("addToCartFinish", fetchCart);

class QuickBuy extends HTMLElement {
  strings = {
    cartAdd: "Add to cart",
    cartSuccess: "Added!",
    cartFail: "Error",
    noStock: "Sold out",
    chooseOptions: "Choose options",
  };

  constructor() {
    super();

    this.strings.cartAdd = this.getAttribute("cart-add") || this.strings.cartAdd;
    this.strings.cartSuccess = this.getAttribute("cart-success") || this.strings.cartSuccess;
    this.strings.cartFail = this.getAttribute("cart-fail") || this.strings.cartFail;
    this.strings.noStock = this.getAttribute("no-stock") || this.strings.noStock;
    this.strings.chooseOptions = this.getAttribute("choose-options") || this.strings.chooseOptions;
    this.cartBubble = document.querySelector(".header__cart-count");

    this.form = this.querySelector(".cart-add__form");
    this.opener = this.querySelector("[data-action='open']");
    this.submitter = this.querySelector('button[data-action="submit"]');
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    this.addEventListener("input", this.inputHandler.bind(this));
    document.addEventListener("click", this.outsideClickHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    this.removeEventListener("input", this.inputHandler.bind(this));
    document.removeEventListener("click", this.outsideClickHandler.bind(this));
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  inputHandler(e) {
    const selects = this.querySelectorAll(".quick-buy__option select");
    this.selectedVariantOptions = [];
    for (const select of selects) {
      this.selectedVariantOptions.push(select.value);
    }
    const matchedVariant = this.form.querySelector(
      `[data-title="${this.selectedVariantOptions.join(" / ")}"]`,
    );
    this.form.querySelector("select").value = matchedVariant?.value;
    this.form.querySelectorAll("option").forEach((option) => {
      option.removeAttribute("selected");
    });
    matchedVariant?.setAttribute("selected", "selected");
    this.checkAvailability(matchedVariant);
  }

  clickHandler(e) {
    e.preventDefault();
    if (e.target.dataset.action === "open") {
      this.open();
    }
    if (e.target.dataset.action === "close") {
      this.close();
    }
    if (e.target.dataset.action === "submit") {
      this.submit();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("quick-buy") !== this) {
      this.close();
    }
  }

  open() {
    this.opener ? this.opener.setAttribute("aria-expanded", "true") : null;
  }

  close() {
    this.opener ? this.opener.setAttribute("aria-expanded", "false") : null;
  }

  async submit() {
    const formData = new FormData(this.form);
    this.submitter.classList.add("btn--loading");
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHTTPRequest",
        },
        body: formData,
      });
      if (!response.ok) {
        throw new Error("[CART_ADD]: There was an error adding an item to the cart");
      }
      const data = await response.json();
      this.submitter.textContent = this.strings.cartSuccess;
      this.submitter.classList.add("btn--success");
    } catch (error) {
      console.log(error);
      this.submitter.textContent = this.strings.cartFail;
      this.submitter.classList.add("btn--error");
    } finally {
      this.submitter.classList.remove("btn--loading");
      setTimeout(() => {
        this.submitter.className = "btn";
        this.submitter.textContent = this.strings.cartAdd;
      }, 2000);
    }

    this.updateCartCount();
  }

  async updateCartCount() {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      const data = await response.json();
      this.cartBubble.innerText = data.item_count;
      if (data.item_count < 1) {
        this.cartBubble.classList.add("cart-empty");
      } else {
        this.cartBubble.classList.remove("cart-empty");
      }
    } catch (error) {
      console.log(error);
    }
  }

  checkAvailability(variant) {
    let available = false;
    if (variant) {
      available = variant.dataset.available === "false" ? false : true;
    }
    this.submitter.classList.toggle("btn--disabled", !available);
    !available
      ? (this.submitter.textContent = this.strings.noStock)
      : (this.submitter.textContent = this.strings.cartAdd);
  }
}

customElements.define("quick-buy", QuickBuy);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.search = {
      query: this.getAttribute("search-query"),
      type: this.getAttribute("search-type") || "product,query,collection,page",
      limit: this.getAttribute("search-scope") || "10",
      scope: this.getAttribute("search-scope") || "each",
      fields:
        this.getAttribute("search-fields") || "title,product_type,body,variants.title,variants.sku",
      unavailable: this.getAttribute("search-unavailable") || "last",
    };
    this.appearance = {
      type: this.getAttribute("appearance-type") || "bar",
    };
    this.predictiveSearchResults = this.querySelector("#predictive-search-results");
    this.inputWrapper = this.querySelector(".input-wrapper");
    this.closeBtn = this.querySelector(".close-results");
    this.closeBtnBottom = this.querySelector(".close-results-bottom");
    this.resultsOverlay = document.querySelector(".predictive-search-overlay");
    this.mobileNav = document.querySelector(".drawer");
    this.mobileBurgerBtn = document.querySelector("button.js-drawer-open-left");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
    this.setAttribute("search-loaded", "true");
  }

  addEventListeners() {
    this.input = this.querySelector('input[type="search"]');
    this.input.addEventListener("focusin", this.setActive.bind(this));
    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.inputChange(event);
      }, 300).bind(this),
    );

    this.clear = this.querySelector(".input-clear");
    document.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target === this.clear || e.target.closest(".input-clear")) {
      e.preventDefault();
      this.clearResults();
      return;
    }
    if (e.target === this.closeBtn || e.target.closest(".close-results")) {
      this.closeResultsPane();
      this.toggleSearch("close");
      return;
    }
    if (e.target === this.closeBtnBottom || e.target.closest(".close-results-bottom")) {
      this.closeResultsPane();
      return;
    }
    if (e.target === this.resultsOverlay || e.target.closest(".predictive-search-overlay")) {
      this.unsetActive();
      this.closeResultsPane();
      this.toggleSearch("close");
      return;
    }
    if (e.target === this.searchIcon || e.target.closest(".search-button")) {
      this.toggleSearch();
      return;
    }
    if (!e.target.closest("predictive-search")) {
      if (!e.target === this.mobileNav || !e.target.closest(".drawer")) {
        if (this.searchIcon) {
          this.toggleSearch("close");
        } else {
          this.unsetActive();
        }
        return;
      }
    }
  }

  attributeChangedCallback(name, prev, next) {
    // triggers whenever the search-query param is set, handle everything here
    if (next === "") {
      // input field is empty, clear DOM and close results pane
      this.closeResultsPane();
      this.predictiveSearchResults.innerHTML = "";
      return;
    }
    if (prev === next && this.DOMCache) {
      return;
    }

    // new query
    this.getNewSearch();
  }

  static get observedAttributes() {
    return ["search-query"];
  }

  inputChange() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.toggleClearButton();
    this.setAttribute("search-query", query);
  }

  async getNewSearch() {
    this.loadingElem = this.querySelector(".predictive-search__loading");
    this.loadingElem ? this.loadingElem.setAttribute("aria-hidden", "false") : null;
    let string = `/search/suggest?q=${this.search.query}&resources[type]=${this.search.type}&resources[limit]=${this.search.limit}&resources[limit_scope]=${this.search.scope}&resources[options][fields]=${this.search.fields}&resources[options][unavailable_products]=${this.search.unavailable}&section_id=predictive-search`;
    try {
      const response = await fetch(string);
      if (!response.ok) {
        const error = new Error(response.status);
        throw error;
      }
      const data = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector("#shopify-section-predictive-search").innerHTML;
      this.DOMCache = resultsMarkup;
      this.predictiveSearchResults.innerHTML = this.DOMCache;
      this.openResultsPane();
    } catch (error) {
      this.closeResultsPane();
    }
    this.loadingElem ? this.loadingElem.setAttribute("aria-hidden", "false") : null;
  }

  handleFocus() {
    const dummyInput = document.createElement("input");
    dummyInput.setAttribute("type", "text");
    const styleObject = {
      position: "absolute",
      opacity: "0",
      height: "0",
      fontSize: "16px",
      width: "0px",
    };
    Object.assign(dummyInput.style, styleObject);

    this.prepend(dummyInput);
    dummyInput.focus();

    setTimeout(() => {
      this.input.focus();
      dummyInput.remove();
    }, 500);
  }

  positionResultsPane() {
    this.predictiveSearchResults.removeAttribute("style");
    const results = this.predictiveSearchResults.getBoundingClientRect();
    if (this.predictiveSearchResults.scrollHeight + results.top + 15 > window.innerHeight) {
      this.predictiveSearchResults.style.height = window.innerHeight - 15 - results.top + "px"; // remove an extra 20px from height to space from bottom of browser window
    }
  }

  openResultsPane() {
    this.positionResultsPane();
    if (this.predictiveSearchResults.innerHTML !== "") {
      this.predictiveSearchResults.classList.add("predictive-search-results--visible");
    }
    this.resultsOverlay.classList.remove("hidden");
    // this.querySelector('form').style.border = '2px solid #f58020';
  }

  closeResultsPane() {
    this.predictiveSearchResults.classList.remove("predictive-search-results--visible");
    this.resultsOverlay.classList.add("hidden");
    // this.querySelector('form').style.border = '2px solid transparent';
  }

  toggleClearButton() {
    if (this.input.value !== "") {
      this.querySelector(".input-clear").classList.add("input-clear--visible");
    } else {
      this.querySelector(".input-clear").classList.remove("input-clear--visible");
    }
  }

  toggleSearch(force) {
    if (this.searchIcon) {
      const isActive = this.searchIcon.getAttribute("aria-expanded") === "true" ? true : false;
      this.searchIcon.setAttribute("aria-expanded", !isActive);
      this.searchIcon.querySelector(".search-toggle").style.filter =
        "invert(1) invert(55%) sepia(41%) saturate(1436%) hue-rotate(347deg) brightness(99%) contrast(93%)";
      if (force === "close") {
        this.unsetActive();
        this.searchIcon.setAttribute("aria-expanded", "false");
        this.searchIcon.querySelector(".search-toggle").style.filter = "invert(1)";
      } else if (isActive) {
        this.unsetActive();
        this.searchIcon.querySelector(".search-toggle").style.filter = "invert(1)";
      } else {
        this.setActive();
        this.input.focus();
        this.handleFocus();
        this.searchIcon.querySelector(".search-toggle").style.filter =
          "invert(1) invert(55%) sepia(41%) saturate(1436%) hue-rotate(347deg) brightness(99%) contrast(93%)";
      }
    }
  }

  clearResults() {
    this.input.value = "";
    this.input.dispatchEvent(new Event("input"));
    this.input.focus();
  }

  setActive() {
    this.inputWrapper.classList.add("input-wrapper--active");
    this.openResultsPane();
  }

  unsetActive() {
    if (this.input.value === "") {
      this.inputWrapper.classList.remove("input-wrapper--active");
    }
    this.closeResultsPane();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  init() {
    if (this.input.value !== "") {
      this.inputWrapper.classList.add("input-wrapper--active");
    }
    if (this.appearance.type == "icon") {
      const iconButton = document.createElement("button");
      const style = document.createElement("style");

      style.textContent = `
        .search-toggle {transition: none; width: 100%}
        .search-toggle:hover {filter: invert(1) invert(55%) sepia(41%) saturate(1436%) hue-rotate(347deg) brightness(99%) contrast(93%);}
        .search-button{-webkit-appearance:none;appearance:none;width:24px; border:0;padding:0;background:none;display:flex;align-items:center;}
        .search-button + form{display:none}
        .search-button[aria-expanded="true"] + form{display:block}
        predictive-search form{top:0;min-width:300px;background:#fff;right:36px;}
        predictive-search[appearance-type="bar"] form{position:relative;top:0;min-width:100%;background:#fff;right:0;}

        @media screen and (max-width:1360px) {
          .search-button + form{display:block;opacity:0;visibility:hidden;pointer-events:none;transition:all .2s ease}
          .search-button[aria-expanded="true"] + form{opacity:1;visibility:visible;pointer-events:all;transform: translateY(40px);}
          predictive-search form{top:64px;right:0;width:calc(100% - 50px);left:0;z-index:1;}
        }
        @media screen and (max-width:1024px) {
          predictive-search form{top:42px;right:0;width:calc(100% - 50px);left:0;z-index:1;}
        }
        @media screen and (max-width:767px) {
          predictive-search form{position:absolute!important;}
        }
      `;
      iconButton.classList.add("search-button");
      iconButton.setAttribute("aria-expanded", "false");
      iconButton.innerHTML = `
      <svg class="search-toggle" focusable="false" class="icon icon--search" viewBox="0 0 21 21" role="presentation">
        <g stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd">
          <path d="M19 19l-5-5" stroke-linecap="square"></path>
          <circle cx="8.5" cy="8.5" r="7.5"></circle>
        </g>
      </svg>
      `;
      this.appendChild(style);
      this.insertBefore(iconButton, this.firstElementChild);
      this.searchIcon = iconButton;
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.is_visible = false;

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
      this.elements.swiper.dataset.alignArrows
        ? (this.align_arrows = JSON.parse(this.elements.swiper.dataset.alignArrows))
        : null;
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }
  }

  connectedCallback() {
    this.addEventListeners();
    this.checkVisibility();
  }

  addEventListeners() {
    window.addEventListener("resize", this.positionArrows.bind(this));
    window.addEventListener("scroll", this.checkVisibility.bind(this));
  }

  checkVisibility() {
    if (this.is_visible) return;
    const rect = this.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      if (!this.is_visible) {
        this.init();
      }
      this.is_visible = true;
    }
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
    this.positionArrows();
  }

  positionArrows() {
    if (!this.elements.swiper) return;
    setTimeout(() => {
      if (!this.align_arrows || !this.elements.prevButton || !this.elements.nextButton) return;
      const slide_image_height = this.swiper.slidesEl.querySelector(".luc-media")?.offsetHeight;
      this.elements.nextButton.style.top = slide_image_height / 2 + "px";
      this.elements.nextButton.style.marginTop = -this.elements.nextButton.offsetHeight / 2 + "px";
      this.elements.prevButton.style.top = slide_image_height / 2 + "px";
      this.elements.prevButton.style.marginTop = -this.elements.prevButton.offsetHeight / 2 + "px";
    }, 1);
  }
}
customElements.define("main-carousel", MainCarousel);

// Product Recommendations Small
class ProductRecommendations extends MainCarousel {
  constructor() {
    super();

    this.limit = this.getAttribute("limit") || "8";
    this.intent = this.getAttribute("intent") || "related";
    this.product_id = this.getAttribute("product_id");
    this.section_id = this.getAttribute("section_id");
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener('recommendations:toggle', this.checkVisibility.bind(this))
  }

  async init() {
    if (!this.elements.swiper) return;
    const base_url = `${window.Shopify.routes.root}recommendations/products?section_id=${this.section_id}&product_id=${this.product_id}&limit=${this.limit}`;
    if (this.intent === "both") {
      const complementary = await this.fetchRecs(`${base_url}&intent=complementary`);
      if (complementary) {
        this.renderRecs(complementary.innerHTML);
      } else {
        const related = await this.fetchRecs(`${base_url}&intent=related`);
        if (related) {
          this.renderRecs(related.innerHTML);
        } else {
          this.style.display = "none";
        }
      }
    } else {
      const recs = await this.fetchRecs(`${base_url}&intent=${this.intent}`);
      if (recs) {
        this.renderRecs(recs.innerHTML);
      } else {
        this.style.display = "none";
      }
    }
  }

  async fetchRecs(url) {
    try {
      const response = await fetch(url);
      const data = await response.text();
      const container = document.createElement("div");
      container.innerHTML = data;
      const allProducts = container.querySelectorAll(".main-carousel__slide");
      if (allProducts.length > 0) {
        const recWrapper = container.querySelector(".main-carousel");
        return recWrapper;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  }

  renderRecs(data) {
    this.elements.swiper.querySelector(".swiper-wrapper").outerHTML = data;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
    this.positionArrows();
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class RecentlyViewedCarousel extends MainCarousel {
  constructor() {
    super();
    this.recentlyViewedHandles = JSON.parse(localStorage.getItem("recentlyViewedItems"));
    this.currentProduct = this.getAttribute("current-product");

    if (this.currentProduct && this.recentlyViewedHandles) {
      this.recentlyViewedHandles = this.recentlyViewedHandles.filter((handle) => {
        return handle != this.currentProduct;
      });
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.fetchRecentlyViewed.bind(this));
  }

  async fetchRecentlyViewed() {
    if (!this.recentlyViewedHandles) return;

    try {
      const res = await fetch(
        `/search?view=recently-viewed-items&q=${this.recentlyViewedHandles.join(",")}`,
      );
      const data = await res.text();
      if (!data) return;
      this.renderRecentlyViewed(data);
    } catch (error) {
      console.log(error);
    }
  }

  renderRecentlyViewed(data) {
    const items = new DOMParser()
      .parseFromString(data, "text/html")
      .querySelector(".main-carousel__wrapper").innerHTML;
    const item_wrapper = this.querySelector(".main-carousel__wrapper");
    item_wrapper.innerHTML = items;
    this.init();
  }
}
customElements.define("recently-viewed-carousel", RecentlyViewedCarousel);

class MainProduct extends HTMLElement {
  constructor() {
    super();

    this.recs = this.querySelector(".product-information__recommendations");
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("variant:change", this.updateDisplayPrice.bind(this));
    this.addEventListener("variant:change", this.updateSku.bind(this));
    this.addEventListener("cart:add", this.showRecommendations.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (
      e.target.classList.contains(".recommendations__close") ||
      e.target.closest(".recommendations__close")
    ) {
      this.recs.classList.remove("recommendations--active");
    }
  }

  updateSku(e) {
    const sku = this.querySelector(".product-information__sku-number");
    if (!sku) return;

    sku.innerHTML = e.detail.variant.sku;
  }

  updateDisplayPrice(e) {
    const displayPrice = this.querySelector(".product-information__price");
    // const comparePrice = this.querySelector(".product-display__price--compare-at");
    // const compareWrapper = this.querySelector(".product-display__compare-wrapper");
    // if (parseInt(matched.dataset.variantCompare) > parseInt(matched.dataset.variantPrice)) {
    //   compareWrapper.classList.add("visible");
    //   displayPrice.classList.add("on-sale");
    //   comparePrice.innerHTML = `${theme.Currency.formatMoney(matched.dataset.variantCompare, theme.strings.moneyFormat)}`;
    // } else {
    //   compareWrapper.classList.remove("visible");
    //   displayPrice.classList.remove("on-sale");
    // }
    displayPrice.innerHTML = window.currency.formatMoney(e.detail.variant.price, theme.moneyFormat);
    // displayPrice.setAttribute("content", matched.dataset.variantPrice / 100);
  }

  showRecommendations() {
    if (!this.recs) return;
    this.recs.classList.add("recommendations--active");
    const event = new CustomEvent("recommendations:toggle", { detail: { type: "open" } });
    this.recs.querySelector('product-recommendations')?.dispatchEvent(event);

    if (window.innerWidth >= 768) return;
    const offset = 210;
    const topPosition = this.recs.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: topPosition, behavior: "smooth" });
  }
}

customElements.define("main-product", MainProduct);

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector(".main-product__form");
    const jsonData = JSON.parse(this.querySelector(".product-form__data").innerHTML);
    this.productData = jsonData["product"];
    this.selectedVariantId = jsonData["selected_variant_id"];
    this.productOptionsWithValues = jsonData["options_with_values"];
    this.optionSelectors = this.querySelectorAll(".product-form__option-container");
    this.masterSelect = this.querySelector(".product-form__master-select");
    this.submitButton = this.form.querySelector('button[type="submit"]');

    this.productData["variants"].forEach((variant) => {
      if (variant["id"] === jsonData["selected_variant_id"]) {
        this.currentVariant = variant;
        this.option1 = variant["option1"];
        this.option2 = variant["option2"];
        this.option3 = variant["option3"];
      }
    });
  }

  connectedCallback() {
    this.addEventListeners();

    this.checkInventory();
    this.updateBuyButtons(this.currentVariant.id);
  }

  addEventListeners() {
    this.form.addEventListener("input", this.changeVariantSelect.bind(this));
    this.form.addEventListener("submit", this.addItemToCart.bind(this));
  }

  changeVariantSelect() {
    const data = new FormData(this.form);
    const selected = [];
    for (const [key, value] of data) {
      if (key.includes("option")) {
        selected.push(value);
      }
    }
    const variants = this.masterSelect.querySelectorAll("option");
    const matchedVariant = Array.from(variants).filter((variant) => {
      return variant.dataset.variantOptions === selected.join("||");
    });
    const variantId = matchedVariant[0] ? parseInt(matchedVariant[0].value) : null;

    this.option1 = selected[0];
    this.option2 = selected[1];
    this.option3 = selected[2];
    this.productData["variants"].forEach((variant) => {
      if (variant.id === variantId) {
        this.currentVariant = variant;
      }
    });
    if (variantId) {
      this.masterSelect.value = variantId;
    }

    this.checkInventory();
    this.updateHistoryState();
    this.updateBuyButtons(variantId);
    this.updateSelectedTitles();

    const variantChangeEvent = new CustomEvent("variant:change", {
      detail: {
        variant: this.currentVariant,
        options: this.productData.options,
      },
      bubbles: true,
    });
    this.dispatchEvent(variantChangeEvent);
    if (document.querySelector("product-media")) {
      document.querySelector("product-media").dispatchEvent(variantChangeEvent);
    }
  }

  updateSelectedTitles() {
    const option1 = this.optionSelectors[0]?.closest(".product-form__option-wrap");
    const option2 = this.optionSelectors[1]?.closest(".product-form__option-wrap");
    const option3 = this.optionSelectors[2]?.closest(".product-form__option-wrap");

    if (option1) {
      option1.querySelector(".product-form__option-selected").innerHTML = this.option1;
    }
    if (option2) {
      option2.querySelector(".product-form__option-selected").innerHTML = this.option2;
    }
    if (option3) {
      option3.querySelector(".product-form__option-selected").innerHTML = this.option3;
    }
  }

  updateBuyButtons(id) {
    if (!id) {
      this.submitButton.classList.add("btn-elem--disabled");
      this.submitButton.disabled = true;
      this.submitButton.innerHTML = "<span>Unavailable</span>";
    } else {
      if (this.currentVariant.available) {
        this.submitButton.classList.remove("btn-elem--disabled");
        this.submitButton.disabled = false;
        this.submitButton.innerHTML = "<span>Add to cart</span>";
      } else {
        this.submitButton.classList.add("btn-elem--disabled");
        this.submitButton.disabled = true;
        this.submitButton.innerHTML = "<span>Sold out</span>";
      }
    }
  }

  updateHistoryState() {
    if (this.currentVariant) {
      if (history.replaceState) {
        var newUrl = ""
          .concat(window.location.protocol, "//")
          .concat(window.location.host)
          .concat(window.location.pathname, "?variant=")
          .concat(this.currentVariant.id);
        window.history.replaceState(
          {
            path: newUrl,
          },
          "",
          newUrl,
        );
      }
      this.masterSelect.querySelector("[selected]").removeAttribute("selected");
      this.masterSelect
        .querySelector('[value="'.concat(this.currentVariant["id"], '"]'))
        .setAttribute("selected", "selected");
    }
  }

  toggleAvailableClass(selector, index, available) {
    if (selector.querySelector(".product-form__option--dropdown")) return;
    selector
      .querySelector(".product-form__option-radio-wrapper:nth-child(".concat(index + 1, ")"))
      .classList.toggle("product-form__option--disabled", !available);
  }

  checkInventory() {
    if (this.optionSelectors && this.optionSelectors[0]) {
      this.productOptionsWithValues[0]["values"].forEach((value, index) => {
        this.toggleAvailableClass(
          this.optionSelectors[0],
          index,
          this.productData.variants.some((variant) => {
            return variant["option1"] === value && variant.available;
          }),
        );
        if (this.optionSelectors[1]) {
          this.productOptionsWithValues[1]["values"].forEach((value, index) => {
            this.toggleAvailableClass(
              this.optionSelectors[1],
              index,
              this.productData["variants"].some((variant) => {
                return (
                  variant["option2"] === value &&
                  variant["option1"] === this.option1 &&
                  variant["available"]
                );
              }),
            );

            if (this.optionSelectors[2]) {
              this.productOptionsWithValues[2]["values"].forEach((value, index) => {
                this.toggleAvailableClass(
                  this.optionSelectors[2],
                  index,
                  this.productData["variants"].some((variant) => {
                    return (
                      variant["option3"] === value &&
                      variant["option1"] === this.option1 &&
                      variant["option2"] === this.option2 &&
                      variant["available"]
                    );
                  }),
                );
              });
            }
          });
        }
      });
    }
  }

  addItemToCart(e) {
    e.preventDefault();

    const data = new FormData(this.form);
    const formData = {
      id: data.get("id"),
      quantity: data.get("quantity"),
    };

    const event = new CustomEvent("cart:add", {
      detail: {
        submitter: e.submitter,
        data: {
          items: [
            {
              id: +formData.id,
              quantity: +formData.quantity,
            },
          ],
        },
      },
      bubbles: true,
    });

    this.dispatchEvent(event);
  }
}
customElements.define("product-form", ProductForm);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.quantityInput = this.querySelector(".quantity-selector__input");
    this.decrease = this.querySelector('.quantity-selector__button[data-change="decrease"]');
    this.increase = this.querySelector('.quantity-selector__button[data-change="increase"]');
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.adjustQuantity.bind(this));
  }

  adjustQuantity(e) {
    if (
      e.target === this.decrease ||
      e.target.closest(".quantity-selector__button") === this.decrease
    ) {
      if (+this.quantityInput.value <= 1) return;
      +this.quantityInput.value--;
    }
    if (
      e.target === this.increase ||
      e.target.closest(".quantity-selector__button") === this.increase
    ) {
      +this.quantityInput.value++;
    }
  }
}
customElements.define("quantity-selector", QuantitySelector);

class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: false,
    };

    this.defaultThumbsOptions = {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 8,
      watchSlidesProgress: true,
    };

    this.elements = {
      swiper: this.querySelector(".product-media"),
      slides: this.querySelectorAll(".product-media__slide"),
      pagination: this.querySelector(".product-media__pagination"),
      prevButton: this.querySelector(".product-media__button-prev"),
      nextButton: this.querySelector(".product-media__button-next"),
      thumbs: this.querySelector(".product-media__thumbs"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };

    if (this.elements.swiper.dataset.galleryOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.galleryOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }

    if (this.elements.thumbs) {
      this.thumbsSwiperOptions = {
        ...this.defaultThumbsOptions,
      };
      if (this.elements.thumbs.dataset.galleryOptions) {
        this.thumbsSwiperOptions = {
          ...this.defaultThumbsOptions,
          ...JSON.parse(this.elements.thumbs.dataset.galleryOptions),
        };
      }
      this.swiperOptions.thumbs = {
        swiper: this.elements.thumbs,
      };
    }

    for (const [index, slide] of this.elements.slides.entries()) {
      if (slide.dataset.mediaPrimary != null) {
        this.mediaPrimary = this.elements.swiper.querySelector("[data-media-primary]");
        this.mediaPrimaryImg = this.mediaPrimary.querySelector("img");
        this.mediaPrimaryPosition = index;
        this.swiperOptions.initialSlide = index;
        if (this.elements.thumbs) {
          this.thumbsPrimary = this.elements.thumbs.querySelector("[data-media-primary]");
          this.thumbsPrimaryImg = this.thumbsPrimary.querySelector("img");
          this.thumbsPrimaryPosition = index;
          this.thumbsSwiperOptions.initialSlide = index;
        }
      }
    }

    this.activeVideo = null;

    this.variantImages = JSON.parse(
      this.querySelector('script[type="application/json"]').innerHTML,
    );
  }
  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
    this.addEventListener("variant:change", this.showVariantMedia.bind(this));
    if (!this.mediaPrimaryImg) return;
    this.mediaPrimaryImg.addEventListener("load", this.handleImageLoad.bind(this));
  }

  showVariantMedia(e) {
    if (!this.mediaPrimary || !this.variantImages) return;
    const hasMedia = e.detail.variant.featured_media;
    if (!hasMedia || !e.detail.options) return;
    let colorPosition = -1;
    for (const [index, option] of e.detail.options.entries()) {
      if (option.toLowerCase() === "color" || option.toLowerCase() === "colour" || option.toLowerCase().includes("color")) {
        colorPosition = index;
        break;
      }
    }
    if (colorPosition === -1) return;
    const colorMatch = this.variantImages.filter((variant) => {
      return (
        variant.color.toLowerCase() === e.detail.variant[`option${colorPosition + 1}`].toLowerCase()
      );
    });
    if (colorMatch.length <= 0) return;

    this.mediaPrimary.classList.add("media-loading");

    this.mediaPrimary.setAttribute("data-media-filtered", colorMatch[0].color);

    const targetImg = this.mediaPrimary.querySelector("img");
    targetImg.setAttribute("src", colorMatch[0].url + "&width=680");
    targetImg.removeAttribute("srcset");

    if (this.elements.thumbs) {
      this.thumbsPrimary.setAttribute("data-media-filtered", colorMatch[0].color);

      const targetThumbImg = this.thumbsPrimary.querySelector("img");
      targetThumbImg.setAttribute("src", colorMatch[0].url + "&width=100");
      targetThumbImg.removeAttribute("srcset");
    }

    this.swiper.slideToLoop(this.mediaPrimaryPosition);
  }

  handleImageLoad() {
    this.mediaPrimary.classList.remove("media-loading");
  }

  init() {
    if (!this.elements.swiper) return;
    if (this.elements.thumbs) {
      this.thumbsSwiper = new Swiper(this.elements.thumbs, this.thumbsSwiperOptions);
    }
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);

    this.swiper.on("slideChange", (swiper) => {
      if (this.activeVideo) {
        this.activeVideo.pause();
      }

      let activeSlide;
      for (const [index, slide] of swiper.slides.entries()) {
        if (swiper.activeIndex === index) {
          activeSlide = slide;
        }
      }
      if (activeSlide.classList.contains("video-slide")) {
        const videoEl = activeSlide.querySelector("video");
        this.activeVideo = videoEl;
        videoEl.play();
      }
    });
  }
}
customElements.define("product-media", ProductMedia);

async function cartAddItem(e) {
  const submitter = e.detail.submitter;
  const submitterInnerHTML = submitter.innerHTML;
  if (submitter) {
    submitter.classList.add("btn-elem--loading");
  }
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(e.detail.data), // expects {items: [{...}]}
    });
    if (!res.ok) {
      throw new Error("[cart:add] - Something went wrong");
    }
    const data = await res.json();
    if (submitter) {
      submitter.classList.remove("btn-elem--loading");
      submitter.classList.add("btn-elem--success");
      submitter.innerHTML = "<span>Product added to cart!</span>";
    }
    document.dispatchEvent(new CustomEvent("cart:get"));
  } catch (error) {
    console.log(error);
    if (submitter) {
      submitter.classList.remove("btn-elem--loading");
      submitter.classList.add("btn-elem--error");
      submitter.innerHTML = "<span>Something went wrong</span>";
    }
  } finally {
    setTimeout(() => {
      if (submitter) {
        submitter.classList.remove("btn-elem--success", "btn-elem--error");
        submitter.innerHTML = submitterInnerHTML;
      }
    }, 3000);
  }
}

async function getCart() {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) {
      throw new Error("[cart:get] - Something went wrong");
    }
    const data = await res.json();
    document.querySelector(".header__cart-count").innerHTML = data.item_count;
    if (data.item_count < 1) {
      document.querySelector(".header__cart-count")?.classList.add("cart-empty");
    } else {
      document.querySelector(".header__cart-count")?.classList.remove("cart-empty");
    }
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { data } }));
  } catch (error) {
    console.log(error);
  }
}

document.addEventListener("cart:add", cartAddItem);
document.addEventListener("cart:get", getCart);

class ProductItem extends HTMLElement {
  constructor() {
    super();

    this.primary_image = this.querySelector(".product-item__primary-image");
    this.product_links = this.querySelectorAll("a");
  }
  connectedCallback() {
    this.selected_mix_match =
      this.closest("product-recommendations")?.getAttribute("selected_mix_match");
    this.product_json = this.querySelector("[data-product-item-json]");
    if (!this.product_json) return;
    this.json = JSON.parse(this.product_json.innerHTML);
    if (this.getAttribute("hide-swatches") === "true") {
      this.calculateSwatches();
    }
    this.calculateSelects();
    this.addEventListeners();
    if (!this.selected_mix_match) return;
    this.initMixMatch();
  }
  addEventListeners() {
    this.addEventListener("input", this.inputHandler.bind(this));
    if (!this.selected_mix_match) return;
    document.addEventListener("mixmatch:change", this.updateMixMatch.bind(this));
    document.addEventListener("variant:change", this.captureVariantChange.bind(this));
  }
  inputHandler(e) {
    if (e.target.classList.contains("color-swatch__radio")) {
      this.updateSelectedSwatch(e.target);
      if (this.selected_mix_match) {
        document.dispatchEvent(
          new CustomEvent("mixmatch:change", {
            detail: {
              trigger: this,
              selected: this.selected_mix_match,
            },
          }),
        );
      }
    }
  }
  calculateSelects() {
    const in_stock_variants = this.json.variants.filter((option) => {
      return option.count > 0;
    });
    const option1_in_stock_array = [];
    const option2_in_stock_array = [];
    in_stock_variants.forEach((variant) => {
      if (!option1_in_stock_array.includes(variant.option1)) {
        option1_in_stock_array.push(variant.option1);
      }
      if (!option2_in_stock_array.includes(variant.option2)) {
        option2_in_stock_array.push(variant.option2);
      }
    });
    const optionContainer = this.querySelector(".quick-buy__wrapper");
    if (!optionContainer) return;
    const selectMenus = optionContainer.querySelectorAll("select");

    // Loop through option1 select menu and hide any options not in the array
    if (!selectMenus[0]) return;
    for (const option of selectMenus[0].options) {
      if (!option1_in_stock_array.includes(option.value)) {
        option.style.display = "none";
      }
    }

    // Loop through option2 select menu and hide any options not in the array
    if (!selectMenus[1]) return;
    for (const option of selectMenus[1].options) {
      if (!option2_in_stock_array.includes(option.value)) {
        option.style.display = "none";
      }
    }
  }
  calculateSwatches() {
    this.swatches = this.querySelectorAll(".color-swatch");
    if (!this.swatches) return;
    const color_option = this.json.options_with_values.filter((option) => {
      return option.name.toLowerCase() === "color" || option.name.toLowerCase() === "colour";
    });
    const color_position = color_option[0].position;
    if (color_option.length <= 0) return;
    const colors = {};
    color_option[0].values.forEach((color) => {
      const color_handle = color.toLowerCase().replace(" ", "_");
      colors[color_handle] = {
        color,
        count: 0,
      };
    });

    for (const variant of this.json.variants) {
      const color = variant[`option${color_position}`];
      const color_handle = color.toLowerCase().replace(" ", "_");
      colors[color_handle].count += variant.count;
    }
    for (const value of Object.values(colors)) {
      if (value.count <= 0) {
        this.querySelector(`[title="${value.color}"]`)?.parentElement.remove();
      }
    }
  }
  updateSelectedSwatch(target) {
    const variant_url = new URL(window.location.origin + target.dataset.variantUrl);

    this.primary_image.src = target.dataset.imageUrl;
    this.primary_image.mediaId = target.dataset.mediaId;
    const variant_search = new URLSearchParams(variant_url.search);
    const variant_id = variant_search.get("variant");
    for (const link of this.product_links) {
      if (link.href.includes(variant_url.pathname)) {
        const link_url = new URL(link.href);
        link_url.searchParams.set("variant", variant_id);
        link.href = link_url.toString().replace(link.origin, "");
      }
    }
    if (!this.selected_mix_match) return;
    this.selected_mix_match = target.value;
  }
  initMixMatch() {
    const match = this.querySelector(`.color-swatch__radio[value="${this.selected_mix_match}"]`);
    if (!match) return;
    match.setAttribute("checked", "checked");
    this.updateSelectedSwatch(match);
  }
  updateMixMatch(e) {
    if (e.detail.trigger === this) return;
    const match = this.querySelector(`.color-swatch__radio[value="${e.detail.selected}"]`);
    if (!match) return;
    match.setAttribute("checked", "checked");
    this.updateSelectedSwatch(match);
  }
  captureVariantChange(e) {
    let color_option = null;
    for (const [index, option] of e.detail.options.entries()) {
      if (option === "Color" || option === "Colour" || option === "color" || option === "colour") {
        color_option = index;
        break;
      }
    }
    if (color_option === null) return;
    const match = this.querySelector(
      `.color-swatch__radio[value="${e.detail.variant.options[color_option]}"]`,
    );
    if (!match) return;
    match.setAttribute("checked", "checked");
    this.updateSelectedSwatch(match);
  }
}
customElements.define("product-item", ProductItem);

function trackRecentlyViewed(handle) {
  let recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewedItems"));
  if (!recentlyViewed) {
    recentlyViewed = [];
  }
  if (recentlyViewed.indexOf(handle) === -1) {
    recentlyViewed.unshift(handle);
  } else {
    const index = recentlyViewed.indexOf(handle);
    recentlyViewed.splice(index, 1);
    recentlyViewed.unshift(handle);
  }
  recentlyViewed = recentlyViewed.slice(0, 9);
  localStorage.setItem("recentlyViewedItems", JSON.stringify(recentlyViewed));
}


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
  }
  connectedCallback() {
    this.addEventListeners();
  }
  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("keydown", this.keyboardHandler.bind(this));
  }
  clickHandler(e) {
    const action_target =
      e.target.closest("[modal-dialog-action]")?.getAttribute("modal-dialog-action") || null;
    if (action_target === "open") {
      e.preventDefault();
      this.openModal();
    } else if (action_target === "close" || !e.target.closest(".modal-main__inner")) {
      e.preventDefault();
      this.closeModal();
    }
  }
  keyboardHandler(e) {
    if ((e.key === "Escape" || e.keyCode === 27) && this.is_open === true) {
      this.closeModal();
    }
  }
  openModal() {
    this.is_open = true;
    this.setAttribute("aria-hidden", "false");
    this.setAttribute("modal-dialog-view", "visible");
  }
  closeModal() {
    this.is_open = false;
    this.setAttribute("aria-hidden", "true");
    this.setAttribute("modal-dialog-view", "hidden");
  }
}

customElements.define("modal-dialog", ModalDialog);


class RepeatOrder extends ModalDialog {
  constructor() {
    super();

    this.main_message = this.querySelector("[modal-main-message]");
    this.unavailable_message = this.querySelector("[modal-unavailable-message]");
    this.alternative_message = this.querySelector("[modal-alternative-message]");
  }

  addEventListeners() {
    super.addEventListeners();
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.getAttribute("modal-dialog-action") === "open") {
      if (!this.unavailable_message) {
        this.triggerReorder();
      }
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-clear") {
      this.toggleMessage();
      this.clearCart();
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-combine") {
      this.toggleMessage();
      this.continueReorder();
    }
  }

  async triggerReorder() {
    const cart_check = await this.checkCart();
    if (!cart_check) {
      this.toggleMessage("alt");
    } else {
      this.continueReorder();
    }
  }

  async checkCart() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.json();
      if (data.item_count > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async continueReorder() {
    const form_inputs = this.querySelectorAll("form input");
    const form_data = {};
    for (const input of form_inputs) {
      let current = 0;
      if (form_data[input.dataset.id]?.quantity) {
        current = form_data[input.dataset.id].quantity;
      }
      form_data[input.dataset.id] = { properties: {} };
      form_data[input.dataset.id].quantity = current + +input.dataset.quantity;
      form_data[input.dataset.id].properties._multiples = +input.dataset.multiples;

      if (input.dataset.outer) {
        form_data[input.dataset.id].properties._outer = +input.dataset.outer;
      }
    }
    const item_data = { items: [] };
    for (const [key, value] of Object.entries(form_data)) {
      item_data.items.push({
        id: +key,
        quantity: value.quantity,
        properties: { ...value.properties },
      });
    }
    let event;
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify(item_data),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      event = new CustomEvent("cart:add:success", {
        detail: {
          type: "success",
          data: {
            title: "Order",
          }
        },
      });
      fetchCart();
      document.dispatchEvent(new CustomEvent("cart:get"));
    } catch (error) {
      console.log(error);
      event = new CustomEvent("cart:add:error", {
        detail: {
          type: "error",
          error,
        },
      });
    } finally {
      document.dispatchEvent(event);
      this.closeModal();
    }
  }

  async clearCart() {
    try {
      const res = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
    this.continueReorder();
  }

  closeModal() {
    super.closeModal();
    this.toggleMessage();
  }

  toggleMessage(type) {
    if (type === "alt") {
      this.main_message.setAttribute("aria-hidden", "true");
      this.alternative_message.setAttribute("aria-hidden", "false");
    } else {
      this.main_message.setAttribute("aria-hidden", "false");
      this.alternative_message.setAttribute("aria-hidden", "true");
    }
  }
}

customElements.define("repeat-order", RepeatOrder);

class ImageDownload extends ModalDialog {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll(".account-order__product-select");
    this.selectToggle = this.querySelector('[modal-dialog-event="download-images-select"]');
    this.downloadButton = this.querySelector('[modal-dialog-event="download-images-submit"]');
  }

  addEventListeners() {
    super.addEventListeners();
    this.addEventListener("input", this.inputHandler.bind(this));
  }

  inputHandler(e) {
    let hasChecked = false;
    for (const checkbox of this.checkboxes) {
      if (checkbox.checked === true) {
        hasChecked = true;
        break;
      }
    }
    if (!hasChecked) {
      this.downloadButton.disabled = true;
    } else {
      this.downloadButton.disabled = false;
    }
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.closest("[modal-dialog-event]") === this.selectToggle) {
      this.selectAllToggle();
    }
    if (
      e.target.closest("[modal-dialog-event]")?.getAttribute("modal-dialog-event") ===
      "download-images-submit"
    ) {
      this.packageDownloads();
    }
  }

  closeModal() {
    super.closeModal();
    this.selectAllToggle("deselect");
  }

  selectAllToggle(type) {
    if (type && type == "deselect") {
      this.checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    } else {
      this.checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
    }
    this.dispatchEvent(new Event("input"));
  }

  async fetchImageBinary(url) {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  async packageDownloads() {
    const zip = new JSZip();
    const directory = zip.folder("TalkingTablesDownload");

    this.selectedItems = [];
    Array.from(this.checkboxes).forEach((checkbox) => {
      const parent = checkbox.closest(".account-order__product");
      if (checkbox.checked === true) {
        this.selectedItems.push({
          title: parent.dataset.title,
          images: JSON.parse(parent.dataset.images),
        });
      }
    });

    for (const product of this.selectedItems) {
      for (const image of product.images) {
        const fileSubstring = image.substring(image.lastIndexOf("/") + 1);
        const fileName = fileSubstring.split("?")[0].toLowerCase();
        if (fileName.indexOf("private") <= 0) {
          directory.file(product.title + "/" + fileName, this.fetchImageBinary(image), {
            binary: true,
          });
        }
      }
    }

    try {
      const blob = await zip.generateAsync({ type: "blob" }, () => {
        this.downloadButton.innerText = "Gathering your files";
        this.downloadButton.disabled = true;
      });
      saveAs(blob, "TalkingTablesDownload.zip");
      this.downloadButton.innerText = "Finished";
    } catch (error) {
      console.log(error);
      this.downloadButton.innerText = "Something went wrong";
    } finally {
      setTimeout(() => {
        // this.closeModal();
        // this.selectAllToggle("deselect");
        this.downloadButton.innerText = "Download";
        this.downloadButton.disabled = false;
      }, 2000);
    }
  }
}

customElements.define("image-download", ImageDownload);

// Account Order Page - Line Item Buttons
const lineItemATC = document.querySelectorAll(".line-item__atc")
if (lineItemATC) {
  lineItemATC.forEach((btn) => {
    btn.addEventListener("click", addLineItemToCart)
  })
}
function addLineItemToCart(e) {
  const addItemToCart = new CustomEvent('cart:add', {
    detail: { 
      submitter: e.target,
      data: {
        items: [
          {
            id: e.target.dataset.productId,
            quantity: 1,
          },
        ],
      }
    }
  });
  document.dispatchEvent(addItemToCart);
  document.dispatchEvent(new CustomEvent('cart:get'))
  fetchCart();
}
